import { ContainerVertical } from "components";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { Toggle } from "@duik/it";
import cls from "./detail.module.scss";
import classNames from "classnames";
import * as XLSX from "xlsx";
//const ExcelJS = require('exceljs');
import XlsxPopulate from "xlsx-populate";
import * as FileSaver from "file-saver";
import {
    DropdownButtonProps,
    DropdownMenuPosition,
    Button,
    Dropdown,
    TextField,
} from "@duik/it";
import Icon from "@duik/icon";
import { useRedux } from "@redux";
import * as appActions from "@redux/app/actions";
import _ from "lodash";

import { useIsOpenControls } from "hooks";
import { useDispatch } from "react-redux";
import {
    get as getCustomerProfileAction,
    create as createCustomerProfileAction,
    remove as removeCustomerProfileAction,
    update as updateCustomerProfileAction,
} from "@redux/customerProfile/actions";
import { ImplantType } from "@redux";
import * as TypesV1 from "@redux/customerProfile/typesV1";
import LinkOutlinedIcon from "@material-ui/icons/LinkOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddOutlinedIcon from "@material-ui/icons/AddCircleOutline";
import AddIcon from "@material-ui/icons/AddCircle";
import RemoveIcon from "@material-ui/icons/RemoveCircle";
import InfoIcon from "@material-ui/icons/Info";
import UpIcon from "@material-ui/icons/ExpandLess";
import DownIcon from "@material-ui/icons/ExpandMore";
import PublishIcon from "@material-ui/icons/GetApp";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import CloseIcon from "@material-ui/icons/Close";
import { getAll } from "@redux/customerProfile/actions";
import { ContainerHorizontal, ContentLoader } from "components";
import ProfileDelete from "./Modal/delete";
import ProfileDuplicate from "./Modal/duplicate";
import ProductsDelete from "./Modal/deleteProduct";
import ModalCopyLink from "./Modal/linkcopy";
import ModalAddCustomerSummary from "./Modal/addCustomerSummary";
import ModalAddEquipmentSummary from "./Modal/addEquipmentSummary";
import ModalAddSpecialtiesSummary from "./Modal/addSpecialtiesSummary";
import ModalAddImplantSummary from "./Modal/addImplantSummary";
import ModalUploadPL from "./Modal/uploadV1";
import ModalUploadPDFOnly from "./Modal/uploadPDFOnly";
import ModalUploadImplant from "./Modal/uploadImplantV1";
import Moment from "moment";
import Html from "react-pdf-html";
import {
    StyleSheet,
    Font,
    PDFDownloadLink,
    Document,
    Page,
    Text,
    View
} from "@react-pdf/renderer";
import futuraBook from "../../../../fonts/FuturaStd-Book.ttf";
import futuraBold from "../../../../fonts/FuturaStd-Bold.ttf";
import humstSlabRoman from "../../../../fonts/HumanistSlabserif712BT-Roman.ttf";
import humstSlabBlack from "../../../../fonts/HumanistSlabserif712BT-Black.ttf";
import ReactDOMServer from "react-dom/server";
import { parse } from "path";



// Register font
Font.register({
    family: "Stryker",
    fonts: [
        { format: "truetype", src: humstSlabRoman, fontWeight: 300 },
        { format: "truetype", src: humstSlabBlack, fontWeight: 500 },
        { format: "truetype", src: futuraBook, fontWeight: 700 },
        { format: "truetype", src: futuraBold, fontWeight: 900 },
    ],
});

export const CustomerDetail = ({ match, history, location }) => {
    const isManual = location?.state?.isManual ? true : false;
    const page = location?.state?.page ? location.state.page : 0;
    const modalDeleteControls = useIsOpenControls();
    const modalDuplicateControls = useIsOpenControls();
    const modalCopyLinkControls = useIsOpenControls();
    const modalAddCustomerSummaryControls = useIsOpenControls();
    const modalAddEquipmentSummaryControls = useIsOpenControls();
    const modalAddImplantSummaryControls = useIsOpenControls();
    const modalAddspecialtiesSummaryControls = useIsOpenControls();
    const modalExportControls = useIsOpenControls();
    const modalExportPDFOnlyControls = useIsOpenControls();
    const modalExportPDFOnlySpecialtiesControls = useIsOpenControls();

    const modalExportImplantControls = useIsOpenControls();
    const moddalExportPDFPLControls = useIsOpenControls();
    const modalDeleteProductControls = useIsOpenControls();

    const implantsInitialValues: ImplantType[] = [
        {
            title: "Lower clinical preference",
            implants: [
                {
                    subtitle: "Orthopaedic Disposables",
                    imageUrl: "L1-OrthopedicDisposables-1.png",
                    implantProducts: [
                        {
                            productName: "Tourniquet cuffs",
                            isInQuote: false,
                        },
                        {
                            productName: "Cement mixers",
                            isInQuote: false,
                        },
                        {
                            productName: "Pulsed lavage",
                            isInQuote: false,
                        },
                        {
                            productName: "Zip skin closure",
                            isInQuote: false,
                        },
                        {
                            productName: "Power tools blades and burs",
                            isInQuote: false,
                        },
                        {
                            productName: "Pumps, shavers, RF",
                            isInQuote: false,
                        },
                        {
                            productName: "Sutures",
                            isInQuote: false,
                        },
                    ],
                },
                {
                    subtitle: "Waste Management",
                    imageUrl: "L1-WasteManagement-2.png",
                    implantProducts: [
                        {
                            productName: "Manifolds",
                            isInQuote: false,
                        },
                        {
                            productName: "Smoke evacuation pencils/filters",
                            isInQuote: false,
                        },
                        {
                            productName: "Pharma waste cartridges",
                            isInQuote: false,
                        },
                        {
                            productName: "Floor fluid mats",
                            isInQuote: false,
                        },
                    ],
                },
                {
                    subtitle: "Cleaners and Disinfectants",
                    imageUrl: "L1-CleanersAndDisinfectants-1.png",
                    implantProducts: [
                        {
                            productName: "Pretreatment foam",
                            isInQuote: false,
                        },
                        {
                            productName: "Instrument detergent",
                            isInQuote: false,
                        },
                        {
                            productName: "Disinfecting wipes (furniture/surfaces)",
                            isInQuote: false,
                        },
                    ],
                },
                {
                    subtitle: "Infection Prevention",
                    imageUrl: "infectionPrevention.png",
                    implantProducts: [
                        {
                            productName: "Pre-Op prepping system (nasal/oral/skin prep)",
                            isInQuote: false,
                        },
                    ],
                },
                {
                    subtitle: "Injury Prevention",
                    imageUrl: "L1-InjuryPrevention-1.png",
                    implantProducts: [
                        {
                            productName: "Lateral transfer mats",
                            isInQuote: false,
                        },
                    ],
                },
                {
                    subtitle: "Airway Management",
                    imageUrl: "proceduralOxygenMask.png",
                    implantProducts: [
                        {
                            productName: "Procedural Oxygen Mask",
                            isInQuote: false,
                        },
                    ],
                },
            ],
        },
        {
            title: "Moderate clinical preference",
            implants: [
                {
                    subtitle: "Orthopaedic Disposables",
                    imageUrl: "L2-OrthopedicDisposables-3.png",
                    implantProducts: [
                        {
                            productName: "Surgical hoods/togas/PPE",
                            isInQuote: false,
                        },
                    ],
                },
            ],
        },
        {
            title: "Higher clinical preference",
            implants: [
                {
                    subtitle: "Sports Medicine",
                    imageUrl: "L2-SportsMedicine-2.png",
                    implantProducts: [
                        {
                            productName: "Hip",
                            isInQuote: false,
                        },
                        {
                            productName: "Knee",
                            isInQuote: false,
                        },
                        {
                            productName: "Shoulder",
                            isInQuote: false,
                        },
                        {
                            productName: "Foot & Ankle",
                            isInQuote: false,
                        },
                    ],
                },
                {
                    subtitle: "Joint Replacement",
                    imageUrl: "L3-JointReplacement-1.png",
                    implantProducts: [
                        {
                            productName: "Total hip",
                            isInQuote: false,
                        },
                        {
                            productName: "Total knee",
                            isInQuote: false,
                        },
                        {
                            productName: "Partial knee",
                            isInQuote: false,
                        },
                        {
                            productName: "Shoulder",
                            isInQuote: false,
                        },
                    ],
                },
                {
                    subtitle: "Additional specialties",
                    imageUrl: "L3-Specialties-1.png",
                    implantProducts: [
                        {
                            productName: "Spine",
                            isInQuote: false,
                        },
                        {
                            productName: "Foot & Ankle",
                            isInQuote: false,
                        },
                        {
                            productName: "Hand & Wrist",
                            isInQuote: false,
                        },
                        {
                            productName: "Pain Management/RF ablation",
                            isInQuote: false,
                        },
                        {
                            productName: "ENT",
                            isInQuote: false,
                        },
                        {
                            productName: "General Surgery",
                            isInQuote: false,
                        },
                        {
                            productName: "Biologics",
                            isInQuote: false,
                        },
                    ],
                },
            ],
        },
    ];

    const user = useRedux("auth");
    const customerProfile = useRedux("customerProfile");

    const customerProfiledata = customerProfile.data.find(
        (profile) => profile.id === parseInt(match.params.id)
    );
    const encryptpwd = require("encrypt-with-password");
    const password = "examplepassword2";
    const encrypted = encryptpwd.encryptJSON(
        customerProfiledata.id.toString(),
        password
    );
    const dispatch = useDispatch();

    React.useEffect(() => {
        // if (data.length == 0) {
        dispatch(getAll());
        // }
    }, []);

    React.useEffect(() => {
        setCustomerProfiledataTemp(
            customerProfiledata.config.implants
                ? {
                    ...customerProfiledata,
                }
                : {
                    ...customerProfiledata,
                    config: {
                        ...customerProfiledata.config,
                        implants: [...implantsInitialValues],
                    },
                }
        );
    }, [customerProfiledata]);
    const [customerProfiledataTemp, setCustomerProfiledataTemp] = useState(
        customerProfiledata.config.implants
            ? {
                ...customerProfiledata,
            }
            : {
                ...customerProfiledata,
                config: {
                    ...customerProfiledata.config,
                    implants: [...implantsInitialValues],
                },
            }
    );

    const [removeProduct, setRemoveProduct] = useState([]);
    const [newName, setnewName] = useState(
        `${customerProfiledataTemp.config.account_name} copy`
    );
    const [tabIndex, settabIndex] = useState(page ?? 0);
    const [isEdit, setisEdit] = useState(isManual ? true : false);
    let initCollapsed = [];
    for (let i = 0; i < 28; i++) {
        initCollapsed[i] = false;
    }
    const [isCollapsed, setIsCollapsed] = React.useState([...initCollapsed]);

    const { config } = customerProfiledataTemp;
    console.log({ config });

    const totalORRooms =
        config.asc === "De Novo / New Build ASC" || config.asc === "New Build"
            ? parseInt(config.facility_new[0].value) || 0
            : config.asc === "Existing ASC"
                ? parseInt(config.facility_existing[0].value) || 0
                : config.asc === "Expansion / Construction of Existing ASC" || config.asc === "Existing"
                    ? parseInt(config.facility_expanding[1].value) || 0
                    : 0;
    const totalPostOPRooms =
        config.asc === "De Novo / New Build ASC" || config.asc === "New Build"
            ? (parseInt(config.facility_new[2].value) || 0) +
            (parseInt(config.facility_new[3].value) || 0)
            : config.asc === "Existing ASC"
                ? parseInt(config.facility_existing[4].value) || 0
                : config.asc === "Expansion / Construction of Existing ASC" || config.asc === "Existing"
                    ? parseInt(config.facility_expanding[7].value) || 0
                    : 0;

    const totalLobbyRooms =
        config.asc === "De Novo / New Build ASC" || config.asc === "New Build"
            ? parseInt(config.facility_new[4].value) || 0
            : config.asc === "Expansion / Construction of Existing ASC"
                ? parseInt(config.facility_expanding[9].value) || 0
                : 0;

    const totalOvernightRooms =
        config.asc === "De Novo / New Build ASC" || config.asc === "New Build"
            ? parseInt(config.facility_new[6].value) || 0
            : config.asc === "Expansion / Construction of Existing ASC"
                ? parseInt(config.facility_expanding[12].value) || 0
                : 0;

    /*     let produtList = [
            ...(config.communication1.value > 0 ? config["standardORs"] : []),
            ...(config.communication1.value > 0 ? config["standardORsAddons"] : []),
            ...(config.communication3.value > 0 ? config["isuitORs"] : []),
            ...(config.communication3.value > 0 ? config["isuitORsAddons"] : []),
            ...(config.jpsub2 === "Yes" ? config["makoSmartRobotics"] : []),
            ...(totalORRooms > 0
                ? config["wasteManagements"].filter((item) => item.qty > 0)
                : []),
            ...(config["wasteManagementAddons"] ? config["wasteManagementAddons"].filter((item) => item.qty > 0) : []),
            ...(totalORRooms > 0
                ? config["wasteManagementsSwap"].filter((item) => item.qty > 0)
                : []),
            ...(totalORRooms > 0 ? config["saftySpongeSystem"] : []),
            ...(config['saftySpongeSystemAddons']),
            ...config['safeAir'],
            ...config['vocera'],
            ...config['footAndAnkle'],
            ...(config.acutecare1.value > 0 ||
                config.acutecare2.value > 0 ||
                config.acutecare3.value > 0
                ? config["generalStretchers"]
                : []),
            ...(config.acutecare1.value > 0 ||
                config.acutecare2.value > 0 ||
                config.acutecare3.value > 0
                ? config["generalStretchersAddons"]
                : []),
            config["patienWarning"],
            config["transportChairs"],
            config["surgeonStools"],
            ...(totalPostOPRooms > 0 ? config["patientBayFurniture"] : []),
            ...(totalOvernightRooms > 0 ? config["overnightBayRoomFurniture"] : []),
            ...(totalLobbyRooms > 0 ? config["lobbyRoomFurniture"] : []),
            ...(config.sp1 === "Imaging only" ||
                (config.sp1 === "Imaging with navigation" && config.sp2 === "3D navigation")
                ? config["spineNavigations"]
                : []),
            ...(config.specialties[3].value > 0 ? config["spineInstrumentation"] : []),
            ...config["crashcartsDefibrillators"],
            ...(config.emergencyPreparedness[0].qty > 0 ||
                config.emergencyPreparedness[1].qty > 0 ||
                config.emergencyPreparedness[2].qty > 0 ||
                (config.emergencyPreparedness.length > 3 && config.emergencyPreparedness[3].qty > 0)
                ? config["emergencyPreparedness"]
                : []),
            ...(config.specialties[1].value > 0 ||
                config.specialties[4].value > 0 ||
                config.specialties[5].value > 0 ||
                config.specialties[0].value > 0 ||
                config.specialties[3].value > 0
                ? config["powerTools"]
                : []),
            ...(totalORRooms > 0 ? config["tourniquet"] : []),
            ...config["surgicalHelmets"],
            ...config["sportMedicine"],
            ...(config.specialties[0].value ? config["sportInstrumentation"] : []),
            ...(config.specialties[0].value > 0 ? config["sportAccessories"] : []),
            ...(config.specialties[0].value > 0
                ? config["sportsKneeInstrumentation"]
                : []),
            ...(config.specialties[0].value > 0
                ? config["sportsHipInstrumentation"]
                : []),
            ...(config.specialties[0].value > 0
                ? config["sportMedicineHipArthroscopy"]
                : []),
            ...(config.specialties[0].value > 0
                ? config["sportMedicineFootAnkle"]
                : []),
            ...(config.entNav === "Yes" ? config["entNavigation"] : []),
            ...(config.entNav === "Yes" || config.specialties[8].value > 0
                ? config["entDrills"]
                : []),
            ...(config.specialties[6].value > 0 ? config["painManagement"] : []),
            ...((config.specialties[0].value > 0 ||
                config.specialties[8].value > 0 ||
                config.specialties[10].value > 0 ||
                config.specialties[11].value > 0) &&
                (config.facility_all_option[1].value === "Low temp" ||
                    config.facility_all_option[1].value === "Both" ||
                    config.facility_all_option[1].value === "I don't know yet.")
                ? config["videoEndoscopy"].filter((item) => item.qty > 0)
                : []),
    
            ...((config.specialties[0].value > 0 ||
                config.specialties[8].value > 0 ||
                config.specialties[10].value > 0 ||
                config.specialties[11].value > 0) &&
                config.facility_all_option[1].value === "High Temp/autoclave only"
                ? config["videoEndcscopyautoclavable"]
                : []),
            ...config["scopesOption1"],
            ...config["scopesOption2"],
            ...[config["serviceContract"]],
    
            ...[config["onSiteServicesProgram"]],
    
        ];
     */
    /* i need this order */
    let allProductList = [
        ...(config.standardORs || []),
        ...(config.isuitORs || []),
        ...(config.makoSmartRobotics || []),
        ...(config.wasteManagements || []),
        ...(config.wasteManagementAddons || []),
        ...(config.saftySpongeSystem || []),
        ...(config.safeAir || []),
        ...(config.generalStretchers || []),
        ...(config.patienWarning ? [config.patienWarning] : []),
        ...(config.transportChairs ? [config.transportChairs] : []),
        ...(config.surgeonStools ? [config.surgeonStools] : []),
        ...(config.patientBayFurniture || []),
        ...(config.overnightBayRoomFurniture || []),
        ...(config.lobbyRoomFurniture || []),
        ...(config.spineNavigations || []),
        ...(config.spineInstrumentation || []),
        ...(config.crashcartsDefibrillators || []),
        ...(config.emergencyPreparedness || []),
        ...(config.vocera || []),
        ...(config.powerTools || []),
        ...(config.tourniquet || []),
        ...(config.surgicalHelmets || []),
        ...(config.sportMedicine || []),
        ...(config.sportInstrumentation || []),
        ...(config.sportAccessories || []),
        ...(config.sportsKneeInstrumentation || []),
        ...(config.sportsHipInstrumentation || []),
        ...(config.sportMedicineHipArthroscopy || []),
        ...(config.sportMedicineFootAnkle || []),
        ...(config.entNavigation || []),
        ...(config.entDrills || []),
        ...(config.painManagement || []),
        ...(config.footAndAnkle || []),
        ...(config.videoEndoscopy || []),
        ...(config.videoEndcscopyautoclavable || []),
        ...(config.scopesOption1 || []),
        ...(config.scopesOption2 || []),
        ...(config.serviceContract ? [config.serviceContract] : []),
        ...(config.onSiteServicesProgram ? [config.onSiteServicesProgram] : [])
    ];

    console.log('Version 1');

    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    const exportToExcelTemplate = async () => {

        const filePath = "/assets/Intake tool - Draft Excel Output.xlsx";

        const response = await fetch(filePath);

        const fileReader = new FileReader();
        fileReader.onload = (e) => {

            const bstr = e.target.result;
            console.log({ config });

            XlsxPopulate.fromDataAsync(bstr).then(async function (workbook) {

                let sheet1 = workbook.sheet(0);
                const range = sheet1.range('A1:B200');

                sheet1.cell("B1").value(config.account_name ? config.account_name : " ");
                sheet1.cell("B2").value(config.city ? config.city : " ");
                sheet1.cell("B3").value(config.state ? config.state : " ");
                sheet1.cell("B4").value(config.zip ? config.zip : " ");
                sheet1.cell("B5").value(config.streetAddress ? config.streetAddress : " ");
                //CUSTOMER BACKGROUND
                sheet1.cell("B7").value(config.initial_customer_meeting_date ? config.initial_customer_meeting_date : " ");
                sheet1.cell("B8").value(config.stryker_customer ? config.stryker_customer : " ");
                sheet1.cell("B9").value(config.asc_type ? config.asc_type : " ");
                sheet1.cell("B10").value(config.project_type ? config.project_type : " ");
                sheet1.cell("B11").value(config.hospital_type ? config.hospital_type : " ");
                sheet1.cell("B12").value("");
                sheet1.cell("B13").value(config.mako_included ? config.mako_included : " ");
                sheet1.cell("B14").value(config.strategic_partnership ? config.strategic_partnership : " ");
                sheet1.cell("B15").value(config.gpo_affiliation ? config.gpo_affiliation : " ");
                sheet1.cell("B16").value(config.competitive_landscape ? config.competitive_landscape : " ");
                sheet1.cell("B17").value(config.customer_contact ? config.customer_contact : " ");
                sheet1.cell("B18").value(config.one_a_contacts ? config.one_a_contacts : " ");
                sheet1.cell("B19").value(config.construction_architects_applications ? config.construction_architects_applications : " ");
                //FACILITY ONERSHIP
                sheet1.cell("B20").value("");
                sheet1.cell("B21").value(config.owner_ship[0].value ? `${config.owner_ship[0].value}%` : 0);
                sheet1.cell("B22").value(config.owner_ship[1].value ? `${config.owner_ship[1].value}% ${config.owner_ship_hospital ? ` - ${config.owner_ship_hospital}` : ''}` : 0);
                sheet1.cell("B23").value(config.owner_ship[2].value ? `${config.owner_ship[2].value}% ${config.owner_ship_company ? ` - ${config.owner_ship_company}` : ''}` : 0);
                sheet1.cell("B24").value(config.owner_ship[3].value ? `${config.owner_ship[3].value}%` : 0);
                sheet1.cell("B25").value(config.owner_ship[4].value ? `${config.owner_ship[4].value}%` : 0);
                let ownershipAddOns = config.owner_ship_addions.map((item) => `${item.label}:  ${item.value}%`);
                sheet1.cell("B26").value(ownershipAddOns.join(", "));

                let isNewBuild = config.asc === "De Novo / New Build ASC" || config.asc === "New Build" ? true : false;
                let isExisting = config.asc === "Expansion / Construction of Existing ASC" || config.asc === "Existing" ? true : false;

                //OPERATING ROOMS
                sheet1.cell("B27").value("");
                sheet1.cell("B28").value(isNewBuild && config.facility_new[0].value ? parseInt(config.facility_new[0].value) : 0);
                sheet1.cell("B29").value(isExisting && config.facility_expanding[0].value ? parseInt(config.facility_expanding[0].value) : 0);
                sheet1.cell("B30").value(isExisting && config.facility_expanding[1].value ? parseInt(config.facility_expanding[1].value) : 0);
                sheet1.cell("B31").value(isExisting && config.facility_expanding[2].value ? parseInt(config.facility_expanding[2].value) : 0);
                //PROCEDURE ROOMS
                sheet1.cell("B32").value("");
                sheet1.cell("B33").value(isNewBuild && config.facility_new[1].value ? parseInt(config.facility_new[1].value) : 0);
                sheet1.cell("B34").value(isExisting && config.facility_expanding[3].value ? parseInt(config.facility_expanding[3].value) : 0);
                sheet1.cell("B35").value(isExisting && config.facility_expanding[4].value ? parseInt(config.facility_expanding[4].value) : 0);
                //PATIENT BAYS
                sheet1.cell("B36").value("");
                sheet1.cell("B37").value(isNewBuild && config.facility_new[2].value ? parseInt(config.facility_new[2].value) : 0);
                sheet1.cell("B38").value(isNewBuild && config.facility_new[3].value ? parseInt(config.facility_new[3].value) : 0);
                sheet1.cell("B39").value(isExisting && config.facility_expanding[5].value ? parseInt(config.facility_expanding[5].value) : 0);
                sheet1.cell("B40").value(isExisting && config.facility_expanding[6].value ? parseInt(config.facility_expanding[6].value) : 0);
                sheet1.cell("B41").value(isExisting && config.facility_expanding[7].value ? parseInt(config.facility_expanding[7].value) : 0);
                //LOBBY / WAITING ROOMS
                sheet1.cell("B42").value("");
                sheet1.cell("B43").value(isNewBuild && config.facility_new[4].value ? parseInt(config.facility_new[4].value) : 0);
                sheet1.cell("B44").value(isExisting && config.facility_expanding[8].value ? parseInt(config.facility_expanding[8].value) : 0);
                sheet1.cell("B45").value(isExisting && config.facility_expanding[9].value ? parseInt(config.facility_expanding[9].value) : 0);
                //OVERNIGHT STAYS (23 HOURS)
                sheet1.cell("B46").value("");
                sheet1.cell("B47").value(isNewBuild && config.facility_new[5].value ? config.facility_new[5].value : 0);
                sheet1.cell("B48").value(isNewBuild && config.facility_new[6].value ? parseInt(config.facility_new[6].value) : 0);
                sheet1.cell("B49").value(isExisting && config.facility_expanding[10].value ? config.facility_expanding[10].value : '');
                sheet1.cell("B50").value(isExisting && config.facility_expanding[11].value ? parseInt(config.facility_expanding[11].value) : 0);
                sheet1.cell("B51").value(isExisting && config.facility_expanding[12].value ? parseInt(config.facility_expanding[12].value) : 0);

                //STERILIZATION
                sheet1.cell("B52").value("");
                sheet1.cell("B53").value(config.facility_all_option[0].value ? config.facility_all_option[0].value : " ");
                sheet1.cell("B54").value(config.facility_all_option[1].value ? config.facility_all_option[1].value : " ");
                sheet1.cell("B55").value(config.facility_note ? config.facility_note : " ");

                //SPECIALTIES
                //SPORTS MEDICINE
                sheet1.cell("B56").value("");
                sheet1.cell("B57").value("");
                sheet1.cell("B58").value(config.specialties[0].value ? config.specialties[0].value : 0);
                sheet1.cell("B59").value(config.smsub.smdrop[1] ? parseInt(config.smsub.smdrop[1]) : 0);
                let hipPercentage = config.smsub.smary[0].value ? config.smsub.smary[0].value : 0;
                let kneePercentage = config.smsub.smary[1].value ? config.smsub.smary[1].value : 0;
                let shoulderPercentage = config.smsub.smary[2].value ? config.smsub.smary[2].value : 0;
                let footAnklePercentage = config.smsub.smary[3].value ? config.smsub.smary[3].value : 0;
                let otherPercentage = config.smsub.smary[4].value ? config.smsub.smary[4].value : 0;
                let concatPercentage = `Hip - ${hipPercentage}%, Knee - ${kneePercentage}%, Shoulder - ${shoulderPercentage}%, Foot & Ankle - ${footAnklePercentage}%, Other - ${otherPercentage}%`;
                sheet1.cell("B60").value(concatPercentage);


                //JOINT REPLACEMENT
                sheet1.cell("B61").value("");
                sheet1.cell("B62").value(config.specialties[1].value ? config.specialties[1].value : 0);
                sheet1.cell("B63").value(config.specialties[1].estimatedPerMonth ? config.specialties[1].estimatedPerMonth : 0);
                sheet1.cell("B64").value(config.jpsub1 ? parseInt(config.jpsub1) : " ");
                sheet1.cell("B65").value("");

                sheet1.cell("B66").value(`${config.jpsub[0].value ? config.jpsub[0].label : ''}${config.jpsub[0].value ? ', ' : ''} ${config.jpsub[1].value ? config.jpsub[1].label : ''}`);

                //JR (Shoulder)
                sheet1.cell("B67").value("");
                sheet1.cell("B68").value(config.specialties[2].value ? config.specialties[2].value : 0);
                sheet1.cell("B69").value(config.specialties[2].estimatedPerMonth ? config.specialties[2].estimatedPerMonth : 0);

                //SPINE
                sheet1.cell("B70").value("");
                sheet1.cell("B71").value(config.specialties[3].value ? config.specialties[3].value : 0);
                sheet1.cell("B72").value(config.specialties[3].estimatedPerMonth ? config.specialties[3].estimatedPerMonth : 0);
                sheet1.cell("B73").value(config.sp1 ? config.sp1 : " ");

                //FOOT AND ANKLE
                sheet1.cell("B74").value("");
                sheet1.cell("B75").value(config.specialties[4].value ? config.specialties[4].value : 0);
                sheet1.cell("B76").value(config.specialties[4].estimatedPerMonth ? config.specialties[4].estimatedPerMonth : 0);

                //HAND & WRIST
                sheet1.cell("B77").value("");
                sheet1.cell("B78").value(config.specialties[5].value ? config.specialties[5].value : 0);
                sheet1.cell("B79").value(config.specialties[5].estimatedPerMonth ? config.specialties[5].estimatedPerMonth : 0);

                //PAIN MANAGEMENT/RF Ablation
                sheet1.cell("B80").value("");
                sheet1.cell("B81").value(config.specialties[6].value ? config.specialties[6].value : 0);
                sheet1.cell("B82").value(config.specialties[6].estimatedPerMonth ? config.specialties[6].estimatedPerMonth : 0);

                //ENT
                sheet1.cell("B83").value("");
                sheet1.cell("B84").value(config.specialties[8].value ? config.specialties[8].value : 0);
                sheet1.cell("B85").value(config.specialties[8].estimatedPerMonth ? config.specialties[8].estimatedPerMonth : 0);
                sheet1.cell("B86").value(config.entNav ? config.entNav : " ");

                //GENERAL SURGERY
                sheet1.cell("B87").value("");
                sheet1.cell("B88").value(config.specialties[10].value ? config.specialties[10].value : 0);
                sheet1.cell("B89").value(config.specialties[10].estimatedPerMonth ? config.specialties[10].estimatedPerMonth : 0);


                let sheet2 = workbook.sheet(1);
                const range2 = sheet2.range('A1:B200');


                allProductList.map((product, i) => {
                    sheet2.cell(`A${i + 2}`).value(product.partNumber ? product.partNumber : " ");
                    sheet2.cell(`B${i + 2}`).value(product.bu ? product.bu : '');
                    sheet2.cell(`C${i + 2}`).value(product.category ? product.category : '');
                    sheet2.cell(`D${i + 2}`).value(product.product ? product.product : '');
                    sheet2.cell(`E${i + 2}`).value(product.qty ? product.qty : 0);
                });



                let sheet3 = workbook.sheet(2);
                const range3 = sheet3.range('A1:B200');



                //Orthopaedic Disposables
                sheet3.cell("B2").value(config.implants[0].implants[0].implantProducts[0].isInQuote ? "Yes" : "No");
                sheet3.cell("B3").value(config.implants[0].implants[0].implantProducts[1].isInQuote ? "Yes" : "No");
                sheet3.cell("B4").value(config.implants[0].implants[0].implantProducts[2].isInQuote ? "Yes" : "No");
                sheet3.cell("B5").value(config.implants[0].implants[0].implantProducts[3].isInQuote ? "Yes" : "No");
                sheet3.cell("B6").value(config.implants[0].implants[0].implantProducts[4].isInQuote ? "Yes" : "No");
                sheet3.cell("B7").value(config.implants[0].implants[0].implantProducts[5].isInQuote ? "Yes" : "No");
                sheet3.cell("B8").value(config.implants[0].implants[0].implantProducts[6].isInQuote ? "Yes" : "No");

                //Waste Management
                sheet3.cell("B9").value(config.implants[0].implants[1].implantProducts[0].isInQuote ? "Yes" : "No");
                sheet3.cell("B10").value(config.implants[0].implants[1].implantProducts[1].isInQuote ? "Yes" : "No");
                sheet3.cell("B11").value(config.implants[0].implants[1].implantProducts[2].isInQuote ? "Yes" : "No");
                sheet3.cell("B12").value(config.implants[0].implants[1].implantProducts[3].isInQuote ? "Yes" : "No");

                //Cleaners and Disinfectants
                sheet3.cell("B13").value(config.implants[0].implants[2].implantProducts[0].isInQuote ? "Yes" : "No");
                sheet3.cell("B14").value(config.implants[0].implants[2].implantProducts[1].isInQuote ? "Yes" : "No");
                sheet3.cell("B15").value(config.implants[0].implants[2].implantProducts[2].isInQuote ? "Yes" : "No");

                //Infection Prevention
                sheet3.cell("B16").value(config.implants[0].implants[3].implantProducts[0].isInQuote ? "Yes" : "No");

                //Injury Prevention
                sheet3.cell("B17").value(config.implants[0].implants[4].implantProducts[0].isInQuote ? "Yes" : "No");

                /* Airway Management */
                sheet3.cell("B18").value(config.implants[0].implants[5].implantProducts[0].isInQuote ? "Yes" : "No");

                //Moderate clinical preference
                //Orthopaedic Disposables
                sheet3.cell("B19").value(config.implants[1].implants[0].implantProducts[0].isInQuote ? "Yes" : "No");

                //Higher clinical preference
                //Sports Medicine
                sheet3.cell("B20").value(config.implants[2].implants[0].implantProducts[0].isInQuote ? "Yes" : "No");
                sheet3.cell("B21").value(config.implants[2].implants[0].implantProducts[1].isInQuote ? "Yes" : "No");
                sheet3.cell("B22").value(config.implants[2].implants[0].implantProducts[2].isInQuote ? "Yes" : "No");
                sheet3.cell("B23").value(config.implants[2].implants[0].implantProducts[3].isInQuote ? "Yes" : "No");

                //Joint Replacement
                sheet3.cell("B24").value(config.implants[2].implants[1].implantProducts[0].isInQuote ? "Yes" : "No");
                sheet3.cell("B25").value(config.implants[2].implants[1].implantProducts[1].isInQuote ? "Yes" : "No");
                sheet3.cell("B26").value(config.implants[2].implants[1].implantProducts[2].isInQuote ? "Yes" : "No");
                sheet3.cell("B27").value(config.implants[2].implants[1].implantProducts[3].isInQuote ? "Yes" : "No");

                //Additional specialties
                sheet3.cell("B28").value(config.implants[2].implants[2].implantProducts[0].isInQuote ? "Yes" : "No");
                sheet3.cell("B29").value(config.implants[2].implants[2].implantProducts[1].isInQuote ? "Yes" : "No");
                sheet3.cell("B30").value(config.implants[2].implants[2].implantProducts[2].isInQuote ? "Yes" : "No");
                sheet3.cell("B31").value(config.implants[2].implants[2].implantProducts[3].isInQuote ? "Yes" : "No");
                sheet3.cell("B32").value(config.implants[2].implants[2].implantProducts[4].isInQuote ? "Yes" : "No");
                sheet3.cell("B33").value(config.implants[2].implants[2].implantProducts[5].isInQuote ? "Yes" : "No");
                sheet3.cell("B34").value(config.implants[2].implants[2].implantProducts[6].isInQuote ? "Yes" : "No");


                let sheet4 = workbook.sheet(3);
                const range4 = sheet2.range('A1:C200');

                sheet4.cell("C5").value(config.account_name ? config.account_name : " ");
                let isASC = config.asc_type !== "N/A" ? true : false;
                let isHospital = config.hospital_type !== "N/A" ? true : false;
                let isBoth = isASC && isHospital ? true : false;
                let c6value = isBoth ? "Both" : isASC ? "ASC" : isHospital ? "Hospital" : "N/A";
                sheet4.cell("C6").value(c6value);
                sheet4.cell("C7").value(config.owner_ship_company ? config.owner_ship_company : " ");
                //current format is 2024-11-20
                //i need to change it to 11/20/2024
                let date = config.initial_customer_meeting_date ? config.initial_customer_meeting_date : " ";
                let dateArray = date.split("-");
                let formattedDate = `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`;
                sheet4.cell("C9").value(formattedDate);
                sheet4.cell("C10").value(config.project_type ? config.project_type : " ");
                sheet4.cell("C11").value(config.asc_type == 'ASC (new build)' ? "Yes" : "No");
                sheet4.cell("C12").value(config.has_slated_opening_date.toLowerCase() == "yes" && config.date_opend ? config.date_opend : '');

                const data = await workbook.outputAsync("blob");

                const fileName = `Stryker product list.xlsx`;
                FileSaver.saveAs(data, fileName);

            });

        };

        let blob = await response.blob();
        fileReader.readAsArrayBuffer(blob);
    };

    const exportToCSV = () => {
        let csvData: any = [...allProductList];
        console.table(csvData);
        csvData = csvData.map((data) => {
            return {
                PartNumber: data.partNumber,
                BU: data.bu,
                Product: data.product,
                Category: data.category,
                "Product Quantity": data.qty,
            };
        });

        const fileName = `Stryker product list_${mm}_${dd}_${yyyy}`;
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    const onClickExport = (format) => {
        //@ts-ignore
        window.gtag("event", "download_products", {
            event_label: `Download in ${format} format`,
        });
        if (format === "CSV") {
            exportToCSV();
        } else if (format === "PDF") {
            exportPDFPL();
        }
    };

    const exportImplantToCSV = () => {
        let csvData: any[] = [];
        customerProfiledataTemp.config.implants.map((implantGroup, i) => {
            implantGroup.implants.map((implant, j) => {
                let tmpProduct = implant.implantProducts.map((product, k) => {
                    return {
                        PRODUCT: product.productName,
                        "INCLUDE IN QUOTE": product.isInQuote ? "Yes" : "No",
                    };
                });
                csvData = [...csvData, ...tmpProduct];
            });
        });

        const fileName = `Stryker implants and disposables list_${mm}_${dd}_${yyyy}`;
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    const onClickExportImplant = (format) => {
        //@ts-ignore
        window.gtag("event", "download_implant", {
            event_label: `Download in ${format} format`,
        });
        if (format === "CSV") {
            exportImplantToCSV();
        } else if (format === "PDF") {
            exportPDFImplant();
        }
    };

    let pdfExportComponent;
    let pdfExportPL;
    let pdfExportImplant;

    const fileName = `Stryker customer profile_${mm}_${dd}_${yyyy}.pdf`;
    const fileSpecialties = `Stryker customer profile specialties_${mm}_${dd}_${yyyy}.pdf`;
    const exportPDFWithComponent = () => {
        //@ts-ignore
        window.gtag("event", "download_customer_profile", {
            event_label: `Download in PDF format`,
        });
        pdfExportComponent.save();
    };

    const pdfFileNamePL = `Stryker product list_${mm}_${dd}_${yyyy}.pdf`;
    const exportPDFPL = () => {
        pdfExportPL.save();
    };
    const pdfFileNameImplant = `Stryker implants and disposables list_${mm}_${dd}_${yyyy}.pdf`;
    const exportPDFImplant = () => {
        pdfExportImplant.save();
    };
    function checkNullArray(ary: TypesV1.ProductItemprops[]): boolean {
        for (let index = 0; index < ary.length; index++) {
            const element = ary[index];
            if (element && element.qty > 0) {
                return true;
            }
        }
        return false;
    }
    function checkEmptyArray(ary: TypesV1.ProductItemprops[]): boolean {
        for (let index = 0; index < ary.length; index++) {
            const element = ary[index];
            if (!element.isRemoved) {
                return true;
            }
        }
        return false;
    }
    function checkVisiblity(
        specialityCheck: boolean,
        ary: TypesV1.ProductItemprops[]
    ): boolean {
        return specialityCheck && (isEdit || (!isEdit && checkNullArray(ary)));
    }
    function checkVisiblityOne(
        specialityCheck: boolean,
        val: TypesV1.ProductItemprops
    ): boolean {
        return specialityCheck && (isEdit || (!isEdit && val && val.qty > 0));
    }
    function calNumRemoveProduct() {
        let result = 0;
        for (let i = 0; i < removeProduct.length; i++) {
            const element = removeProduct[i];
            if (config[element].qty) {
                if (config[element].qty > 0) {
                    result += 1;
                }
            } else {
                for (let j = 0; j < config[element].length; j++) {
                    const e = config[element][j];
                    if (e.qty > 0) {
                        result += 1;
                    }
                }
            }
        }
        return result;
    }
    const onChangeText = (value, index, str) => {
        if (parseInt(value) === 0) {
            customerProfiledataTemp.config[str][index].qty = 0;
        } else {
            customerProfiledataTemp.config[str][index].qty = parseInt(value)
                ? parseInt(value)
                : "";
        }

        setCustomerProfiledataTemp({ ...customerProfiledataTemp });
    };

    const dropdownComponent = ({ handleToggle }: DropdownButtonProps) => (
        <Button
            className="dropdown-button"
            onClick={handleToggle}
            square
            style={{ borderRadius: 5 }}
        >
            <Icon className="dropdown-button-icon">more</Icon>
        </Button>
    );

    const handleChange = (e) => {
        setnewName(e.target.value);
    };
    const onClickDup = () => {
        dispatch(
            createCustomerProfileAction({
                config: { ...config, account_name: newName },
            })
        );
        history.push("/app/customer-profiles/list");
    };

    const onClickDelete = () => {
        dispatch(removeCustomerProfileAction(customerProfiledataTemp.id));
        history.push("/app/customer-profiles/list");
    };
    const onClickDeleteProduct = () => {
        for (let index = 0; index < removeProduct.length; index++) {
            const element = removeProduct[index];
            if (config[element].qty && config[element].qty > 0) {
                config[element].qty = 0;
            } else {
                for (let j = 0; j < config[element].length; j++) {
                    config[element][j].qty = 0;
                }
            }
        }
        setCustomerProfiledataTemp({
            ...customerProfiledataTemp,
            config: { ...config },
        });
        modalDeleteProductControls.handleClose();
    };

    /**
     *
     * @param products {array} product list needs to be managed(add, subtract)
     * @param action {boolean} true if adding, false if subtracting
     */
    const onClickManageProduct = (products = [], action: boolean = true) => {
        for (let index = 0; index < products.length; index++) {
            const element = products[index];
            if (config[element].qty || config[element].qty === 0) {
                if (!action && config[element].qty != 0) {
                    config[element].qty--;
                } else if (action) {
                    config[element].qty++;
                }
            } else if (config[element].qty === null) {
                config[element].qty = action ? 1 : 0;
            } else {
                for (let j = 0; j < config[element].length; j++) {
                    if (!action && config[element][j].qty > 0) {
                        config[element][j].qty--;
                    } else if (action) {
                        if (config[element][j].qty >= 0) {
                            config[element][j].qty++;
                        } else {
                            config[element][j].qty = 1;
                        }
                    }
                }
            }
        }
        setCustomerProfiledataTemp({
            ...customerProfiledataTemp,
            config: { ...config },
        });
    };

    const ProductEditBar = (props) => {
        const [isInfoOpen, setIsInfoOpen] = React.useState(false);
        const { products, editInfo } = props;
        return (
            <ContainerVertical>
                <ContainerHorizontal className={cls.editContainer}>
                    <ContainerHorizontal className={cls.editBox}>
                        <span className={cls.editLabel}>ADJUST ALL PRODUCTS</span>
                        <Button
                            clear
                            className={cls.btnPlus}
                            onClick={() => {
                                onClickManageProduct(products, true);
                            }}
                        >
                            <AddIcon />
                        </Button>
                        <Button
                            clear
                            className={cls.btnMinus}
                            onClick={() => {
                                onClickManageProduct(products, false);
                            }}
                        >
                            <RemoveIcon />
                        </Button>
                        <p className={cls.verticalLine}>|</p>
                        <Button
                            className={cls.removeAll}
                            onClick={() => {
                                setRemoveProduct([...products]);
                                modalDeleteProductControls.handleOpen();
                            }}
                        >
                            REMOVE ALL
                        </Button>
                    </ContainerHorizontal>
                    <ContainerHorizontal
                        className={`${cls.infoSection} ${editInfo.length > 0 ? cls.show : cls.hide
                            }`}
                    >
                        <InfoIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setIsInfoOpen(!isInfoOpen);
                            }}
                        />
                    </ContainerHorizontal>
                </ContainerHorizontal>

                <ContainerHorizontal
                    className={`${cls.infoContent} ${isInfoOpen && editInfo.length > 0 ? cls.show : cls.hide
                        }`}
                >
                    <span>
                        {editInfo}
                        <span className={cls.arrow}></span>
                    </span>
                </ContainerHorizontal>
            </ContainerVertical>
        );
    };

    const EquipmentSummaryItem = (props) => {
        const { products, title } = props;
        let sortedProducts = JSON.parse(JSON.stringify(products)).sort((a, b) => {
            let labelA = a.summaryLabel || '';
            let labelB = b.summaryLabel || '';
            return labelA.localeCompare(labelB);
        });
        //has at least one product with qty > 0
        let hasProduct = sortedProducts.some((item) => item.qty && item.qty > 0);
        return (
            <ContainerVertical>
                {hasProduct && <div style={{ fontSize: "0.71rem", fontFamily: "HumstSlab712 Blk BT" }}>
                    {title}
                </div>}
                <div style={{ fontSize: "0.7rem", fontFamily: "HumstSlab712 Blk" }}>
                    {sortedProducts.map((item, index) =>
                        item.qty && item.qty > 0 && item.summaryLabel ? (
                            item.summaryLabel1 ? (
                                <>
                                    <div>{`(${item.qty}) ${item.summaryLabel}`}</div>
                                    <div>{`(${item.qty}) ${item.summaryLabel1}`}</div>
                                </>
                            ) : (
                                <div>{`(${item.qty}) ${item.summaryLabel}`}</div>
                            )
                        ) : null
                    )}
                </div>
            </ContainerVertical>
        );
    };

    const pdfStyle = {
        page: { fontSize: 10, fontFamily: "Stryker" },
        title: { fontSize: 24, fontWeight: 900 },
        subtitle: { fontSize: 12, fontWeight: 500, maxWidth: 158 },
        label: { fontSize: 10, fontWeight: 700, color: "#bbb" },
        titleUnderline: {
            fontSize: 12,
            fontWeight: 500,
            textDecoration: "underline",
        },
        tHeading: { fontWeight: 700, minWidth: 100, width: 100, color: "#bbb" },
        tHeadingSmall: { fontWeight: 700, width: 20, color: "#bbb" },
        tCell: { minWidth: 100, width: 100, paddingRight: 5 },
        tCellSmall: { width: 20 },
    };


    const EquipmentSummaryItemPDF = (props) => {
        const { products, title } = props;
        return (
            <div>
                <br />
                <div style={pdfStyle.subtitle}>{title}</div>
                <div>
                    {products.map((item, index) =>
                        item.qty && item.summaryLabel ? (
                            item.summaryLabel1 ? (
                                <div>
                                    <div>{`(${item.qty}) ${item.summaryLabel}`}</div>
                                    <div>{`(${item.qty}) ${item.summaryLabel1}`}</div>
                                </div>
                            ) : (
                                <div>{`(${item.qty}) ${item.summaryLabel}`}</div>
                            )
                        ) : null
                    )}
                </div>
            </div>
        );
    };

    if (customerProfile.isLoading) {
        return <ContentLoader />;
    }

    const customerInfoElement = (
        <div style={pdfStyle.page}>
            <div style={pdfStyle.title}>Customer Information</div>
            <div style={pdfStyle.subtitle}>{config.account_name}</div>
            <br />
            {config.customerSummary && (
                <div>
                    <div style={pdfStyle.subtitle}>Notes</div>
                    <div>{config.customerSummary}</div>
                    <br />
                </div>
            )}
            <div style={pdfStyle.label}>ACCOUNT / PROJECT NAME</div>
            <div>{config.account_name}</div>
            <br />
            <div style={pdfStyle.label}>STREET ADDRESS</div>
            <div>{config.streetAddress}</div>
            <br />
            <div style={pdfStyle.label}>CITY</div>
            <div>{config.city}</div>
            <br />
            <div style={pdfStyle.label}>STATE/PROVINCE</div>
            <div>{config.state}</div>
            <br />
            <div style={pdfStyle.label}>ZIP CODE/POSTAL CODE</div>
            <div>{config.zip}</div>
            <br />


            <div style={pdfStyle.subtitle}>Customer Background</div>

            <div style={pdfStyle.label}>INITIAL CUSTOMER MEETING DATE</div>
            <div>{config.initial_customer_meeting_date}</div>
            <br />
            <div style={pdfStyle.label}>NEW OR EXISTING STRYKER CUSTOMER?</div>
            <div>{config.stryker_customer}</div>
            <br />
            <div style={pdfStyle.label}>ASC TYPE</div>
            <div>{config.asc_type}</div>
            <br />
            <div style={pdfStyle.label}>PROJECT TYPE (NT)</div>
            <div>{config.project_type}</div>
            <br />
            <div style={pdfStyle.label}>HOSPITAL TYPE</div>
            <div>{config.hospital_type}</div>
            <br />
            {/* <div style={pdfStyle.label}>NEW BUILD OR EXISTING?</div>
            <div>{`NEED TO LOOK INTO IT`}</div>
            <br /> */}
            <div style={pdfStyle.label}>IS THERE A MAKO INCLUDED?</div>
            <div >{config.mako_included}</div>
            <br />
            <div style={pdfStyle.label}>WHAT IS THE STRATEGIC PARTNERSHIP?</div>
            <div>{config.strategic_partnership}</div>
            <br />
            <div style={pdfStyle.label}>GPO AFFILIATION</div>
            <div >{config.gpo_affiliation}</div>
            <br />
            <div style={pdfStyle.label}>COMPETITIVE LANDSCAPE</div>
            <div>{config.competitive_landscape}</div>
            <br />
            <div style={pdfStyle.label}>CUSTOMER CONTACT</div>
            <div>{config.customer_contact}</div>
            <br />
            <div style={pdfStyle.label}>1A CONTACTS</div>
            <div>{config.one_a_contacts}</div>
            <br />
            <div style={pdfStyle.label}>WHERE ARE YOU AT WITH CONTRUCTION, HIRING ARCHITECTS, AND SUBMITTING APPLICATIONS?</div>
            <div>{config.construction_architects_applications}</div>
            <br />


            <div style={pdfStyle.subtitle}>Project Type</div>
            <br />

            <div style={pdfStyle.label}>
                {" "}
                WHAT BEST DEFINES YOUR CURRENT ASC PROJECTS{" "}
            </div>
            <div>{config.asc}</div>
            <br />

            {config.asc === "De Novo / New Build ASC" || config.asc === "New Build" && (
                <div>
                    <div style={pdfStyle.label}>
                        {" "}
                        WHAT BEST DEFINES YOUR CURRENT ASC PROJECTS{" "}
                    </div>
                    <div>{config.healthcare_partner}</div>
                    <br />
                </div>
            )}

            <div style={pdfStyle.label}>
                {" "}
                HAVE YOU PARTNERED WITH AN ASC MANAGEMENT COMPANY YET?

            </div>
            <div>{config.asc_management_partner}</div>
            <br />

            <div style={pdfStyle.label}>
                {" "}
                HAVE YOU HIRED AN ARCHITECT YET?

            </div>
            <div>{config.hired}</div>
            <br />


            <div style={pdfStyle.label}>
                {" "}
                HAVE YOU HIRED A MEDICAL EQUIPMENT PLANNER YET?

            </div>
            <div>{config.hired_medical_equipment_planner}</div>
            <br />

            <div style={pdfStyle.label}>
                {" "}
                HAVE YOU PERFORMED A FEASIBILITY STUDY?

            </div>
            <div>{config.performed_feasibility_study}</div>
            <br />


            <div style={pdfStyle.label}>
                {" "}
                DOES YOUR STATE HAVE CON LAWS?
            </div>
            <div>{config.has_con_laws}</div>
            <br />

            {config.has_con_laws.toLowerCase() == "yes" && (
                <div>
                    <div style={pdfStyle.label}>HAVE YOU SUBMITTED A CON APPLICATION?</div>
                    <div>{config.submitted_con_application}</div>
                    <br />
                </div>
            )}
            <div style={pdfStyle.label}>
                {" "}
                HAS CONSTRUCTION STARTED?
            </div>
            <div>{config.started}</div>
            <br />

            <div style={pdfStyle.label}>
                {" "}
                DO YOU HAVE A SLATED OPENING DATE?
            </div>
            <div>{config.has_slated_opening_date}</div>
            <br />



            {config.has_slated_opening_date.toLowerCase() == "yes" && (
                <div>
                    <div style={pdfStyle.label}>SLATED DATE OF OPENING?</div>
                    <div>{config.date_opend}</div>
                    <br />
                </div>
            )}

            {/*  <div style={pdfStyle.label}>
                {" "}
                ARE YOU PARTNERING WITH A SOFTWARE PLATFORM TO MANAGE YOUR ASC OPERATIONS, SUCH AS SCHEDULING, BILLING, AND ELECTRONIC CHARTING?
            </div>
            <div>{config.has_software_platform}</div> */}
            <br />



            {!config.isManual && (
                <div>
                    <div style={pdfStyle.subtitle}>Facility ownership module</div>
                    <br />
                </div>
            )}
            {!config.isManual &&
                config.owner_ship.map((item, index) =>
                    item.value ? (
                        <div key={index}>
                            <div>
                                <span style={{ fontWeight: 500 }}>{`${item.value}%`}</span> -{" "}
                                {item.label == "Hospital/IDN"
                                    ? `${item.label} - ${config.owner_ship_hospital}`
                                    : item.label == "Management company"
                                        ? `${item.label} - ${config.owner_ship_company}`
                                        : item.label}
                            </div>
                            <br />
                        </div>
                    ) : null
                )}
            <table>
                <tbody>
                    <tr>
                        <td>
                            {!config.isManual &&
                                config.owner_ship_addions.map((item, index) =>
                                    item.value ? (
                                        <div key={index}>
                                            <div>
                                                <span
                                                    style={{ fontWeight: 500 }}
                                                >{`${item.value}%`}</span>{" "}
                                                - {item.label}
                                            </div>
                                            <br />
                                        </div>
                                    ) : null
                                )}
                        </td>
                    </tr>
                </tbody>
            </table>

            <table>
                <tbody>
                    {!config.isManual && (config.asc === "De Novo / New Build ASC" || config.asc === "New Build") &&
                        config.facility_new.map((item, index) =>
                            item.value.length > 0 ? (
                                <tr key={index}>
                                    <td>
                                        <br />
                                        {index === 0 && (
                                            <div style={pdfStyle.subtitle}>Operating rooms</div>
                                        )}
                                        {index === 1 && (
                                            <div style={pdfStyle.subtitle}>Procedure rooms</div>
                                        )}
                                        {index === 2 && (
                                            <div style={pdfStyle.subtitle}>Patient bays</div>
                                        )}
                                        {index === 4 && (
                                            <div style={pdfStyle.subtitle}>Lobby / waiting rooms</div>
                                        )}
                                        {index === 5 && (
                                            <div style={pdfStyle.subtitle}>
                                                Overnight stays (23hours)
                                            </div>
                                        )}
                                        {index <= 5 && <br />}
                                        <div>
                                            <div style={pdfStyle.label}>
                                                {item.label.toUpperCase()}
                                            </div>
                                            <div>{item.value}</div>
                                        </div>
                                    </td>
                                </tr>
                            ) : null
                        )}
                </tbody>
            </table>
            <table>
                <tbody>
                    {!config.isManual && (config.asc === "Expansion / Construction of Existing ASC" || config.asc === "Existing") &&
                        config.facility_expanding.map((item, index) =>
                            item.value.length > 0 ? (
                                <tr key={index}>
                                    <td>
                                        <br />
                                        {index === 0 && (
                                            <div style={pdfStyle.subtitle}>Operating rooms</div>
                                        )}
                                        {index === 3 && (
                                            <div style={pdfStyle.subtitle}>Procedure rooms</div>
                                        )}
                                        {index === 5 && (
                                            <div style={pdfStyle.subtitle}>Patient bays</div>
                                        )}
                                        {index === 8 && (
                                            <div style={pdfStyle.subtitle}>Lobby / waiting rooms</div>
                                        )}
                                        {index === 10 && (
                                            <div style={pdfStyle.subtitle}>
                                                Overnight stays (23hours)
                                            </div>
                                        )}
                                        {(index === 0 ||
                                            index == 3 ||
                                            index == 5 ||
                                            index == 8 ||
                                            index == 10) && <br />}
                                        <div>
                                            <div style={pdfStyle.label}>
                                                {item.label.toUpperCase()}
                                            </div>
                                            <div>{item.value}</div>
                                        </div>
                                    </td>
                                </tr>
                            ) : null
                        )}
                </tbody>
            </table>

            <table>
                <tbody>
                    {!config.isManual &&
                        config.facility_all_option.map((item, index) =>
                            item.value.length > 0 ? (
                                <tr key={index}>
                                    <td>
                                        {index === 0 && (
                                            <div style={pdfStyle.subtitle}>
                                                <br />
                                                Sterilization
                                            </div>
                                        )}
                                        <br />
                                        <div>
                                            <div style={pdfStyle.label}>
                                                {item.label.toUpperCase()}
                                            </div>
                                            <div>{item.value}</div>
                                        </div>
                                    </td>
                                </tr>
                            ) : null
                        )}
                </tbody>
            </table>
            <br />
            {!config.isManual && (
                <div>
                    <div style={pdfStyle.label}>ADDITIONAL PROJECT / CUSTOMER NOTES:</div>
                    <div>{config.facility_note}</div>
                    <br />
                </div>
            )}
        </div>
    );

    const pdfStyleLandscape = {
        page: { fontSize: 10, fontFamily: "Stryker" },
        title: { fontSize: 24, fontWeight: 900 },
        subtitle: { fontSize: 12, fontWeight: 500, maxWidth: 158 },
        label: { fontSize: 10, fontWeight: 700, color: "#bbb" },
        titleUnderline: {
            fontSize: 12,
            fontWeight: 500,
            textDecoration: "underline",
        },
        tHeading: { fontWeight: 700, minWidth: 175, width: 175, color: "#bbb" },
        tHeadingSmall: { fontWeight: 700, width: 20, color: "#bbb" },
        tCell: { minWidth: 175, width: 175, paddingRight: 5 },
        tCellSmall: { width: 20 },
    };

    const customerInfoElementLandscape = (
        <div style={pdfStyleLandscape.page}>
            <div style={pdfStyleLandscape.title}>Customer Information</div>
            <div style={pdfStyleLandscape.subtitle}>{config.account_name}</div>
            <br />
            {config.customerSummary && (
                <div>
                    <div style={pdfStyle.subtitle}>Notes</div>
                    <div>{config.customerSummary}</div>
                    <br />
                </div>
            )}
            <div style={pdfStyleLandscape.label}>ACCOUNT / PROJECT NAME</div>
            <div>{config.account_name}</div>
            <br />
            <div style={pdfStyleLandscape.label}>STREET ADDRESS</div>
            <div>{config.state}</div>
            <br />
            <div style={pdfStyleLandscape.label}>CITY</div>
            <div>{config.city}</div>
            <br />
            <div style={pdfStyleLandscape.label}>STATE/PROVINCE</div>
            <div>{config.state}</div>
            <br />
            <div style={pdfStyleLandscape.label}>ZIP CODE/POSTAL CODE</div>
            <div>{config.zip}</div>
            <br />


            <div style={pdfStyleLandscape.subtitle}>Customer Background</div>

            <div style={pdfStyleLandscape.label}>INITIAL CUSTOMER MEETING DATE</div>
            <div>{config.initial_customer_meeting_date}</div>
            <br />
            <div style={pdfStyleLandscape.label}>NEW OR EXISTING STRYKER CUSTOMER?</div>
            <div>{config.stryker_customer}</div>
            <br />
            <div style={pdfStyleLandscape.label}>ASC TYPE</div>
            <div>{config.asc_type}</div>
            <br />
            <div style={pdfStyleLandscape.label}>PROJECT TYPE (NT)</div>
            <div>{config.project_type}</div>
            <br />
            <div style={pdfStyleLandscape.label}>HOSPITAL TYPE</div>
            <div>{config.hospital_type}</div>
            <br />
            {/* <div style={pdfStyleLandscape.label}>NEW BUILD OR EXISTING?</div>
            <div>{`NEED TO LOOK INTO IT`}</div>
            <br /> */}
            <div style={pdfStyleLandscape.label}>IS THERE A MAKO INCLUDED?</div>
            <div >{config.mako_included}</div>
            <br />
            <div style={pdfStyleLandscape.label}>WHAT IS THE STRATEGIC PARTNERSHIP?</div>
            <div>{config.strategic_partnership}</div>
            <br />
            <div style={pdfStyleLandscape.label}>GPO AFFILIATION</div>
            <div >{config.gpo_affiliation}</div>
            <br />
            <div style={pdfStyleLandscape.label}>COMPETITIVE LANDSCAPE</div>
            <div>{config.competitive_landscape}</div>
            <br />
            <div style={pdfStyleLandscape.label}>CUSTOMER CONTACT</div>
            <div>{config.customer_contact}</div>
            <br />
            <div style={pdfStyleLandscape.label}>1A CONTACTS</div>
            <div>{config.one_a_contacts}</div>
            <br />
            <div style={pdfStyleLandscape.label}>WHERE ARE YOU AT WITH CONTRUCTION, HIRING ARCHITECTS, AND SUBMITTING APPLICATIONS?</div>
            <div>{config.construction_architects_applications}</div>
            <br />

            <div style={pdfStyleLandscape.subtitle}>Project Type</div>
            <br />

            <div style={pdfStyleLandscape.label}>
                {" "}
                WHAT BEST DEFINES YOUR CURRENT ASC PROJECTS{" "}
            </div>
            <div>{config.asc}</div>
            <br />

            {config.asc === "De Novo / New Build ASC" || config.asc === "New Build" && (
                <div>
                    <div style={pdfStyleLandscape.label}>
                        {" "}
                        WHAT BEST DEFINES YOUR CURRENT ASC PROJECTS{" "}
                    </div>
                    <div>{config.healthcare_partner}</div>
                    <br />
                </div>
            )}

            <div style={pdfStyleLandscape.label}>
                {" "}
                HAVE YOU PARTNERED WITH AN ASC MANAGEMENT COMPANY YET?

            </div>
            <div>{config.asc_management_partner}</div>
            <br />

            <div style={pdfStyleLandscape.label}>
                {" "}
                HAVE YOU HIRED AN ARCHITECT YET?

            </div>
            <div>{config.hired}</div>
            <br />


            <div style={pdfStyleLandscape.label}>
                {" "}
                HAVE YOU HIRED A MEDICAL EQUIPMENT PLANNER YET?

            </div>
            <div>{config.hired_medical_equipment_planner}</div>
            <br />

            <div style={pdfStyleLandscape.label}>
                {" "}
                HAVE YOU PERFORMED A FEASIBILITY STUDY?

            </div>
            <div>{config.performed_feasibility_study}</div>
            <br />


            <div style={pdfStyleLandscape.label}>
                {" "}
                DOES YOUR STATE HAVE CON LAWS?
            </div>
            <div>{config.has_con_laws}</div>
            <br />

            {config.has_con_laws.toLowerCase() == "yes" && (
                <div>
                    <div style={pdfStyleLandscape.label}>HAVE YOU SUBMITTED A CON APPLICATION?</div>
                    <div>{config.submitted_con_application}</div>
                    <br />
                </div>
            )}
            <div style={pdfStyleLandscape.label}>
                {" "}
                HAS CONSTRUCTION STARTED?
            </div>
            <div>{config.started}</div>
            <br />

            <div style={pdfStyleLandscape.label}>
                {" "}
                DO YOU HAVE A SLATED OPENING DATE?
            </div>
            <div>{config.has_slated_opening_date}</div>
            <br />



            {config.has_slated_opening_date.toLowerCase() == "yes" && (
                <div>
                    <div style={pdfStyleLandscape.label}>SLATED DATE OF OPENING?</div>
                    <div>{config.date_opend}</div>
                    <br />
                </div>
            )}

            {/* <div style={pdfStyleLandscape.label}>
                {" "}
                ARE YOU PARTNERING WITH A SOFTWARE PLATFORM TO MANAGE YOUR ASC OPERATIONS, SUCH AS SCHEDULING, BILLING, AND ELECTRONIC CHARTING?
            </div>
            <div>{config.has_software_platform}</div> */}
            <br />



            {!config.isManual && (
                <div>
                    <div style={pdfStyleLandscape.subtitle}>Facility ownership module</div>
                    <br />
                </div>
            )}
            {!config.isManual &&
                config.owner_ship.map((item, index) =>
                    item.value ? (
                        <div key={index}>
                            <div>
                                <span style={{ fontWeight: 500 }}>{`${item.value}%`}</span> -{" "}
                                {item.label == "Hospital/IDN"
                                    ? `${item.label} - ${config.owner_ship_hospital}`
                                    : item.label == "Management company"
                                        ? `${item.label} - ${config.owner_ship_company}`
                                        : item.label}
                            </div>
                            <br />
                        </div>
                    ) : null
                )}
            <table>
                <tbody>
                    <tr>
                        <td>
                            {!config.isManual &&
                                config.owner_ship_addions.map((item, index) =>
                                    item.value ? (
                                        <div key={index}>
                                            <div>
                                                <span
                                                    style={{ fontWeight: 500 }}
                                                >{`${item.value}%`}</span>{" "}
                                                - {item.label}
                                            </div>
                                            <br />
                                        </div>
                                    ) : null
                                )}
                        </td>
                    </tr>
                </tbody>
            </table>

            <table>
                <tbody>
                    {!config.isManual && (config.asc === "De Novo / New Build ASC" || config.asc === "New Build") &&
                        config.facility_new.map((item, index) =>
                            item.value.length > 0 ? (
                                <tr key={index}>
                                    <td>
                                        <br />
                                        {index === 0 && (
                                            <div style={pdfStyleLandscape.subtitle}>Operating rooms</div>
                                        )}
                                        {index === 1 && (
                                            <div style={pdfStyleLandscape.subtitle}>Procedure rooms</div>
                                        )}
                                        {index === 2 && (
                                            <div style={pdfStyleLandscape.subtitle}>Patient bays</div>
                                        )}
                                        {index === 4 && (
                                            <div style={pdfStyleLandscape.subtitle}>Lobby / waiting rooms</div>
                                        )}
                                        {index === 5 && (
                                            <div style={pdfStyleLandscape.subtitle}>
                                                Overnight stays (23hours)
                                            </div>
                                        )}
                                        {index <= 5 && <br />}
                                        <div>
                                            <div style={pdfStyleLandscape.label}>
                                                {item.label.toUpperCase()}
                                            </div>
                                            <div>{item.value}</div>
                                        </div>
                                    </td>
                                </tr>
                            ) : null
                        )}
                </tbody>
            </table>
            <table>
                <tbody>
                    {!config.isManual && (config.asc === "Expansion / Construction of Existing ASC" || config.asc === "Existing") &&
                        config.facility_expanding.map((item, index) =>
                            item.value.length > 0 ? (
                                <tr key={index}>
                                    <td>
                                        <br />
                                        {index === 0 && (
                                            <div style={pdfStyleLandscape.subtitle}>Operating rooms</div>
                                        )}
                                        {index === 3 && (
                                            <div style={pdfStyleLandscape.subtitle}>Procedure rooms</div>
                                        )}
                                        {index === 5 && (
                                            <div style={pdfStyleLandscape.subtitle}>Patient bays</div>
                                        )}
                                        {index === 8 && (
                                            <div style={pdfStyleLandscape.subtitle}>Lobby / waiting rooms</div>
                                        )}
                                        {index === 10 && (
                                            <div style={pdfStyleLandscape.subtitle}>
                                                Overnight stays (23hours)
                                            </div>
                                        )}
                                        {(index === 0 ||
                                            index == 3 ||
                                            index == 5 ||
                                            index == 8 ||
                                            index == 10) && <br />}
                                        <div>
                                            <div style={pdfStyleLandscape.label}>
                                                {item.label.toUpperCase()}
                                            </div>
                                            <div>{item.value}</div>
                                        </div>
                                    </td>
                                </tr>
                            ) : null
                        )}
                </tbody>
            </table>

            <table>
                <tbody>
                    {!config.isManual &&
                        config.facility_all_option.map((item, index) =>
                            item.value.length > 0 ? (
                                <tr key={index}>
                                    <td>
                                        {index === 0 && (
                                            <div style={pdfStyleLandscape.subtitle}>
                                                <br />
                                                Sterilization
                                            </div>
                                        )}
                                        <br />
                                        <div>
                                            <div style={pdfStyleLandscape.label}>
                                                {item.label.toUpperCase()}
                                            </div>
                                            <div>{item.value}</div>
                                        </div>
                                    </td>
                                </tr>
                            ) : null
                        )}
                </tbody>
            </table>
            <br />
            {!config.isManual && (
                <div>
                    <div style={pdfStyleLandscape.label}>ADDITIONAL PROJECT / CUSTOMER NOTES:</div>
                    <div>{config.facility_note}</div>
                    <br />
                </div>
            )}
        </div>
    );

    const customerInfoHtml =
        ReactDOMServer.renderToStaticMarkup(customerInfoElement);
    const CustomerInfoDoc = () => (
        <Document>
            <Page style={{ padding: 50 }}>
                <Html>{customerInfoHtml}</Html>
            </Page>
        </Document>
    );

    const customerInfoHtmlLandscape =
        ReactDOMServer.renderToStaticMarkup(customerInfoElementLandscape);
    const CustomerInfoDocLandscape = () => (
        <Document>
            <Page orientation="landscape"
                style={{ padding: 50 }}
            >
                <Html>{customerInfoHtmlLandscape}</Html>
            </Page>
        </Document>
    );

    const specialtiesElement = (
        <div style={pdfStyle.page}>
            <div style={pdfStyle.title}>Specialties</div>
            <div style={pdfStyle.subtitle}>{config.account_name}</div>
            <br />
            {config.specialtiesSummary && (
                <div>
                    <div style={pdfStyle.subtitle}>Notes</div>
                    <div>{config.specialtiesSummary}</div>
                    <br />
                </div>
            )}
            {!config.isManual && (
                <div>
                    <div style={pdfStyle.subtitle}>ASC Specialties</div>
                    <br />
                </div>
            )}
            {/* <div className={cls.surgeon}>Surgeons</div> */}
            <table>
                <tbody>
                    {config.specialties.map((item, index) => {
                        if (item.value > 0) {
                            return (
                                <tr key={index}>
                                    <td>
                                        <br />
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                paddingLeft: 40,
                                            }}
                                        >
                                            <img
                                                src={`/assets/images/specialties/${item.image ? item.image : "generalSurgery.png"
                                                    }`}
                                                style={{ height: 50, width: 50 }}
                                            />
                                            <div>
                                                <div style={pdfStyle.subtitle}>{item.label}</div>
                                                <div>{`${item.value} Surgeons`}</div>
                                            </div>
                                        </div>
                                        <br />
                                        {index !== 0 && (
                                            <div>
                                                <div style={pdfStyle.label}>
                                                    {`ESTIMATED ${item.label.toUpperCase()} CASES PER MONTH`}
                                                </div>
                                                <div className={cls.val}>
                                                    {item?.estimatedPerMonth || 0}
                                                </div>
                                                <br />
                                            </div>
                                        )}
                                        {index === 0 && (
                                            <div>
                                                <div>
                                                    {parseInt(config.smsub.smdrop[0]) > 0 && (
                                                        <div>
                                                            <div style={pdfStyle.label}>
                                                                HOW MANY OF YOUR ORS WILL SPORTS MEDICINE CASES
                                                                BE PERFORMED IN?
                                                            </div>
                                                            <div>{config.smsub.smdrop[0]}</div>
                                                        </div>
                                                    )}
                                                    {parseInt(config.smsub.smdrop[1]) > 0 && (
                                                        <div>
                                                            <div style={pdfStyle.label}>
                                                                HOW MANY SPORTS CASES PER DAY?
                                                            </div>
                                                            <div>{config.smsub.smdrop[1]}</div>
                                                            <br />
                                                        </div>
                                                    )}
                                                    {parseInt(config.smsub.smdrop[2]) > 0 && (
                                                        <div>
                                                            <div style={pdfStyle.label}>
                                                                HOW MANY HIP ARTHROSCOPISTS WILL OPERATE
                                                                SIMULTANEOUSLY IN A SINGLE DAY?
                                                            </div>
                                                            <div>{config.smsub.smdrop[2]}</div>
                                                            <br />
                                                        </div>
                                                    )}
                                                    <div>
                                                        <div style={pdfStyle.label}>
                                                            SELECT ALL SUBSPECIALTIES THAT APPLY AND THEIR
                                                            CASE MIX PERCENTAGES. MUST EQUAL 100%
                                                        </div>
                                                        {config.smsub.smary.map((element, i) => {
                                                            if (element.value > 0) {
                                                                return (
                                                                    <div key={i}>
                                                                        <div>
                                                                            {`${element.value}%`} - {element.label}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            } else {
                                                                return null;
                                                            }
                                                        })}
                                                        <br />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {index === 1 && (
                                            <div>
                                                <div>
                                                    <div>
                                                        <div style={pdfStyle.label}>
                                                            HOW MANY ORS WILL YOU BE DOING TOTAL JOINTS IN?
                                                        </div>
                                                        <div>{config.jpsub1}</div>
                                                    </div>
                                                    {config.jpsub2 === "Yes" && (
                                                        <div>
                                                            <div style={pdfStyle.label}>
                                                                WHICH APPLICATIONS WOULD YOU LIKE TO SEE
                                                                PROPOSALS FOR THAT FACTOR IN THE POSSIBLITY OF
                                                                MAKO SMARTROBOTICS?
                                                            </div>
                                                            {config.jpsub.map((item, index) => {
                                                                return item.value ? (
                                                                    <div>{item.label}</div>
                                                                ) : null;
                                                            })}
                                                            <br />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {index === 3 && (
                                            <div>
                                                <div>
                                                    {config.sp1.length > 0 ? (
                                                        <div>
                                                            <div style={pdfStyle.label}>
                                                                WILL YOU BE DESIRING IMAGING WITH NAVIGATION OR
                                                                IMAGING ONLY?
                                                            </div>
                                                            <div>{config.sp1}</div>
                                                        </div>
                                                    ) : null}
                                                    {config.sp2.length > 0 ? (
                                                        <div>
                                                            <div style={pdfStyle.label}>
                                                                WILL FLUOROSCOPY (2D) NAVIGATION OR 3D
                                                                NAVIGATION BE DESIRED?
                                                            </div>
                                                            <div>{config.sp2}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )}
                                        {index === 8 && config.entNav.length > 0 && (
                                            <div>
                                                <div>
                                                    <div style={pdfStyle.label}>
                                                        WOULD YOU LIKE TO SEE A PROPOSAL THAT FACTORS IN THE
                                                        POSSIBILITY OF ENT NAVIGATION?
                                                    </div>
                                                    <div>{config.entNav}</div>
                                                </div>
                                            </div>
                                        )}
                                        {index === 12 && (
                                            <div>
                                                <div>
                                                    {config.eyeNewfacility.value.length > 0 &&
                                                        config.asc === "De Novo / New Build ASC" || config.asc === "New Build" ? (
                                                        <div>
                                                            <div style={pdfStyle.label}>
                                                                {config.eyeNewfacility.label}
                                                            </div>
                                                            <div>{config.eyeNewfacility.value}</div>
                                                        </div>
                                                    ) : null}
                                                    {config.eyeExpandingfacility.value.length > 0 &&
                                                        config.asc ===
                                                        "Expansion / Construction of Existing ASC" ? (
                                                        <div>
                                                            <div style={pdfStyle.label}>
                                                                {config.eyeExpandingfacility.label.toUpperCase()}
                                                            </div>
                                                            <div>{config.eyeExpandingfacility.value}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            );
                        } else {
                            return null;
                        }
                    })}
                </tbody>
            </table>

            {config.specialties_addtions.map((item, index) => {
                if (item.value > 0) {
                    return (
                        <div key={index}>
                            <div>
                                {item.value} - {item.label}
                            </div>
                            <br />
                        </div>
                    );
                } else {
                    return null;
                }
            })}
        </div>
    );

    const specialtiesElementLandscape = (
        <div style={pdfStyleLandscape.page}>
            <div style={pdfStyleLandscape.title}>Specialties</div>
            <div style={pdfStyleLandscape.subtitle}>{config.account_name}</div>
            <br />
            {config.specialtiesSummary && (
                <div>
                    <div style={pdfStyleLandscape.subtitle}>Notes</div>
                    <div>{config.specialtiesSummary}</div>
                    <br />
                </div>
            )}
            {!config.isManual && (
                <div>
                    <div style={pdfStyleLandscape.subtitle}>ASC Specialties</div>
                    <br />
                </div>
            )}
            {/* <div className={cls.surgeon}>Surgeons</div> */}
            <table>
                <tbody>
                    {config.specialties.map((item, index) => {
                        if (item.value > 0) {
                            return (
                                <tr key={index}>
                                    <td>
                                        <br />
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                paddingLeft: 40,
                                            }}
                                        >
                                            <img
                                                src={`/assets/images/specialties/${item.image ? item.image : "generalSurgery.png"
                                                    }`}
                                                style={{ height: 50, width: 50 }}
                                            />
                                            <div>
                                                <div style={pdfStyleLandscape.subtitle}>{item.label}</div>
                                                <div>{`${item.value} Surgeons`}</div>
                                            </div>
                                        </div>
                                        <br />
                                        {index !== 0 && (
                                            <div>
                                                <div style={pdfStyleLandscape.label}>
                                                    {`ESTIMATED ${item.label.toUpperCase()} CASES PER MONTH`}
                                                </div>
                                                <div className={cls.val}>
                                                    {item?.estimatedPerMonth || 0}
                                                </div>
                                                <br />
                                            </div>
                                        )}
                                        {index === 0 && (
                                            <div>
                                                <div>
                                                    {parseInt(config.smsub.smdrop[0]) > 0 && (
                                                        <div>
                                                            <div style={pdfStyleLandscape.label}>
                                                                HOW MANY OF YOUR ORS WILL SPORTS MEDICINE CASES
                                                                BE PERFORMED IN?
                                                            </div>
                                                            <div>{config.smsub.smdrop[0]}</div>
                                                        </div>
                                                    )}
                                                    {parseInt(config.smsub.smdrop[1]) > 0 && (
                                                        <div>
                                                            <div style={pdfStyleLandscape.label}>
                                                                HOW MANY SPORTS CASES PER DAY?
                                                            </div>
                                                            <div>{config.smsub.smdrop[1]}</div>
                                                            <br />
                                                        </div>
                                                    )}
                                                    {parseInt(config.smsub.smdrop[2]) > 0 && (
                                                        <div>
                                                            <div style={pdfStyleLandscape.label}>
                                                                HOW MANY HIP ARTHROSCOPISTS WILL OPERATE
                                                                SIMULTANEOUSLY IN A SINGLE DAY?
                                                            </div>
                                                            <div>{config.smsub.smdrop[2]}</div>
                                                            <br />
                                                        </div>
                                                    )}
                                                    <div>
                                                        <div style={pdfStyleLandscape.label}>
                                                            SELECT ALL SUBSPECIALTIES THAT APPLY AND THEIR
                                                            CASE MIX PERCENTAGES. MUST EQUAL 100%
                                                        </div>
                                                        {config.smsub.smary.map((element, i) => {
                                                            if (element.value > 0) {
                                                                return (
                                                                    <div key={i}>
                                                                        <div>
                                                                            {`${element.value}%`} - {element.label}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            } else {
                                                                return null;
                                                            }
                                                        })}
                                                        <br />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {index === 1 && (
                                            <div>
                                                <div>
                                                    <div>
                                                        <div style={pdfStyleLandscape.label}>
                                                            HOW MANY ORS WILL YOU BE DOING TOTAL JOINTS IN?
                                                        </div>
                                                        <div>{config.jpsub1}</div>
                                                    </div>
                                                    {config.jpsub2 === "Yes" && (
                                                        <div>
                                                            <div style={pdfStyleLandscape.label}>
                                                                WHICH APPLICATIONS WOULD YOU LIKE TO SEE
                                                                PROPOSALS FOR THAT FACTOR IN THE POSSIBLITY OF
                                                                MAKO SMARTROBOTICS?
                                                            </div>
                                                            {config.jpsub.map((item, index) => {
                                                                return item.value ? (
                                                                    <div>{item.label}</div>
                                                                ) : null;
                                                            })}
                                                            <br />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {index === 3 && (
                                            <div>
                                                <div>
                                                    {config.sp1.length > 0 ? (
                                                        <div>
                                                            <div style={pdfStyleLandscape.label}>
                                                                WILL YOU BE DESIRING IMAGING WITH NAVIGATION OR
                                                                IMAGING ONLY?
                                                            </div>
                                                            <div>{config.sp1}</div>
                                                        </div>
                                                    ) : null}
                                                    {config.sp2.length > 0 ? (
                                                        <div>
                                                            <div style={pdfStyleLandscape.label}>
                                                                WILL FLUOROSCOPY (2D) NAVIGATION OR 3D
                                                                NAVIGATION BE DESIRED?
                                                            </div>
                                                            <div>{config.sp2}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )}
                                        {index === 8 && config.entNav.length > 0 && (
                                            <div>
                                                <div>
                                                    <div style={pdfStyleLandscape.label}>
                                                        WOULD YOU LIKE TO SEE A PROPOSAL THAT FACTORS IN THE
                                                        POSSIBILITY OF ENT NAVIGATION?
                                                    </div>
                                                    <div>{config.entNav}</div>
                                                </div>
                                            </div>
                                        )}
                                        {index === 12 && (
                                            <div>
                                                <div>
                                                    {config.eyeNewfacility.value.length > 0 &&
                                                        config.asc === "De Novo / New Build ASC" || config.asc === "New Build" ? (
                                                        <div>
                                                            <div style={pdfStyleLandscape.label}>
                                                                {config.eyeNewfacility.label}
                                                            </div>
                                                            <div>{config.eyeNewfacility.value}</div>
                                                        </div>
                                                    ) : null}
                                                    {config.eyeExpandingfacility.value.length > 0 &&
                                                        config.asc ===
                                                        "Expansion / Construction of Existing ASC" ? (
                                                        <div>
                                                            <div style={pdfStyleLandscape.label}>
                                                                {config.eyeExpandingfacility.label.toUpperCase()}
                                                            </div>
                                                            <div>{config.eyeExpandingfacility.value}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            );
                        } else {
                            return null;
                        }
                    })}
                </tbody>
            </table>

            {config.specialties_addtions.map((item, index) => {
                if (item.value > 0) {
                    return (
                        <div key={index}>
                            <div>
                                {item.value} - {item.label}
                            </div>
                            <br />
                        </div>
                    );
                } else {
                    return null;
                }
            })}
        </div>
    );
    const specialtiesHtml =
        ReactDOMServer.renderToStaticMarkup(specialtiesElement);
    const SpecialtiesDoc = () => (
        <Document>
            <Page style={{ padding: 50 }}>
                <Html>{specialtiesHtml}</Html>
            </Page>
        </Document>
    );

    const specialtiesHtmlLandscape =
        ReactDOMServer.renderToStaticMarkup(specialtiesElementLandscape);
    const SpecialtiesDocLandscape = () => (
        <Document>
            <Page orientation="landscape" style={{ padding: 50 }}>
                <Html>{specialtiesHtmlLandscape}</Html>
            </Page>
        </Document>
    );

    const SpecialitiesBreakdownComp = ({ image, array1, array2 }) => {
        return (
            <div>
                <br />
                <div
                    style={{ display: "flex", flexDirection: "row", paddingLeft: 130 }}
                >
                    {image !== "" ? (
                        <img
                            style={{ width: 132.8, height: 97.6, marginRight: 10 }}
                            src={image}
                        />
                    ) : (
                        <div style={{ width: 0, height: 97.6, marginRight: 10 }}></div>
                    )}
                    <div style={{ paddingLeft: 20 }}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <div style={pdfStyle.tHeading}>PART NUMBER</div>
                            <div style={pdfStyle.tHeading}>PRODUCT</div>
                            <div style={pdfStyle.tHeading}>CATEGORY</div>
                            <div style={{ ...pdfStyle.tHeadingSmall, textAlign: "right" }}>
                                QTY
                            </div>
                        </div>

                        {array1.map((item, index) => {
                            return (
                                <div>
                                    {item && <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                        }}
                                    >
                                        <div style={pdfStyle.tCell}>{item.partNumber}</div>
                                        <div style={pdfStyle.tCell}>{item.product}</div>
                                        <div style={pdfStyle.tCell}>{item.category}</div>
                                        <div style={{ ...pdfStyle.tCellSmall, textAlign: "right" }}>
                                            {item.qty}
                                        </div>
                                    </div>
                                    }
                                </div>
                            );
                        })}

                        {array2 && checkNullArray(array2) && (
                            <div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                >
                                    <div className={cls.lightline} />
                                    <div style={pdfStyle.subtitle}>ADD ONS</div>
                                    <div className={cls.lightline} />
                                </div>
                                {array2.map((item, index) => {
                                    return (
                                        item.qty > 0 && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                }}
                                                key={index}
                                            >
                                                <div style={pdfStyle.tCell}>{item.partNumber}</div>
                                                <div style={pdfStyle.tCell}>{item.product}</div>
                                                <div style={pdfStyle.tCell}>{item.category}</div>
                                                <div
                                                    style={{ ...pdfStyle.tCellSmall, textAlign: "right" }}
                                                >
                                                    {item.qty}
                                                </div>
                                            </div>
                                        )
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const SpecialitiesBreakdownCompLandscape = ({ image, array1, array2 }) => {
        return (
            <div>
                <br />
                <div
                    style={{ display: "flex", flexDirection: "row" }}
                >
                    {image !== "" ? (
                        <img
                            style={{ width: 132.8, height: 97.6, marginRight: 10 }}
                            src={image}
                        />
                    ) : (
                        <div style={{ width: 0, height: 97.6, marginRight: 10 }}></div>
                    )}
                    <div style={{ paddingLeft: 20 }}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <div style={pdfStyleLandscape.tHeading}>PART NUMBER</div>
                            <div style={pdfStyleLandscape.tHeading}>PRODUCT</div>
                            <div style={pdfStyleLandscape.tHeading}>CATEGORY</div>
                            <div style={{ ...pdfStyleLandscape.tHeadingSmall, textAlign: "right" }}>
                                QTY
                            </div>
                        </div>

                        {array1.map((item, index) => {
                            return (
                                <div>
                                    {item && <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                        }}
                                    >
                                        <div style={pdfStyleLandscape.tCell}>{item.partNumber}</div>
                                        <div style={pdfStyleLandscape.tCell}>{item.product}</div>
                                        <div style={pdfStyleLandscape.tCell}>{item.category}</div>
                                        <div style={{ ...pdfStyleLandscape.tCellSmall, textAlign: "right" }}>
                                            {item.qty}
                                        </div>
                                    </div>
                                    }
                                </div>
                            );
                        })}

                        {array2 && checkNullArray(array2) && (
                            <div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                >
                                    <div className={cls.lightline} />
                                    <div style={pdfStyleLandscape.subtitle}>ADD ONS</div>
                                    <div className={cls.lightline} />
                                </div>
                                {array2.map((item, index) => {
                                    return (
                                        item.qty > 0 && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                }}
                                                key={index}
                                            >
                                                <div style={pdfStyleLandscape.tCell}>{item.partNumber}</div>
                                                <div style={pdfStyleLandscape.tCell}>{item.product}</div>
                                                <div style={pdfStyleLandscape.tCell}>{item.category}</div>
                                                <div
                                                    style={{ ...pdfStyleLandscape.tCellSmall, textAlign: "right" }}
                                                >
                                                    {item.qty}
                                                </div>
                                            </div>
                                        )
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    //Combine products with the same name in the equipment summary
    const filterSummaryValue = (arrVal) => {
        const tmpVal = _.cloneDeep(arrVal);
        const newVal = tmpVal.reduce((acc, e) => {
            const { summaryLabel } = e;
            if (acc[summaryLabel]) {
                acc[summaryLabel] = {
                    ...acc[summaryLabel],
                    qty:
                        parseInt(acc?.[summaryLabel]?.qty ?? "0") + parseInt(e?.qty ?? "0"),
                };
            } else {
                acc[summaryLabel] = {
                    ...e,
                };
            }
            return acc;
        }, {});
        return Object.values(newVal);
    };

    const equipmentPlanElement = (
        <div style={pdfStyle.page}>
            <div>
                <div style={pdfStyle.title}>Equipment Plan</div>
                <div style={pdfStyle.subtitle}>{config.account_name}</div>
                <br />
                {config.equipmentSummary && (
                    <div>
                        <div style={pdfStyle.subtitle}>Notes </div>
                        <div>{config.equipmentSummary}</div>
                        <br />
                    </div>
                )}
                <div>
                    <div style={pdfStyle.titleUnderline}>Equipment Plan Summary </div>
                    <table>
                        <tbody>
                            {checkNullArray([
                                ...config.standardORs,
                                ...config.isuitORs,
                            ]) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={
                                                    "Operating room infrastructure (Booms, Lights, Tables, etc.)"
                                                }
                                                products={filterSummaryValue([
                                                    ...config.standardORs,
                                                    ...config.isuitORs,
                                                ])}
                                            />
                                        </td>
                                    </tr>
                                )}
                            {checkNullArray([...config.makoSmartRobotics]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Robotics"}
                                            products={[...config.makoSmartRobotics]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.wasteManagements]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Waste Management"}
                                            products={[...config.wasteManagements]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([...config.saftySpongeSystem]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Safety Sponge System"}
                                            products={[...config.saftySpongeSystem]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {config.safeAir && checkNullArray([...config.safeAir]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"SafeAir"}
                                            products={[...config.safeAir]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.generalStretchers]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"General Stretchers"}
                                            products={[...config.generalStretchers]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([config.patienWarning]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Patient Warming"}
                                            products={[config.patienWarning]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([config.transportChairs]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Transport Chairs"}
                                            products={[config.transportChairs]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([config.surgeonStools]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Surgeon Stools"}
                                            products={[config.surgeonStools]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.patientBayFurniture]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Furniture"}
                                            products={[...config.patientBayFurniture]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([...config.overnightBayRoomFurniture]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Furniture"}
                                            products={[...config.overnightBayRoomFurniture]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.lobbyRoomFurniture]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Furniture"}
                                            products={[...config.lobbyRoomFurniture]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([...config.spineNavigations]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Spine Navigation, Software, and Imaging"}
                                            products={[...config.spineNavigations]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.spineInstrumentation]) &&
                                config.specialties[3].value > 0 && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Spine Instrumentation"}
                                                products={[...config.spineInstrumentation]}
                                            />
                                        </td>
                                    </tr>
                                )}
                            {checkNullArray([...config.crashcartsDefibrillators]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"AEDs, Crash Carts, Defibrillators"}
                                            products={[...config.crashcartsDefibrillators]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.emergencyPreparedness]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Emergency Preparedness"}
                                            products={[...config.emergencyPreparedness]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.vocera]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Communication Technology"}
                                            products={[...config.vocera]}
                                        />
                                    </td>
                                </tr>
                            )}






                            {(checkVisiblity(
                                config.jpsub1 && parseInt(config.jpsub1) > 0,
                                config.powerTools.slice(0, 12)
                            ) ||
                                checkVisiblity(
                                    config.specialties[4].value > 0 ||
                                    config.specialties[5].value > 0,
                                    config.powerTools.slice(12, 25)
                                ) ||
                                checkVisiblity(
                                    config.specialties[0].value > 0,
                                    config.powerTools.slice(25, 36)
                                ) ||
                                checkVisiblity(
                                    config.specialties[3].value > 0,
                                    config.powerTools.slice(36)
                                )) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Power Tools"}
                                                products={[...config.powerTools]}
                                            />
                                        </td>
                                    </tr>
                                )}


                            {checkNullArray([...config.tourniquet]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Tourniquet System"}
                                            products={[...config.tourniquet]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkVisiblity(
                                parseInt(config.jpsub1) > 0 || config.isManual,
                                config.surgicalHelmets
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Surgical Helmets"}
                                                products={[...config.surgicalHelmets]}
                                            />
                                        </td>
                                    </tr>
                                )}

                            {checkVisiblity(
                                config.specialties[0].value > 0 || config.isManual,
                                [
                                    ...config.sportMedicine,
                                    ...config.sportInstrumentation,
                                    ...config.sportAccessories,
                                    ...config.sportsKneeInstrumentation,
                                    ...config.sportsHipInstrumentation,
                                    ...config.sportMedicineHipArthroscopy,
                                    ...config.sportMedicineFootAnkle,
                                ]
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Sports Medicine"}
                                                products={[
                                                    ...config.sportMedicine,
                                                    ...config.sportInstrumentation,
                                                    ...config.sportAccessories,
                                                    ...config.sportsKneeInstrumentation,
                                                    ...config.sportsHipInstrumentation,
                                                    ...config.sportMedicineHipArthroscopy,
                                                    ...config.sportMedicineFootAnkle,
                                                ]}
                                            />
                                        </td>
                                    </tr>
                                )}
                            {checkVisiblity(config.entNav === "Yes" || config.isManual, [
                                ...config.entNavigation,
                                ...config.entDrills,
                            ]) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"ENT"}
                                                products={[
                                                    ...config.entNavigation,
                                                    ...config.entDrills,
                                                ]}
                                            />
                                        </td>
                                    </tr>
                                )}

                            {checkNullArray([...config.painManagement]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Pain Management Equipment"}
                                            products={[...config.painManagement]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.footAndAnkle]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Foot & Ankle"}
                                            products={[...config.footAndAnkle]}
                                        />
                                    </td>
                                </tr>
                            )}


                            {checkNullArray([...config.entDrills]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"ENT Drills, Irrigation Systems and Accessories"}
                                            products={[...config.entDrills]}
                                        />
                                    </td>
                                </tr>
                            )}






                            {checkVisiblity(
                                ((config.specialties[0].value > 0 ||
                                    config.specialties[8].value > 0 ||
                                    config.specialties[10].value > 0 ||
                                    config.specialties[11].value > 0) &&
                                    (config.facility_all_option[1].value === "Low temp" ||
                                        config.facility_all_option[1].value ===
                                        "High Temp/autoclave only" ||
                                        config.facility_all_option[1].value === "Both" ||
                                        config.facility_all_option[1].value ===
                                        "I don't know yet.")) ||
                                config.isManual,
                                [...config.videoEndoscopy]
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Video Systems/Towers"}
                                                products={[
                                                    ...config.videoEndoscopy
                                                ]}
                                            />
                                        </td>
                                    </tr>
                                )}

                            {checkVisiblity(
                                ((config.specialties[0].value > 0 ||
                                    config.specialties[8].value > 0 ||
                                    config.specialties[10].value > 0 ||
                                    config.specialties[11].value > 0) &&
                                    config.facility_all_option[1].value ===
                                    "High Temp/autoclave only") ||
                                config.isManual,
                                [...config.videoEndcscopyautoclavable]
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Video Endoscopy System- 4K Autoclavable"}
                                                products={[...config.videoEndcscopyautoclavable]}
                                            />
                                        </td>
                                    </tr>
                                )}

                            {checkVisiblity(
                                ((config.specialties[0].value > 0 ||
                                    config.specialties[8].value > 0 ||
                                    config.specialties[10].value > 0 ||
                                    config.specialties[11].value > 0) &&
                                    (config.facility_all_option[1].value === "Low temp" ||
                                        config.facility_all_option[1].value ===
                                        "High Temp/autoclave only" ||
                                        config.facility_all_option[1].value === "Both" ||
                                        config.facility_all_option[1].value ===
                                        "I don't know yet.")) ||
                                config.isManual,
                                [...config.scopesOption1]
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Insufflation"}
                                                products={[...config.scopesOption1]}
                                            />
                                        </td>
                                    </tr>
                                )}
                            {/* {checkNullArray([...config.scopesOption2]) && (
                <tr>
                  <td>
                    <EquipmentSummaryItemPDF
                      title={"Sinuscopes"}
                      products={[...config.scopesOption2]}
                    />
                  </td>
                </tr>
              )} */}
                            {checkNullArray([config.serviceContract]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Service Contract"}
                                            products={[config.serviceContract]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([config.onSiteServicesProgram]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"OnSite Services Program"}
                                            products={[config.onSiteServicesProgram]}
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div>
                <table>
                    <tbody>
                        {/*   Operating Rooms  */}
                        {checkVisiblity(
                            config.communication1.value > 0 || config.isManual,
                            config.standardORs
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div>
                                            <div style={pdfStyle.subtitle}>
                                                Operating room infrastructure (Booms, Lights, Tables, etc.)
                                            </div>
                                        </div>

                                        {/*  Standart Operating Rooms  */}
                                        {checkVisiblity(
                                            config.communication1.value > 0 || config.isManual,
                                            config.standardORs
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/communication1.png"}
                                                    array1={config.standardORs}
                                                    array2={config.standardORsAddons}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}
                        {checkVisiblity(
                            config.communication3.value > 0 || config.isManual,
                            config.isuitORs
                        ) && (
                                <tr>
                                    <td>
                                        <br />

                                        {/*  iSuite Rooms  */}
                                        {checkVisiblity(
                                            config.communication3.value > 0 || config.isManual,
                                            config.isuitORs
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/communication3.png"}
                                                    array1={config.isuitORs}
                                                    array2={config.isuitORsAddons}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {/* Mako Smart Robotics  */}
                        {checkVisiblity(
                            config.jpsub2 === "Yes" || config.isManual,
                            config.makoSmartRobotics
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Mako Smart Robotics</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/mako.png"}
                                            array1={config.makoSmartRobotics}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*  Waste Management  */}
                        {checkVisiblity(
                            totalORRooms > 0 || config.isManual,
                            config.wasteManagements
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Waste Management</div>

                                        {checkVisiblity(
                                            totalORRooms > 0 || config.isManual,
                                            config.wasteManagements.slice(0, 2)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/waste_rover.png"}
                                                    array1={config.wasteManagements.slice(0, 2)}
                                                    array2={config.wasteManagementAddons}
                                                />
                                            )}

                                        {checkVisiblity(
                                            totalORRooms > 0 || config.isManual,
                                            config.wasteManagements.slice(2)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/waste_or.png"}
                                                    array1={config.wasteManagements.slice(2)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {/*  sponge  */}
                        {checkVisiblity(
                            totalORRooms > 0 || config.isManual,
                            config.saftySpongeSystem
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Safety Sponge System</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/SC+ Stand Kit- Sponge Counting.png"}
                                            array1={config.saftySpongeSystem}
                                            array2={[]}
                                        />
                                        {checkVisiblity(
                                            totalORRooms > 0 || config.isManual,
                                            config.saftySpongeSystemAddons
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/SurgiCount+ Safety-Sponge System (Generation 2) .jpeg"}
                                                    array1={[]}
                                                    array2={config.saftySpongeSystemAddons}
                                                />
                                            )}

                                    </td>
                                </tr>
                            )}

                        {/*  sponge  */}
                        {config.safeAir && checkVisiblity(
                            true || config.isManual,
                            config.safeAir
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>SafeAir</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/safeAir.png"}
                                            array1={config.safeAir}
                                            array2={[]}
                                        />


                                    </td>
                                </tr>
                            )}

                        {(checkVisiblityOne(
                            config.acutecare2.value > 0 || config.isManual,
                            config.generalStretchers[0]
                        )) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>General Stretchers</div>

                                        {[0].map((i) =>
                                            checkVisiblityOne(
                                                config[`acutecare2`].value > 0 || config.isManual,
                                                config.generalStretchers[i]
                                            ) ? (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/stretcher.png"}
                                                    array1={[config.generalStretchers[i]]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                        <SpecialitiesBreakdownComp
                                            image={""}
                                            array1={[]}
                                            array2={config.generalStretchersAddons}
                                        />
                                    </td>
                                </tr>
                            )}

                        {checkVisiblityOne(
                            totalPostOPRooms > 0 || config.isManual,
                            config.patienWarning
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Patient Warming</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/prewarming2.jpeg"}
                                            array1={[config.patienWarning]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                        {/*   Transport Chairs   */}
                        {checkVisiblityOne(
                            totalORRooms > 0 || config.isManual,
                            config.transportChairs
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Transport Chairs</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/transport_chair.png"}
                                            array1={[config.transportChairs]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*   Surgeon Stools   */}
                        {checkVisiblityOne(
                            totalORRooms > 0 || config.isManual,
                            config.surgeonStools
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Surgeon Stools</div>

                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/surgeon_stools.png"}
                                            array1={[config.surgeonStools]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                        {/* Patient Bay Furniture */}
                        {checkVisiblity(
                            totalPostOPRooms > 0 || config.isManual,
                            config.patientBayFurniture
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Patient Bay Furniture</div>

                                        {config.patientBayFurniture.map((item, index) =>
                                            config.patientBayFurniture[index].qty > 0 ? (
                                                <SpecialitiesBreakdownComp
                                                    image={
                                                        index === 0
                                                            ? "/assets/images/patient_furniture.png"
                                                            : "/assets/images/patient_furniture1.png"
                                                    }
                                                    array1={[item]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                    </td>
                                </tr>
                            )}
                        {/* Overnight Bay/Room Furniture */}
                        {checkVisiblity(
                            totalOvernightRooms > 0 || config.isManual,
                            config.overnightBayRoomFurniture
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Overnight Bay/Room Furniture
                                        </div>

                                        {config.overnightBayRoomFurniture.map((item, index) =>
                                            config.overnightBayRoomFurniture[index].qty > 0 ? (
                                                <SpecialitiesBreakdownComp
                                                    image={
                                                        index === 0
                                                            ? "/assets/images/overnight1.png"
                                                            : "/assets/images/overnight2.png"
                                                    }
                                                    array1={[item]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                    </td>
                                </tr>
                            )}
                        {/* Lobby/Waiting Room Furniture */}
                        {checkVisiblity(
                            totalLobbyRooms > 0 || config.isManual,
                            config.lobbyRoomFurniture
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Lobby/Waiting Room Furniture
                                        </div>

                                        {config.lobbyRoomFurniture.map((item, index) =>
                                            config.lobbyRoomFurniture[index].qty > 0 ? (
                                                <SpecialitiesBreakdownComp
                                                    image={
                                                        index === 0
                                                            ? "/assets/images/lobby1.png"
                                                            : "/assets/images/lobby2.png"
                                                    }
                                                    array1={[item]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                    </td>
                                </tr>
                            )}





                        {/* Spine Navigation, Software, and Imaging */}
                        {checkVisiblity(
                            config.sp1 === 'Imaging with navigation' || config.isManual,
                            config.spineNavigations
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Spine Navigation, Software, and Imaging</div>

                                        {checkVisiblity(
                                            config.sp1 === 'Imaging with navigation' || config.isManual,
                                            config.spineNavigations.slice(0, 2)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/spinenav12.png"}
                                                    array1={config.spineNavigations.slice(0, 2)}
                                                    array2={[]}
                                                />
                                            )}
                                        {checkVisiblity(
                                            config.sp1 === 'Imaging with navigation' || config.isManual,
                                            config.spineNavigations.slice(2, 5)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/Q Guidance System.png"}
                                                    array1={config.spineNavigations.slice(2, 5)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            config.sp1 === 'Imaging with navigation' || config.isManual,
                                            config.spineNavigations.slice(5, 8)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/Airo System.png"}
                                                    array1={config.spineNavigations.slice(5, 8)}
                                                    array2={[]}
                                                />
                                            )}
                                        {checkVisiblity(
                                            config.sp1 === 'Imaging with navigation' || config.isManual,
                                            config.spineNavigations.slice(8)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/SpineMask Tracker.png"}
                                                    array1={config.spineNavigations.slice(8)}
                                                    array2={[]}
                                                />
                                            )}


                                    </td>
                                </tr>
                            )}





                        {/* Spine Instrumentation  */}
                        {checkVisiblity(
                            config.specialties[3].value > 0 || config.isManual,
                            config.spineInstrumentation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Spine Instrumentation</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/spineinstrument.png"}
                                            array1={config.spineInstrumentation}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/* AEDs, Crash Carts, Defibrillators  */}

                        {checkVisiblity(true, config.crashcartsDefibrillators) && (
                            <tr>
                                <td>
                                    <br />
                                    <div style={pdfStyle.subtitle}>
                                        AEDs, Crash Carts, Defibrillators
                                    </div>

                                    {checkVisiblity(
                                        true,
                                        config.crashcartsDefibrillators.slice(0, 3)
                                    ) && (
                                            <SpecialitiesBreakdownComp
                                                image={"/assets/images/aed0.png"}
                                                array1={config.crashcartsDefibrillators.slice(0, 3)}
                                                array2={[]}
                                            />
                                        )}
                                    {checkVisiblity(
                                        true,
                                        config.crashcartsDefibrillators.slice(0, 3)
                                    ) && (
                                            <SpecialitiesBreakdownComp
                                                image={"/assets/images/lifepak35.png"}
                                                array1={config.crashcartsDefibrillators.slice(3)}
                                                array2={[]}
                                            />
                                        )}
                                </td>
                            </tr>
                        )}

                        {/* Emergency Preparedness  */}
                        {checkVisiblity(true, config.emergencyPreparedness) && (
                            <tr>
                                <td>
                                    <br />
                                    <div style={pdfStyle.subtitle}>Emergency Preparedness</div>
                                    <SpecialitiesBreakdownComp
                                        image={"/assets/images/emergency.png"}
                                        array1={config.emergencyPreparedness}
                                        array2={[]}
                                    />
                                </td>
                            </tr>
                        )}

                        {/* Emergency Preparedness  */}
                        {checkVisiblity(true, config.vocera) && (
                            <tr>
                                <td>
                                    <br />
                                    <div style={pdfStyle.subtitle}>Communnication Technology</div>

                                    {checkVisiblity(true, config.vocera.slice(0, 1)) && (
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/vocera1.png"}
                                            array1={config.vocera.slice(0, 1)}
                                            array2={[]}
                                        />
                                    )}
                                    {checkVisiblity(true, config.vocera.slice(1)) && (
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/vocera2.jpeg"}
                                            array1={config.vocera.slice(1)}
                                            array2={[]}
                                        />
                                    )}
                                </td>
                            </tr>
                        )}


                        {checkVisiblity(
                            config.jpsub1 && parseInt(config.jpsub1) > 0
                            || config.isManual,
                            config.powerTools.slice(0, 12)
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Power Tools</div>

                                        {checkVisiblity(
                                            config.jpsub1 && parseInt(config.jpsub1) > 0
                                            || config.isManual,
                                            config.powerTools.slice(12, 23)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/powertool5.png"}
                                                    array1={config.powerTools.slice(12, 24)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {checkVisiblity(
                            config.specialties[4].value > 0 ||
                            config.specialties[5].value > 0 ||
                            config.isManual,
                            config.powerTools.slice(12, 25)
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <br />
                                        {checkVisiblity(
                                            config.specialties[4].value > 0 ||
                                            config.specialties[5].value > 0 ||
                                            config.isManual,
                                            config.powerTools.slice(12, 25)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/powertool1.png"}
                                                    array1={config.powerTools.slice(12, 25)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}


                        {(
                            checkVisiblity(
                                config.specialties[3].value > 0 || config.isManual,
                                config.powerTools.slice(36)
                            )) && (
                                <tr>
                                    <td>
                                        <br />
                                        {checkVisiblity(
                                            config.specialties[3].value > 0 || config.isManual,
                                            config.powerTools.slice(36)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/powertool3.png"}
                                                    array1={config.powerTools.slice(36)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}



                        {checkVisiblity(
                            config.specialties[0].value > 0 || config.isManual,
                            config.powerTools.slice(25, 36)
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        {checkVisiblity(
                                            config.specialties[0].value > 0 || config.isManual,
                                            config.powerTools.slice(25, 36)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/powertool6.png"}
                                                    array1={config.powerTools.slice(25, 36)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}



                        {/*     Tourniquet System    */}
                        {checkVisiblity(
                            totalORRooms > 0 || config.isManual,
                            config.tourniquet
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Tourniquet System</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/tourniquet.png"}
                                            array1={config.tourniquet}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}



                        {/*   Sports Medicine - Arthroscopy Capital    */}
                        {checkVisiblity(
                            config.specialties[0].value > 0 || config.isManual,
                            config.sportMedicine
                        ) && (
                                <tr>
                                    <td>
                                        <div style={{ pageBreakBefore: 'always' }}></div>

                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Sports Medicine - Arthroscopy Capital
                                        </div>

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(0, 1)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/sportsMedicine0.png"}
                                                    array1={config.sportMedicine.slice(0, 1)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(1, 2)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/sportsMedicine1.png"}
                                                    array1={config.sportMedicine.slice(1, 2)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(2, 3)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/crossfirefootpedal.png"}
                                                    array1={config.sportMedicine.slice(2, 3)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(3, 4)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/crossfirehandpiece.png"}
                                                    array1={config.sportMedicine.slice(3, 4)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(4, 5)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/cuttercannulaset.png"}
                                                    array1={config.sportMedicine.slice(4, 5)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(5, 6)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/inspaceballoon.png"}
                                                    array1={config.sportMedicine.slice(5, 6)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {/*     Surgical Helmets    */}
                        {checkVisiblity(
                            parseInt(config.jpsub1) > 0 || config.isManual,
                            config.surgicalHelmets
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Surgical Helmets</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/surgical.png"}
                                            array1={config.surgicalHelmets}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*  Sports Medicine - shoulder Trays / Instrumentation   */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[2].value > 0) ||
                            config.isManual,
                            config.sportInstrumentation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Sports Medicine - Shoulder Trays / Instrumentation
                                        </div>

                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/Championshoulderinstrumentationset.png"}
                                            array1={config.sportInstrumentation.slice(0, 1)}
                                            array2={[]}
                                        />
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/AntegradeSuturePasser.png"}
                                            array1={config.sportInstrumentation.slice(1)}
                                            array2={[]}
                                        />











                                    </td>
                                </tr>
                            )}

                        {/*  Sports Medicine - shoulder OR Table Accessories   */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[2].value > 0) ||
                            config.isManual,
                            config.sportAccessories
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Sports Medicine - Shoulder OR Table Accessories
                                        </div>

                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/sportaccessories1.png"}
                                            array1={config.sportAccessories.slice(0, 1)}
                                            array2={[]}
                                        />
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/sportAccessories2.png"}
                                            array1={config.sportAccessories.slice(1)}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}


                        {/*  Sports Medicine - Knee Trays / Instrumentation   */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[1].value > 0) ||
                            config.isManual,
                            config.sportsKneeInstrumentation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Sports Medicine - Knee Trays / Instrumentation
                                        </div>

                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/spineinstrument.png"}
                                            array1={config.sportsKneeInstrumentation}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*  Sports Medicine - Hip Trays / Instrumentation   */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[0].value > 0) ||
                            config.isManual,
                            config.sportsHipInstrumentation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Sports Medicine - Hip Trays / Instrumentation
                                        </div>

                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/sportsHipInstrumentation.png"}
                                            array1={config.sportsHipInstrumentation}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*    Sports Medicine - Hip Arthroscopy: Capital     */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[0].value > 0) ||
                            config.isManual,
                            config.sportMedicineHipArthroscopy
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Sports Medicine - Hip Arthroscopy: Capital
                                        </div>

                                        {config.sportMedicineHipArthroscopy.map((item, index) =>
                                            item.qty > 0 ? (
                                                <SpecialitiesBreakdownComp
                                                    image={
                                                        index === 0
                                                            ? "/assets/images/sportarth0.png"
                                                            : index === 1 ? "/assets/images/sportarth1.png" : "/assets/images/sportarth2.png"
                                                    }
                                                    array1={[item]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                    </td>
                                </tr>
                            )}

                        {/*   Sports Medicine - Foot & Ankle Trays / Instrumentation    */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[3].value > 0) ||
                            config.isManual,
                            config.sportMedicineFootAnkle
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Sports Medicine - Foot & Ankle Trays / Instrumentation
                                        </div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/sportMedicineFootAnkle.png"}
                                            array1={config.sportMedicineFootAnkle}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}









                        {/*   ENT Navigation System    */}
                        {checkVisiblity(
                            config.entNav === "Yes" || config.isManual,
                            config.entNavigation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>ENT Navigation System</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/entnavigation.png"}
                                            array1={config.entNavigation}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*   ENT Drills, Irrigation Systems and Accessories    */}
                        {checkVisiblity(
                            config.entNav === "Yes" ||
                            config.specialties[8].value > 0 ||
                            config.isManual,
                            config.entDrills
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            ENT Drills, Irrigation Systems and Accessories
                                        </div>
                                        {checkVisiblity(
                                            config.specialties[8].value > 0 ||
                                            config.isManual,
                                            config.entDrills.slice(0, 1)
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/entdrill.png"}
                                                    array1={config.entDrills.slice(0, 1)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            config.specialties[8].value > 0 ||
                                            config.isManual,
                                            config.entDrills.slice(1)
                                        ) && (
                                                <SpecialitiesBreakdownComp

                                                    image={"/assets/images/Cliq Suction Pump .png"}
                                                    array1={config.entDrills.slice(1)}
                                                    array2={[]}
                                                />
                                            )}




                                    </td>
                                </tr>
                            )}



                        {/*   Pain Management Equipment   */}
                        {checkVisiblity(
                            config.specialties[6].value > 0 || config.isManual,
                            config.painManagement
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Pain Management Equipment</div>

                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/painmanagement.png"}
                                            array1={config.painManagement}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*   Foot & Ankle   */}
                        {checkVisiblity(
                            true || config.isManual,
                            config.footAndAnkle
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Foot & Ankle</div>

                                        {checkVisiblity(true, config.footAndAnkle.slice(0, 1)) && (
                                            <SpecialitiesBreakdownComp
                                                image={"/assets/images/footAndAnkle1.png"}
                                                array1={config.footAndAnkle.slice(0, 1)}
                                                array2={[]}
                                            />
                                        )}
                                        {checkVisiblity(true, config.footAndAnkle.slice(1)) && (
                                            <SpecialitiesBreakdownComp
                                                image={"/assets/images/footAndAnkle2.png"}
                                                array1={config.footAndAnkle.slice(1)}
                                                array2={[]}
                                            />
                                        )}
                                    </td>
                                </tr>
                            )}

                        {/*   Video Endoscopy Tower Systems   */}
                        {checkVisiblity(
                            ((config.specialties[0].value > 0 ||
                                config.specialties[8].value > 0 ||
                                config.specialties[10].value > 0 ||
                                config.specialties[11].value > 0) &&
                                (config.facility_all_option[1].value === "Low temp" ||
                                    config.facility_all_option[1].value === "Both" ||
                                    config.facility_all_option[1].value === "I don't know yet.")) ||
                            config.isManual,
                            [...config.videoEndoscopy]
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Video Systems/Towers</div>

                                        {checkVisiblity(true, config.videoEndoscopy) && (
                                            <SpecialitiesBreakdownComp
                                                image={"/assets/images/videoendoscopy.png"}
                                                array1={config.videoEndoscopy}
                                                array2={[]}
                                            />
                                        )}

                                    </td>
                                </tr>
                            )}

                        {/*    Video Endoscopy System- Precision/Autoclavable   */}
                        {checkVisiblity(
                            ((config.specialties[0].value > 0 ||
                                config.specialties[8].value > 0 ||
                                config.specialties[10].value > 0 ||
                                config.specialties[11].value > 0) &&
                                config.facility_all_option[1].value ===
                                "High Temp/autoclave only") ||
                            config.isManual,
                            [...config.videoEndcscopyautoclavable]
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>
                                            Video Systems/Towers - Precision/Autoclavable
                                        </div>

                                        {checkVisiblity(
                                            config.facility_all_option[1].value ===
                                            "High Temp/autoclave only" || config.isManual,
                                            config.videoEndcscopyautoclavable
                                        ) && (
                                                <SpecialitiesBreakdownComp
                                                    image={"/assets/images/videoauto.jpeg"}
                                                    array1={config.videoEndcscopyautoclavable}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {checkVisiblity(
                            ((config.facility_all_option[1].value === "Low temp" ||
                                config.facility_all_option[1].value ===
                                "High Temp/autoclave only" ||
                                config.facility_all_option[1].value === "Both" ||
                                config.facility_all_option[1].value === "I don't know yet.") &&
                                config.specialties[10].value > 0) ||
                            config.isManual,
                            [...config.scopesOption1]
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Insufflation</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/scopeoption.png"}
                                            array1={config.scopesOption1}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                        {checkVisiblity(
                            ((config.specialties[0].value > 0 ||
                                config.specialties[8].value > 0 ||
                                config.specialties[10].value > 0 ||
                                config.specialties[11].value > 0) &&
                                (config.facility_all_option[1].value === "Low temp" ||
                                    config.facility_all_option[1].value ===
                                    "High Temp/autoclave only" ||
                                    config.facility_all_option[1].value === "Both" ||
                                    config.facility_all_option[1].value === "I don't know yet.")) ||
                            config.isManual,
                            [...config.scopesOption2]
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>Sinoscopes</div>
                                        {checkNullArray([...config.scopesOption2.slice(0, 1)]) && (
                                            <SpecialitiesBreakdownComp
                                                image={"/assets/images/scopesOption21.png"}
                                                array1={config.scopesOption2.slice(0, 1)}
                                                array2={[]}
                                            />
                                        )}
                                        {checkNullArray([...config.scopesOption2.slice(0, 1)]) && (
                                            <SpecialitiesBreakdownComp
                                                image={"/assets/images/scopesOption22.png"}
                                                array1={config.scopesOption2.slice(1)}
                                                array2={[]}
                                            />
                                        )}



                                    </td>
                                </tr>
                            )}



                        {config.serviceContract &&
                            config.serviceContract.qty > 0 && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>OnSite Services Program</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/serviceContract.png"}
                                            array1={[config.serviceContract]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                        {config.onSiteServicesProgram &&
                            config.onSiteServicesProgram.qty > 0 && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={pdfStyle.subtitle}>OnSite Services Program</div>
                                        <SpecialitiesBreakdownComp
                                            image={"/assets/images/onsiteservicesprogram2.png"}
                                            array1={[config.onSiteServicesProgram]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        </div>
    );

    const equipmentPlanElementLandscape = (
        <div style={pdfStyleLandscape.page}>
            <div>
                <div style={pdfStyleLandscape.title}>Equipment Plan</div>
                <div style={pdfStyleLandscape.subtitle}>{config.account_name}</div>
                <br />
                {config.equipmentSummary && (
                    <div>
                        <div style={pdfStyleLandscape.subtitle}>Notes </div>
                        <div>{config.equipmentSummary}</div>
                        <br />
                    </div>
                )}
                <div>
                    <div style={pdfStyleLandscape.titleUnderline}>Equipment Plan Summary </div>
                    <table>
                        <tbody>
                            {checkNullArray([
                                ...config.standardORs,
                                ...config.isuitORs,
                            ]) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={
                                                    "Operating room infrastructure (Booms, Lights, Tables, etc.)"
                                                }
                                                products={filterSummaryValue([
                                                    ...config.standardORs,
                                                    ...config.isuitORs,
                                                ])}
                                            />
                                        </td>
                                    </tr>
                                )}
                            {checkNullArray([...config.makoSmartRobotics]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Robotics"}
                                            products={[...config.makoSmartRobotics]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.wasteManagements]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Waste Management"}
                                            products={[...config.wasteManagements]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([...config.saftySpongeSystem]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Safety Sponge System"}
                                            products={[...config.saftySpongeSystem]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {config.safeAir && checkNullArray([...config.safeAir]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"SafeAir"}
                                            products={[...config.safeAir]}
                                        />
                                    </td>
                                </tr>
                            )}


                            {checkNullArray([...config.generalStretchers]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"General Stretchers"}
                                            products={[...config.generalStretchers]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([config.patienWarning]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Patient Warming"}
                                            products={[config.patienWarning]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([config.transportChairs]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Transport Chairs"}
                                            products={[config.transportChairs]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([config.surgeonStools]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Surgeon Stools"}
                                            products={[config.surgeonStools]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.patientBayFurniture]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Furniture"}
                                            products={[...config.patientBayFurniture]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([...config.overnightBayRoomFurniture]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Furniture"}
                                            products={[...config.overnightBayRoomFurniture]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.lobbyRoomFurniture]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Furniture"}
                                            products={[...config.lobbyRoomFurniture]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([...config.spineNavigations]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Spine Navigation, Software, and Imaging"}
                                            products={[...config.spineNavigations]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.spineInstrumentation]) &&
                                config.specialties[3].value > 0 && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Spine Instrumentation"}
                                                products={[...config.spineInstrumentation]}
                                            />
                                        </td>
                                    </tr>
                                )}
                            {checkNullArray([...config.crashcartsDefibrillators]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"AEDs, Crash Carts, Defibrillators"}
                                            products={[...config.crashcartsDefibrillators]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.emergencyPreparedness]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Emergency Preparedness"}
                                            products={[...config.emergencyPreparedness]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.vocera]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Communnication Technology"}
                                            products={[...config.vocera]}
                                        />
                                    </td>
                                </tr>
                            )}


                            {(
                                checkVisiblity(
                                    config.jpsub1 && parseInt(config.jpsub1) > 0,
                                    config.powerTools.slice(0, 12)
                                ) ||
                                checkVisiblity(
                                    config.specialties[4].value > 0 ||
                                    config.specialties[5].value > 0,
                                    config.powerTools.slice(12, 25)
                                ) ||
                                checkVisiblity(
                                    config.specialties[0].value > 0,
                                    config.powerTools.slice(25, 36)
                                ) ||
                                checkVisiblity(
                                    config.specialties[3].value > 0,
                                    config.powerTools.slice(36)
                                )) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Power Tools"}
                                                products={[...config.powerTools]}
                                            />
                                        </td>
                                    </tr>
                                )}


                            {checkNullArray([...config.tourniquet]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Tourniquet System"}
                                            products={[...config.tourniquet]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkVisiblity(
                                parseInt(config.jpsub1) > 0 || config.isManual,
                                config.surgicalHelmets
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Surgical Helmets"}
                                                products={[...config.surgicalHelmets]}
                                            />
                                        </td>
                                    </tr>
                                )}

                            {checkVisiblity(
                                config.specialties[0].value > 0 || config.isManual,
                                [
                                    ...config.sportMedicine,
                                    ...config.sportInstrumentation,
                                    ...config.sportAccessories,
                                    ...config.sportsKneeInstrumentation,
                                    ...config.sportsHipInstrumentation,
                                    ...config.sportMedicineHipArthroscopy,
                                    ...config.sportMedicineFootAnkle,
                                ]
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Sports Medicine"}
                                                products={[
                                                    ...config.sportMedicine,
                                                    ...config.sportInstrumentation,
                                                    ...config.sportAccessories,
                                                    ...config.sportsKneeInstrumentation,
                                                    ...config.sportsHipInstrumentation,
                                                    ...config.sportMedicineHipArthroscopy,
                                                    ...config.sportMedicineFootAnkle,
                                                ]}
                                            />
                                        </td>
                                    </tr>
                                )}
                            {checkVisiblity(config.entNav === "Yes" || config.isManual, [
                                ...config.entNavigation,
                                ...config.entDrills,
                            ]) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"ENT"}
                                                products={[
                                                    ...config.entNavigation,
                                                    ...config.entDrills,
                                                ]}
                                            />
                                        </td>
                                    </tr>
                                )}

                            {checkNullArray([...config.painManagement]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Pain Management Equipment"}
                                            products={[...config.painManagement]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.footAndAnkle]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Foot & Ankle"}
                                            products={[...config.footAndAnkle]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkNullArray([...config.entDrills]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"ENT Drills, Irrigation Systems and Accessories"}
                                            products={[...config.entDrills]}
                                        />
                                    </td>
                                </tr>
                            )}

                            {checkVisiblity(
                                ((config.specialties[0].value > 0 ||
                                    config.specialties[8].value > 0 ||
                                    config.specialties[10].value > 0 ||
                                    config.specialties[11].value > 0) &&
                                    (config.facility_all_option[1].value === "Low temp" ||
                                        config.facility_all_option[1].value ===
                                        "High Temp/autoclave only" ||
                                        config.facility_all_option[1].value === "Both" ||
                                        config.facility_all_option[1].value ===
                                        "I don't know yet.")) ||
                                config.isManual,
                                [...config.videoEndoscopy]
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Video Systems/Towers"}
                                                products={[
                                                    ...config.videoEndoscopy
                                                ]}
                                            />
                                        </td>
                                    </tr>
                                )}

                            {checkVisiblity(
                                ((config.specialties[0].value > 0 ||
                                    config.specialties[8].value > 0 ||
                                    config.specialties[10].value > 0 ||
                                    config.specialties[11].value > 0) &&
                                    config.facility_all_option[1].value ===
                                    "High Temp/autoclave only") ||
                                config.isManual,
                                [...config.videoEndcscopyautoclavable]
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Video Endoscopy System- 4K Autoclavable"}
                                                products={[...config.videoEndcscopyautoclavable]}
                                            />
                                        </td>
                                    </tr>
                                )}

                            {checkVisiblity(
                                ((config.specialties[0].value > 0 ||
                                    config.specialties[8].value > 0 ||
                                    config.specialties[10].value > 0 ||
                                    config.specialties[11].value > 0) &&
                                    (config.facility_all_option[1].value === "Low temp" ||
                                        config.facility_all_option[1].value ===
                                        "High Temp/autoclave only" ||
                                        config.facility_all_option[1].value === "Both" ||
                                        config.facility_all_option[1].value ===
                                        "I don't know yet.")) ||
                                config.isManual,
                                [...config.scopesOption1]
                            ) && (
                                    <tr>
                                        <td>
                                            <EquipmentSummaryItemPDF
                                                title={"Insufflation"}
                                                products={[...config.scopesOption1]}
                                            />
                                        </td>
                                    </tr>
                                )}
                            {/* {checkNullArray([...config.scopesOption2]) && (
                <tr>
                  <td>
                    <EquipmentSummaryItemPDF
                      title={"Sinuscopes"}
                      products={[...config.scopesOption2]}
                    />
                  </td>
                </tr>
              )} */}
                            {checkNullArray([config.serviceContract]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"Service Contract"}
                                            products={[config.serviceContract]}
                                        />
                                    </td>
                                </tr>
                            )}
                            {checkNullArray([config.onSiteServicesProgram]) && (
                                <tr>
                                    <td>
                                        <EquipmentSummaryItemPDF
                                            title={"OnSite Services Program"}
                                            products={[config.onSiteServicesProgram]}
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div style={{ marginLeft: "130px" }}>
                <table>
                    <tbody>
                        {/*   Operating Rooms  */}
                        {checkVisiblity(
                            config.communication1.value > 0 || config.isManual,
                            config.standardORs
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div>
                                            <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                                Operating room infrastructure (Booms, Lights, Tables, etc.)
                                            </div>
                                        </div>

                                        {/*  Standart Operating Rooms  */}
                                        {checkVisiblity(
                                            config.communication1.value > 0 || config.isManual,
                                            config.standardORs
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/communication1.png"}
                                                    array1={config.standardORs}
                                                    array2={config.standardORsAddons}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}
                        {checkVisiblity(
                            config.communication3.value > 0 || config.isManual,
                            config.isuitORs
                        ) && (
                                <tr>
                                    <td>
                                        <br />

                                        {/*  iSuite Rooms  */}
                                        {checkVisiblity(
                                            config.communication3.value > 0 || config.isManual,
                                            config.isuitORs
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/communication3.png"}
                                                    array1={config.isuitORs}
                                                    array2={config.isuitORsAddons}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {/* Mako Smart Robotics  */}
                        {checkVisiblity(
                            config.jpsub2 === "Yes" || config.isManual,
                            config.makoSmartRobotics
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Mako Smart Robotics</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/mako.png"}
                                            array1={config.makoSmartRobotics}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*  Waste Management  */}
                        {checkVisiblity(
                            totalORRooms > 0 || config.isManual,
                            config.wasteManagements
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Waste Management</div>

                                        {checkVisiblity(
                                            totalORRooms > 0 || config.isManual,
                                            config.wasteManagements.slice(0, 2)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/waste_rover.png"}
                                                    array1={config.wasteManagements.slice(0, 2)}
                                                    array2={config.wasteManagementAddons}
                                                />
                                            )}

                                        {checkVisiblity(
                                            totalORRooms > 0 || config.isManual,
                                            config.wasteManagements.slice(2)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/waste_or.png"}
                                                    array1={config.wasteManagements.slice(2)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {/*  sponge  */}
                        {checkVisiblity(
                            totalORRooms > 0 || config.isManual,
                            config.saftySpongeSystem
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyle.subtitle, marginLeft: -125 }}>Safety Sponge System</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/SC+ Stand Kit- Sponge Counting.png"}
                                            array1={config.saftySpongeSystem}
                                            array2={[]}
                                        />
                                        {checkVisiblity(
                                            totalORRooms > 0 || config.isManual,
                                            config.saftySpongeSystemAddons
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/SurgiCount+ Safety-Sponge System (Generation 2) .jpeg"}
                                                    array1={[]}
                                                    array2={config.saftySpongeSystemAddons}
                                                />
                                            )}

                                    </td>
                                </tr>
                            )}

                        {/*  sponge  */}
                        {config.safeAir && checkVisiblity(
                            true || config.isManual,
                            config.safeAir
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyle.subtitle, marginLeft: -125 }}>SafeAir</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/safeAir.png"}
                                            array1={config.safeAir}
                                            array2={[]}
                                        />


                                    </td>
                                </tr>
                            )}












                        {(checkVisiblityOne(
                            config.acutecare2.value > 0 || config.isManual,
                            config.generalStretchers[0]
                        )) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>


                                            General Stretchers</div>

                                        {[0].map((i) =>
                                            checkVisiblityOne(
                                                config[`acutecare2`].value > 0 || config.isManual,
                                                config.generalStretchers[i]
                                            ) ? (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/stretcher.png"}
                                                    array1={[config.generalStretchers[i]]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                        <SpecialitiesBreakdownCompLandscape
                                            image={""}
                                            array1={[]}
                                            array2={config.generalStretchersAddons}
                                        />
                                    </td>
                                </tr>
                            )}

                        {checkVisiblityOne(
                            totalPostOPRooms > 0 || config.isManual,
                            config.patienWarning
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Patient Warming</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/prewarming2.jpeg"}
                                            array1={[config.patienWarning]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                        {/*   Transport Chairs   */}
                        {checkVisiblityOne(
                            totalORRooms > 0 || config.isManual,
                            config.transportChairs
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Transport Chairs</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/transport_chair.png"}
                                            array1={[config.transportChairs]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*   Surgeon Stools   */}
                        {checkVisiblityOne(
                            totalORRooms > 0 || config.isManual,
                            config.surgeonStools
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Surgeon Stools</div>

                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/surgeon_stools.png"}
                                            array1={[config.surgeonStools]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                        {/* Patient Bay Furniture */}
                        {checkVisiblity(
                            totalPostOPRooms > 0 || config.isManual,
                            config.patientBayFurniture
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Patient Bay Furniture</div>

                                        {config.patientBayFurniture.map((item, index) =>
                                            config.patientBayFurniture[index].qty > 0 ? (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={
                                                        index === 0
                                                            ? "/assets/images/patient_furniture.png"
                                                            : "/assets/images/patient_furniture1.png"
                                                    }
                                                    array1={[item]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                    </td>
                                </tr>
                            )}
                        {/* Overnight Bay/Room Furniture */}
                        {checkVisiblity(
                            totalOvernightRooms > 0 || config.isManual,
                            config.overnightBayRoomFurniture
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Overnight Bay/Room Furniture
                                        </div>

                                        {config.overnightBayRoomFurniture.map((item, index) =>
                                            config.overnightBayRoomFurniture[index].qty > 0 ? (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={
                                                        index === 0
                                                            ? "/assets/images/overnight1.png"
                                                            : "/assets/images/overnight2.png"
                                                    }
                                                    array1={[item]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                    </td>
                                </tr>
                            )}
                        {/* Lobby/Waiting Room Furniture */}
                        {checkVisiblity(
                            totalLobbyRooms > 0 || config.isManual,
                            config.lobbyRoomFurniture
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Lobby/Waiting Room Furniture
                                        </div>

                                        {config.lobbyRoomFurniture.map((item, index) =>
                                            config.lobbyRoomFurniture[index].qty > 0 ? (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={
                                                        index === 0
                                                            ? "/assets/images/lobby1.png"
                                                            : "/assets/images/lobby2.png"
                                                    }
                                                    array1={[item]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                    </td>
                                </tr>
                            )}


                        {/* Spine Navigation, Software, and Imaging */}
                        {checkVisiblity(
                            config.sp1 === 'Imaging with navigation' || config.isManual,
                            config.spineNavigations
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyle.subtitle, marginLeft: -125 }}>Spine Navigation, Software, and Imaging</div>

                                        {checkVisiblity(
                                            config.sp1 === 'Imaging with navigation' || config.isManual,
                                            config.spineNavigations.slice(0, 2)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/spinenav12.png"}
                                                    array1={config.spineNavigations.slice(0, 2)}
                                                    array2={[]}
                                                />
                                            )}
                                        {checkVisiblity(
                                            config.sp1 === 'Imaging with navigation' || config.isManual,
                                            config.spineNavigations.slice(2, 5)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/Q Guidance System.png"}
                                                    array1={config.spineNavigations.slice(2, 5)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            config.sp1 === 'Imaging with navigation' || config.isManual,
                                            config.spineNavigations.slice(5, 8)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/Airo System.png"}
                                                    array1={config.spineNavigations.slice(5, 8)}
                                                    array2={[]}
                                                />
                                            )}
                                        {checkVisiblity(
                                            config.sp1 === 'Imaging with navigation' || config.isManual,
                                            config.spineNavigations.slice(8)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/SpineMask Tracker.png"}
                                                    array1={config.spineNavigations.slice(8)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {/* Spine Instrumentation  */}
                        {checkVisiblity(
                            config.specialties[3].value > 0 || config.isManual,
                            config.spineInstrumentation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Spine Instrumentation</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/spineinstrument.png"}
                                            array1={config.spineInstrumentation}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/* AEDs, Crash Carts, Defibrillators  */}

                        {checkVisiblity(true, config.crashcartsDefibrillators) && (
                            <tr>
                                <td>
                                    <br />
                                    <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                        AEDs, Crash Carts, Defibrillators
                                    </div>

                                    {checkVisiblity(
                                        true,
                                        config.crashcartsDefibrillators.slice(0, 3)
                                    ) && (
                                            <SpecialitiesBreakdownCompLandscape
                                                image={"/assets/images/aed0.png"}
                                                array1={config.crashcartsDefibrillators.slice(0, 3)}
                                                array2={[]}
                                            />
                                        )}
                                    {checkVisiblity(
                                        true,
                                        config.crashcartsDefibrillators.slice(0, 3)
                                    ) && (
                                            <SpecialitiesBreakdownCompLandscape
                                                image={"/assets/images/aed1.png"}
                                                array1={config.crashcartsDefibrillators.slice(3)}
                                                array2={[]}
                                            />
                                        )}
                                </td>
                            </tr>
                        )}

                        {/* Emergency Preparedness  */}
                        {checkVisiblity(true, config.emergencyPreparedness) && (
                            <tr>
                                <td>
                                    <br />
                                    <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                        Emergency Preparedness</div>
                                    <SpecialitiesBreakdownCompLandscape
                                        image={"/assets/images/emergency.png"}
                                        array1={config.emergencyPreparedness}
                                        array2={[]}
                                    />
                                </td>
                            </tr>
                        )}

                        {/* Emergency Preparedness  */}
                        {checkVisiblity(true, config.vocera) && (
                            <tr>
                                <td>
                                    <br />
                                    <div style={{ ...pdfStyle.subtitle, marginLeft: -125 }}>Communnication Technology</div>

                                    {checkVisiblity(true, config.vocera.slice(0, 1)) && (
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/vocera1.png"}
                                            array1={config.vocera.slice(0, 1)}
                                            array2={[]}
                                        />
                                    )}
                                    {checkVisiblity(true, config.vocera.slice(1)) && (
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/vocera2.jpeg"}
                                            array1={config.vocera.slice(1)}
                                            array2={[]}
                                        />
                                    )}
                                </td>
                            </tr>
                        )}



                        {checkVisiblity(
                            config.jpsub1 && parseInt(config.jpsub1) > 0
                            || config.isManual,
                            config.powerTools.slice(0, 12)
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Power Tools</div>

                                        {checkVisiblity(
                                            config.jpsub1 && parseInt(config.jpsub1) > 0
                                            || config.isManual,
                                            config.powerTools.slice(0, 12)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/powertool5.png"}
                                                    array1={config.powerTools.slice(0, 12)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {checkVisiblity(
                            config.specialties[4].value > 0 ||
                            config.specialties[5].value > 0 ||
                            config.isManual,
                            config.powerTools.slice(12, 25)
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <br />
                                        {checkVisiblity(
                                            config.specialties[4].value > 0 ||
                                            config.specialties[5].value > 0 ||
                                            config.isManual,
                                            config.powerTools.slice(12, 25)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/powertool1.png"}
                                                    array1={config.powerTools.slice(12, 25)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}


                        {checkVisiblity(
                            config.specialties[0].value > 0 || config.isManual,
                            config.powerTools.slice(25, 36)
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        {checkVisiblity(
                                            config.specialties[0].value > 0 || config.isManual,
                                            config.powerTools.slice(25, 36)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/powertool6.png"}
                                                    array1={config.powerTools.slice(25, 36)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}



                        {/*     Tourniquet System    */}
                        {checkVisiblity(
                            totalORRooms > 0 || config.isManual,
                            config.tourniquet
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Tourniquet System</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/tourniquet.png"}
                                            array1={config.tourniquet}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}



                        {/*   Sports Medicine - Arthroscopy Capital    */}
                        {checkVisiblity(
                            config.specialties[0].value > 0 || config.isManual,
                            config.sportMedicine
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Sports Medicine - Arthroscopy Capital
                                        </div>

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(0, 1)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/sportsMedicine0.png"}
                                                    array1={config.sportMedicine.slice(0, 1)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(1, 2)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/sportsMedicine1.png"}
                                                    array1={config.sportMedicine.slice(1, 2)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(2, 3)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/crossfirefootpedal.png"}
                                                    array1={config.sportMedicine.slice(2, 3)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(3, 4)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/crossfirehandpiece.png"}
                                                    array1={config.sportMedicine.slice(3, 4)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(4, 5)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/cuttercannulaset.png"}
                                                    array1={config.sportMedicine.slice(4, 5)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            true,
                                            config.sportMedicine.slice(5, 6)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/inspaceballoon.png"}
                                                    array1={config.sportMedicine.slice(5, 6)}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}


                        {/*     Surgical Helmets    */}
                        {checkVisiblity(
                            parseInt(config.jpsub1) > 0 || config.isManual,
                            config.surgicalHelmets
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Surgical Helmets</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/surgical.png"}
                                            array1={config.surgicalHelmets}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*  Sports Medicine - shoulder Trays / Instrumentation   */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[2].value > 0) ||
                            config.isManual,
                            config.sportInstrumentation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Sports Medicine - Shoulder Trays / Instrumentation
                                        </div>

                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/Championshoulderinstrumentationset.png"}
                                            array1={config.sportInstrumentation.slice(0, 1)}
                                            array2={[]}
                                        />
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/AntegradeSuturePasser.png"}
                                            array1={config.sportInstrumentation.slice(1)}
                                            array2={[]}
                                        />











                                    </td>
                                </tr>
                            )}

                        {/*  Sports Medicine - shoulder OR Table Accessories   */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[2].value > 0) ||
                            config.isManual,
                            config.sportAccessories
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Sports Medicine - Shoulder OR Table Accessories
                                        </div>

                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/sportaccessories1.png"}
                                            array1={config.sportAccessories.slice(0, 1)}
                                            array2={[]}
                                        />
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/sportAccessories2.png"}
                                            array1={config.sportAccessories.slice(1)}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}






                        {/*  Sports Medicine - Knee Trays / Instrumentation   */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[1].value > 0) ||
                            config.isManual,
                            config.sportsKneeInstrumentation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Sports Medicine - Knee Trays / Instrumentation
                                        </div>

                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/spineinstrument.png"}
                                            array1={config.sportsKneeInstrumentation}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*  Sports Medicine - Hip Trays / Instrumentation   */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[0].value > 0) ||
                            config.isManual,
                            config.sportsHipInstrumentation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Sports Medicine - Hip Trays / Instrumentation
                                        </div>

                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/sportsHipInstrumentation.png"}
                                            array1={config.sportsHipInstrumentation}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*    Sports Medicine - Hip Arthroscopy: Capital     */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[0].value > 0) ||
                            config.isManual,
                            config.sportMedicineHipArthroscopy
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Sports Medicine - Hip Arthroscopy: Capital
                                        </div>

                                        {config.sportMedicineHipArthroscopy.map((item, index) =>
                                            item.qty > 0 ? (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={
                                                        index === 0
                                                            ? "/assets/images/sportarth0.png"
                                                            : index === 1 ? "/assets/images/sportarth1.png" : "/assets/images/sportarth2.png"
                                                    }
                                                    array1={[item]}
                                                    array2={[]}
                                                />
                                            ) : null
                                        )}
                                    </td>
                                </tr>
                            )}

                        {/*   Sports Medicine - Foot & Ankle Trays / Instrumentation    */}
                        {checkVisiblity(
                            (config.specialties[0].value > 0 &&
                                config.smsub.smary[3].value > 0) ||
                            config.isManual,
                            config.sportMedicineFootAnkle
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>
                                            Sports Medicine - Foot & Ankle Trays / Instrumentation
                                        </div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/sportMedicineFootAnkle.png"}
                                            array1={config.sportMedicineFootAnkle}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}









                        {/*   ENT Navigation System    */}
                        {checkVisiblity(
                            config.entNav === "Yes" || config.isManual,
                            config.entNavigation
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            ENT Navigation System</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/entnavigation.png"}
                                            array1={config.entNavigation}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}

                        {/*   ENT Drills, Irrigation Systems and Accessories    */}
                        {checkVisiblity(
                            config.entNav === "Yes" ||
                            config.specialties[8].value > 0 ||
                            config.isManual,
                            config.entDrills
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyle.subtitle, marginLeft: -125 }}>
                                            ENT Drills, Irrigation Systems and Accessories
                                        </div>
                                        {checkVisiblity(
                                            config.specialties[8].value > 0 ||
                                            config.isManual,
                                            config.entDrills.slice(0, 1)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/entdrill.png"}
                                                    array1={config.entDrills.slice(0, 1)}
                                                    array2={[]}
                                                />
                                            )}

                                        {checkVisiblity(
                                            config.specialties[8].value > 0 ||
                                            config.isManual,
                                            config.entDrills.slice(1)
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape

                                                    image={"/assets/images/Cliq Suction Pump .png"}
                                                    array1={config.entDrills.slice(1)}
                                                    array2={[]}
                                                />
                                            )}




                                    </td>
                                </tr>
                            )}


                        {/*   Pain Management Equipment   */}
                        {checkVisiblity(
                            config.specialties[6].value > 0 || config.isManual,
                            config.painManagement
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Pain Management Equipment</div>

                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/painmanagement.png"}
                                            array1={config.painManagement}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}


                        {/*   Foot & Ankle   */}
                        {checkVisiblity(
                            true || config.isManual,
                            config.footAndAnkle
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyle.subtitle, marginLeft: -125 }}>Foot & Ankle</div>

                                        {checkVisiblity(true, config.footAndAnkle.slice(0, 1)) && (
                                            <SpecialitiesBreakdownCompLandscape
                                                image={"/assets/images/footAndAnkle1.png"}
                                                array1={config.footAndAnkle.slice(0, 1)}
                                                array2={[]}
                                            />
                                        )}
                                        {checkVisiblity(true, config.footAndAnkle.slice(1)) && (
                                            <SpecialitiesBreakdownCompLandscape
                                                image={"/assets/images/footAndAnkle2.png"}
                                                array1={config.footAndAnkle.slice(1)}
                                                array2={[]}
                                            />
                                        )}
                                    </td>
                                </tr>
                            )}




                        {/*   Video Endoscopy Tower Systems   */}
                        {checkVisiblity(
                            ((config.specialties[0].value > 0 ||
                                config.specialties[8].value > 0 ||
                                config.specialties[10].value > 0 ||
                                config.specialties[11].value > 0) &&
                                (config.facility_all_option[1].value === "Low temp" ||
                                    config.facility_all_option[1].value === "Both" ||
                                    config.facility_all_option[1].value === "I don't know yet.")) ||
                            config.isManual,
                            [...config.videoEndoscopy]
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Video Systems/Towers</div>

                                        {checkVisiblity(true, config.videoEndoscopy) && (
                                            <SpecialitiesBreakdownCompLandscape
                                                image={"/assets/images/videoendoscopy.png"}
                                                array1={config.videoEndoscopy}
                                                array2={[]}
                                            />
                                        )}

                                    </td>
                                </tr>
                            )}

                        {/*    Video Endoscopy System- Precision/Autoclavable   */}
                        {checkVisiblity(
                            ((config.specialties[0].value > 0 ||
                                config.specialties[8].value > 0 ||
                                config.specialties[10].value > 0 ||
                                config.specialties[11].value > 0) &&
                                config.facility_all_option[1].value ===
                                "High Temp/autoclave only") ||
                            config.isManual,
                            [...config.videoEndcscopyautoclavable]
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Video Systems/Towers - Precision/Autoclavable
                                        </div>

                                        {checkVisiblity(
                                            config.facility_all_option[1].value ===
                                            "High Temp/autoclave only" || config.isManual,
                                            config.videoEndcscopyautoclavable
                                        ) && (
                                                <SpecialitiesBreakdownCompLandscape
                                                    image={"/assets/images/videoauto.jpeg"}
                                                    array1={config.videoEndcscopyautoclavable}
                                                    array2={[]}
                                                />
                                            )}
                                    </td>
                                </tr>
                            )}

                        {checkVisiblity(
                            ((config.facility_all_option[1].value === "Low temp" ||
                                config.facility_all_option[1].value ===
                                "High Temp/autoclave only" ||
                                config.facility_all_option[1].value === "Both" ||
                                config.facility_all_option[1].value === "I don't know yet.") &&
                                config.specialties[10].value > 0) ||
                            config.isManual,
                            [...config.scopesOption1]
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Insufflation</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/scopeoption.png"}
                                            array1={config.scopesOption1}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                        {checkVisiblity(
                            ((config.specialties[0].value > 0 ||
                                config.specialties[8].value > 0 ||
                                config.specialties[10].value > 0 ||
                                config.specialties[11].value > 0) &&
                                (config.facility_all_option[1].value === "Low temp" ||
                                    config.facility_all_option[1].value ===
                                    "High Temp/autoclave only" ||
                                    config.facility_all_option[1].value === "Both" ||
                                    config.facility_all_option[1].value === "I don't know yet.")) ||
                            config.isManual,
                            [...config.scopesOption2]
                        ) && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            Sinoscopes</div>

                                        {checkNullArray([...config.scopesOption2.slice(0, 1)]) && (
                                            <SpecialitiesBreakdownCompLandscape
                                                image={"/assets/images/scopesOption21.png"}
                                                array1={config.scopesOption2.slice(0, 1)}
                                                array2={[]}
                                            />
                                        )}
                                        {checkNullArray([...config.scopesOption2.slice(0, 1)]) && (
                                            <SpecialitiesBreakdownCompLandscape
                                                image={"/assets/images/scopesOption22.png"}
                                                array1={config.scopesOption2.slice(1)}
                                                array2={[]}
                                            />
                                        )}

                                    </td>
                                </tr>
                            )}
                        {config.serviceContract &&
                            config.serviceContract.qty > 0 && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            OnSite Services Program</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/serviceContract.png"}
                                            array1={[config.serviceContract]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                        {config.onSiteServicesProgram &&
                            config.onSiteServicesProgram.qty > 0 && (
                                <tr>
                                    <td>
                                        <br />
                                        <div style={{ ...pdfStyleLandscape.subtitle, marginLeft: -125 }}>

                                            OnSite Services Program</div>
                                        <SpecialitiesBreakdownCompLandscape
                                            image={"/assets/images/onsiteservicesprogram2.png"}
                                            array1={[config.onSiteServicesProgram]}
                                            array2={[]}
                                        />
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        </div >
    );

    const equipmentPlanHtml =
        ReactDOMServer.renderToStaticMarkup(equipmentPlanElement);
    const EquipmentPlanDoc = () => (
        <Document>
            <Page
                style={{ padding: 50 }}
            >
                <Html>{equipmentPlanHtml}</Html>
            </Page>
        </Document>
    );

    const equipmentPlanHtmlLandscape =
        ReactDOMServer.renderToStaticMarkup(equipmentPlanElementLandscape);
    const EquipmentPlanDocLandscape = () => (
        <Document>
            <Page orientation="landscape"
                style={{ padding: 50 }}
            >
                <Html>{equipmentPlanHtmlLandscape}</Html>
            </Page>
        </Document>
    );

    const implantsAndDisposablesElement = (
        <div style={pdfStyle.page}>
            <div style={pdfStyle.title}>Implants and Disposables</div>
            <div style={pdfStyle.subtitle}>{config.account_name}</div>
            <br />
            {config.implantSummary && (
                <div>
                    <div style={pdfStyle.subtitle}>Notes </div>
                    <div>{config.implantSummary}</div>
                </div>
            )}
            {/*   Implants and disposables */}
            {config.implants &&
                config.implants.map((implantGroup, groupIndex) => (
                    <div>
                        <div>
                            <div>
                                <table>
                                    <tbody>
                                        {implantGroup.implants.map((implant, implantIndex) => (
                                            <tr key={implantIndex}>
                                                <td>
                                                    <br />
                                                    {implantIndex == 0 && (
                                                        <div style={pdfStyle.titleUnderline}>
                                                            <div>{implantGroup.title}</div>
                                                            <br />
                                                        </div>
                                                    )}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            flexWrap: "nowrap",
                                                        }}
                                                    >
                                                        <div className={cls.subContainerLeft}>
                                                            <div style={pdfStyle.subtitle}>
                                                                {implant.subtitle}
                                                            </div>
                                                            <div style={{ paddingLeft: 150 }}>
                                                                <img
                                                                    src={`/assets/images/ImplantImagery/${implant.imageUrl}`}
                                                                    style={{ width: 158, height: 83 }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "row",
                                                                    justifyContent: "space-between",
                                                                    width: 300,
                                                                    marginLeft: 50,
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        fontWeight: 700,
                                                                        minWidth: 150,
                                                                        width: 150,
                                                                        color: "#bbb",
                                                                    }}
                                                                >
                                                                    PRODUCTS
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        fontWeight: 700,
                                                                        minWidth: 150,
                                                                        width: 150,
                                                                        color: "#bbb",
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    INCLUDE IN QUOTE
                                                                </div>
                                                            </div>
                                                            {implant.implantProducts.map(
                                                                (item, productIndex) => {
                                                                    return (
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                flexDirection: "row",
                                                                                justifyContent: "space-between",
                                                                                width: 300,
                                                                                marginLeft: 50,
                                                                            }}
                                                                        >
                                                                            <div
                                                                                style={{ minWidth: 150, width: 150 }}
                                                                            >
                                                                                {item.productName}
                                                                            </div>
                                                                            <div
                                                                                style={{
                                                                                    minWidth: 150,
                                                                                    width: 150,
                                                                                    textAlign: "right",
                                                                                }}
                                                                            >
                                                                                {item.isInQuote ? "Yes" : "No"}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                    </div>
                ))}
        </div>
    );

    const implantsAndDisposablesElementLandscape = (
        <div style={pdfStyleLandscape.page}>
            <div style={pdfStyleLandscape.title}>Implants and Disposables</div>
            <div style={pdfStyleLandscape.subtitle}>{config.account_name}</div>
            <br />
            {config.implantSummary && (
                <div>
                    <div style={pdfStyleLandscape.subtitle}>Notes </div>
                    <div>{config.implantSummary}</div>
                </div>
            )}
            {/*   Implants and disposables */}
            {config.implants &&
                config.implants.map((implantGroup, groupIndex) => (
                    <div>
                        <div>
                            <div>
                                <table>
                                    <tbody>
                                        {implantGroup.implants.map((implant, implantIndex) => (
                                            <tr key={implantIndex}>
                                                <td>
                                                    <br />
                                                    {implantIndex == 0 && (
                                                        <div style={pdfStyleLandscape.titleUnderline}>
                                                            <div>{implantGroup.title}</div>
                                                            <br />
                                                        </div>
                                                    )}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            flexWrap: "nowrap",
                                                        }}
                                                    >
                                                        <div className={cls.subContainerLeft}>
                                                            <div style={pdfStyleLandscape.subtitle}>
                                                                {implant.subtitle}
                                                            </div>
                                                            <div style={{ paddingLeft: 150 }}>
                                                                <img
                                                                    src={`/assets/images/ImplantImagery/${implant.imageUrl}`}
                                                                    style={{ width: 158, height: 83 }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "row",
                                                                    justifyContent: "space-between",
                                                                    width: 500,
                                                                    marginLeft: 50,
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        fontWeight: 700,
                                                                        minWidth: 225,
                                                                        width: 225,
                                                                        color: "#bbb",
                                                                    }}
                                                                >
                                                                    PRODUCTS
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        fontWeight: 700,
                                                                        minWidth: 150,
                                                                        width: 150,
                                                                        color: "#bbb",
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    INCLUDE IN QUOTE
                                                                </div>
                                                            </div>
                                                            {implant.implantProducts.map(
                                                                (item, productIndex) => {
                                                                    return (
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                flexDirection: "row",
                                                                                justifyContent: "space-between",
                                                                                width: 500,
                                                                                marginLeft: 50,
                                                                            }}
                                                                        >
                                                                            <div
                                                                                style={{ minWidth: 225, width: 225 }}
                                                                            >
                                                                                {item.productName}
                                                                            </div>
                                                                            <div
                                                                                style={{
                                                                                    minWidth: 150,
                                                                                    width: 150,
                                                                                    textAlign: "right",
                                                                                }}
                                                                            >
                                                                                {item.isInQuote ? "Yes" : "No"}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                    </div>
                ))}
        </div>
    );

    const implantsAndDisposablesHtml = ReactDOMServer.renderToStaticMarkup(
        implantsAndDisposablesElement
    );
    const ImplantsAndDisposablesDoc = () => (
        <Document>
            <Page style={{ padding: 50 }}>
                <Html>{implantsAndDisposablesHtml}</Html>
            </Page>
        </Document>
    );

    const implantsAndDisposablesHtmlLandscape = ReactDOMServer.renderToStaticMarkup(
        implantsAndDisposablesElementLandscape
    );
    const ImplantsAndDisposablesDocLandscape = () => (
        <Document>
            <Page orientation="landscape" style={{ padding: 50 }}>
                <Html>{implantsAndDisposablesHtmlLandscape}</Html>
            </Page>
        </Document>
    );
    //return equipmentPlanElement;
    return (
        <ContainerVertical className={cls.container}>
            <ProductsDelete
                value={calNumRemoveProduct()}
                {...modalDeleteProductControls}
                onClickDelete={onClickDeleteProduct}
            />
            <ProfileDelete {...modalDeleteControls} onClickDelete={onClickDelete} />
            <ProfileDuplicate
                {...modalDuplicateControls}
                handleChange={handleChange}
                onClickDup={onClickDup}
                value={newName}
            />
            <ModalCopyLink
                {...modalCopyLinkControls}
                customerProfiledata={customerProfiledataTemp}
                handleUpdate={(data) => {
                    setCustomerProfiledataTemp(data);
                }}
            />
            <ModalAddCustomerSummary
                {...modalAddCustomerSummaryControls}
                customerProfiledata={customerProfiledataTemp}
                handleUpdate={(data, index) => {
                    dispatch(
                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                            ...customerProfiledataTemp,
                            config: { ...customerProfiledataTemp.config, ...data },
                        })
                    );
                    setCustomerProfiledataTemp({
                        ...customerProfiledataTemp,
                        config: { ...customerProfiledataTemp.config, ...data },
                    });
                }}
                handleDelete={(index) => {
                    let tmpData = { ...customerProfiledataTemp };
                    delete tmpData.config.customerSummary;
                    dispatch(
                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                            ...customerProfiledataTemp,
                            config: { ...tmpData.config },
                        })
                    );
                    setCustomerProfiledataTemp({ ...tmpData });
                }}
            />
            <ModalAddEquipmentSummary
                {...modalAddEquipmentSummaryControls}
                customerProfiledata={customerProfiledataTemp}
                handleUpdate={(data, index) => {
                    dispatch(
                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                            ...customerProfiledataTemp,
                            config: { ...customerProfiledataTemp.config, ...data },
                        })
                    );
                    setCustomerProfiledataTemp({
                        ...customerProfiledataTemp,
                        config: { ...customerProfiledataTemp.config, ...data },
                    });
                }}
                handleDelete={(index) => {
                    let tmpData = { ...customerProfiledataTemp };
                    delete tmpData.config.equipmentSummary;
                    dispatch(
                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                            ...customerProfiledataTemp,
                            config: { ...tmpData.config },
                        })
                    );
                    setCustomerProfiledataTemp({ ...tmpData });
                }}
            />
            <ModalAddSpecialtiesSummary
                {...modalAddspecialtiesSummaryControls}
                customerProfiledata={customerProfiledataTemp}
                handleUpdate={(data, index) => {
                    dispatch(
                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                            ...customerProfiledataTemp,
                            config: { ...customerProfiledataTemp.config, ...data },
                        })
                    );
                    setCustomerProfiledataTemp({
                        ...customerProfiledataTemp,
                        config: { ...customerProfiledataTemp.config, ...data },
                    });
                }}
                handleDelete={(index) => {
                    let tmpData = { ...customerProfiledataTemp };
                    delete tmpData.config.specialtiesSummary;
                    dispatch(
                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                            ...customerProfiledataTemp,
                            config: { ...tmpData.config },
                        })
                    );
                    setCustomerProfiledataTemp({ ...tmpData });
                }}
            />
            <ModalAddImplantSummary
                {...modalAddImplantSummaryControls}
                customerProfiledata={customerProfiledataTemp}
                handleUpdate={(data, index) => {
                    dispatch(
                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                            ...customerProfiledataTemp,
                            config: { ...customerProfiledataTemp.config, ...data },
                        })
                    );
                    setCustomerProfiledataTemp({
                        ...customerProfiledataTemp,
                        config: { ...customerProfiledataTemp.config, ...data },
                    });
                }}
                handleDelete={(index) => {
                    let tmpData = { ...customerProfiledataTemp };
                    delete tmpData.config.implantSummary;
                    dispatch(
                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                            ...customerProfiledataTemp,
                            config: { ...tmpData.config },
                        })
                    );
                    setCustomerProfiledataTemp({ ...tmpData });
                }}
            />
            <ModalUploadPL
                {...modalExportControls}
                onClickExport={onClickExport}
                downloadPdfButton={
                    <PDFDownloadLink
                        className={cls.btnUp}
                        document={<EquipmentPlanDoc />}
                        fileName={pdfFileNamePL}
                    >
                        <Button className={cls.button}>EXPORT</Button>
                    </PDFDownloadLink>
                }
                landscapePDFDownloadButton={
                    <PDFDownloadLink
                        className={cls.btnUp}
                        document={<EquipmentPlanDocLandscape />}
                        fileName={pdfFileNamePL}
                    >
                        <Button className={cls.button}>EXPORT (Horizonal)</Button>
                    </PDFDownloadLink>
                }

            />


            <ModalUploadPDFOnly
                {...modalExportPDFOnlyControls}
                onClickExport={onClickExport}
                downloadPdfButton={
                    <PDFDownloadLink
                        className={cls.btnUp}
                        document={<CustomerInfoDoc />}
                        fileName={pdfFileNamePL}
                    >
                        <Button className={cls.button}>EXPORT</Button>
                    </PDFDownloadLink>
                }
                landscapePDFDownloadButton={
                    <PDFDownloadLink
                        className={cls.btnUp}
                        document={<CustomerInfoDocLandscape />}
                        fileName={pdfFileNamePL}
                    >
                        <Button className={cls.button}>EXPORT</Button>
                    </PDFDownloadLink>
                }
            />

            {/* Specialties */}
            <ModalUploadPDFOnly
                {...modalExportPDFOnlySpecialtiesControls}
                onClickExport={onClickExport}
                downloadPdfButton={
                    <PDFDownloadLink
                        className={cls.btnUp}
                        document={<SpecialtiesDoc />}
                        fileName={fileSpecialties}
                    >
                        <Button className={cls.button}>EXPORT</Button>
                    </PDFDownloadLink>
                }
                landscapePDFDownloadButton={
                    <PDFDownloadLink
                        className={cls.btnUp}
                        document={<SpecialtiesDocLandscape />}
                        fileName={fileSpecialties}
                    >
                        <Button className={cls.button}>EXPORT</Button>
                    </PDFDownloadLink>
                }
            />


            <ModalUploadImplant
                {...modalExportImplantControls}
                onClickExport={onClickExportImplant}
                downloadPdfButton={
                    <PDFDownloadLink
                        className={cls.btnUp}
                        document={<ImplantsAndDisposablesDoc />}
                        fileName={pdfFileNameImplant}
                    >
                        <Button className={cls.button}>EXPORT</Button>
                    </PDFDownloadLink>
                }
                landscapeDownloadPDFButton={
                    <PDFDownloadLink
                        className={cls.btnUp}
                        document={<ImplantsAndDisposablesDocLandscape />}
                        fileName={pdfFileNameImplant}
                    >
                        <Button className={cls.button}>EXPORT</Button>
                    </PDFDownloadLink>
                }
            />
            <div className={cls.header}>
                <div className={cls.headerLeft}>
                    <Button
                        clear
                        Component={Link}
                        to="/app/customer-profiles/"
                        style={{ paddingLeft: 0 }}
                        className="back-button"
                    >
                        <Icon className={cls.icon}>arrow_left</Icon>
                        <div className="back-button__text">CUSTOMER PROFILES</div>
                    </Button>
                    <div className={cls.headerMain}>
                        <div className={cls.avatarWrapper}>
                            <div className={cls.avatar}>
                                {config.account_name.slice(0, 1)}
                            </div>
                        </div>
                        <div className={cls.headerDetail}>
                            {config.account_name}
                            <div className={cls.detainbottom}>
                                <div>
                                    <div className={cls.des}>CREATED</div>
                                    <div className={cls.val}>
                                        {Moment(customerProfiledataTemp.created_at).format(
                                            "h:mm a MM.DD.YYYY"
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <div className={cls.des}>LAST VIEWED</div>
                                    <div className={cls.val}>
                                        {Moment(customerProfiledataTemp.updated_at).format(
                                            "h:mm a MM.DD.YYYY"
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <div className={cls.des}>SUBMITTED BY</div>
                                    <div className={cls.val}>{`${customerProfiledataTemp.first_name ??
                                        user.data.user.first_name
                                        } ${customerProfiledataTemp.last_name ??
                                        user.data.user.last_name
                                        }`}</div>
                                </div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={cls.headerRight}>
                    <Button
                        onClick={() => {

                            exportToExcelTemplate();
                        }}
                    >Download report</Button>

                    <Dropdown
                        ButtonComponent={dropdownComponent}
                        menuPosition={"bottom-left" as DropdownMenuPosition}
                    >
                        <div>
                            <Button
                                clear
                                className={classNames(cls.dropbtn, cls.black)}
                                onClick={modalDuplicateControls.handleOpen}
                            >
                                DUPLICATE
                            </Button>
                            <div className={cls.dropline} />
                            <Button
                                clear
                                className={classNames(cls.dropbtn, cls.red)}
                                onClick={modalDeleteControls.handleOpen}
                            >
                                DELETE
                            </Button>
                        </div>
                    </Dropdown>
                </div>
            </div>
            <div>
                <div className={cls.tabBar}>
                    {[
                        "Customer info",
                        "Equipment plan",
                        "Specialties",
                        "Implants and disposables",
                    ].map((item, index) => {
                        return (
                            <div
                                className={index === tabIndex ? cls.tabItem_a : cls.tabItem_ia}
                                onClick={() => settabIndex(index)}
                                key={index}
                                style={{
                                    paddingTop: 15,
                                    paddingBottom: 10,
                                    marginRight: 20,
                                }}
                            >
                                {item}
                            </div>
                        );
                    })}
                </div>
            </div>
            {tabIndex == 0 && (
                <div>
                    <div className={cls.grayBar}>
                        <Button
                            square
                            className={cls.btnUp}
                            onClick={() => {
                                modalExportPDFOnlyControls.handleOpen();
                            }}
                        >
                            <PublishIcon />
                        </Button>




                        {/*     <PDFDownloadLink
              className={cls.btnUp}
              document={<CustomerInfoDoc />}
              fileName={fileName}
            >
               <Button
                square
                className={cls.btnUp}
                onClick={() => {
                  modalExportPDFOnlyControls.handleOpen();
                }}
              >
                <PublishIcon />
              </Button>

              {({ blob, url, loading, error }) =>
                loading ? "Loading document..." : "Download now!"
              }
            </PDFDownloadLink> */}
                        <Button
                            square
                            className={cls.btnEdit}
                            onClick={() => {
                                dispatch(appActions.setModalOpen());
                                history.push("/app/modal", {
                                    isEdit: true,
                                    initVal: customerProfiledata,
                                    page: 0,
                                });
                            }}
                        >
                            <EditOutlinedIcon
                                className={cls["edit-outlined-icon"]}
                                style={{ color: "white" }}
                            />
                        </Button>
                    </div>
                    <div className={cls.bottomWrapper}>
                        {config.customerSummary ? (
                            <div className={cls.summaryWrapper}>
                                <ContainerHorizontal className={cls.summaryHeader}>
                                    <div>Notes </div>
                                    <Button
                                        className={cls.editSummaryBtn}
                                        square
                                        onClick={() => {
                                            modalAddCustomerSummaryControls.handleOpen();
                                        }}
                                    >
                                        <EditOutlinedIcon className={cls.editSummaryIcon} />
                                    </Button>
                                </ContainerHorizontal>
                                <div className={cls.grayLine}></div>
                                <div className={cls.detailText}>{config.customerSummary}</div>
                            </div>
                        ) : (
                            <Button
                                className={cls.btnAddSummary}
                                onClick={() => {
                                    modalAddCustomerSummaryControls.handleOpen();
                                }}
                            >
                                <AddOutlinedIcon className={cls["add-outlined-icon"]} />
                                Add Notes
                            </Button>
                        )}
                        <div className={cls.label}>Customer information</div>
                        <div className={cls.pair}>
                            <div className={cls.des}>ACCOUNT / PROJECT NAME</div>
                            <div className={cls.val}>{config.account_name}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>STREET ADDRESS</div>
                            <div className={cls.val}>{config.streetAddress}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>CITY</div>
                            <div className={cls.val}>{config.city}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>STATE/PROVINCE</div>
                            <div className={cls.val}>{config.state}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>ZIP CODE/POSTAL CODE</div>
                            <div className={cls.val}>{config.zip}</div>
                        </div>



                        <div className={cls.label}>Customer Background</div>
                        <div className={cls.pair}>
                            <div className={cls.des}>INITIAL CUSTOMER MEETING DATE</div>
                            <div className={cls.val}>{config.initial_customer_meeting_date}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>NEW OR EXISTING STRYKER CUSTOMER?</div>
                            <div className={cls.val}>{config.stryker_customer}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>ASC TYPE</div>
                            <div className={cls.val}>{config.asc_type}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>PROJECT TYPE (NT)</div>
                            <div className={cls.val}>{config.project_type}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>HOSPITAL TYPE</div>
                            <div className={cls.val}>{config.hospital_type}</div>
                        </div>
                        {/*           <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>NEW BUILD OR EXISTING?</div>
                            <div className={cls.val}>{`NEED TO LOOK INTO IT`}</div>
                        </div> */}
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>IS THERE A MAKO INCLUDED?</div>
                            <div className={cls.val}>{config.mako_included}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>WHAT IS THE STRATEGIC PARTNERSHIP?</div>
                            <div className={cls.val}>{config.strategic_partnership}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>GPO AFFILIATION</div>
                            <div className={cls.val}>{config.gpo_affiliation}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>COMPETITIVE LANDSCAPE</div>
                            <div className={cls.val}>{config.competitive_landscape}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>CUSTOMER CONTACT</div>
                            <div className={cls.val}>{config.customer_contact}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>1A CONTACTS</div>
                            <div className={cls.val}>{config.one_a_contacts}</div>
                        </div>
                        <div style={{ height: 20 }} />
                        <div className={cls.pair}>
                            <div className={cls.des}>WHERE ARE YOU AT WITH CONTRUCTION, HIRING ARCHITECTS, AND SUBMITTING APPLICATIONS?</div>
                            <div className={cls.val}>{config.construction_architects_applications}</div>
                        </div>
                        <div style={{ height: 20 }} />










                        <div className={cls.label}>Project Type</div>

                        <div className={cls.pair}>
                            <div className={cls.des}>
                                WHAT BEST DEFINES YOUR CURRENT ASC PROJECTS
                            </div>
                            <div className={cls.val}>{config.asc}</div>
                        </div>

                        {config.asc === "De Novo / New Build ASC" || config.asc === "New Build" && (
                            <div className={cls.pair}>
                                <div className={cls.des}>
                                    HAVE YOU PARTNERED WITH A HEALTHCARE DEVELOPER?
                                </div>
                                <div className={cls.val}>{config.healthcare_partner}</div>
                            </div>
                        )}

                        <div className={cls.pair}>
                            <div className={cls.des}>
                                HAVE YOU PARTNERED WITH AN ASC MANAGEMENT COMPANY YET?
                            </div>
                            <div className={cls.val}>{config.asc_management_partner}</div>
                        </div>


                        <div className={cls.pair}>
                            <div className={cls.des}>HAVE YOU HIRED AN ARCHITECT YET?</div>
                            <div className={cls.val}>{config.hired}</div>
                        </div>

                        <div className={cls.pair}>
                            <div className={cls.des}>HAVE YOU HIRED A MEDICAL EQUIPMENT PLANNER YET?</div>
                            <div className={cls.val}>{config.hired_medical_equipment_planner}</div>
                        </div>

                        <div className={cls.pair}>
                            <div className={cls.des}>HAVE YOU PERFORMED A FEASIBILITY STUDY?</div>
                            <div className={cls.val}>{config.performed_feasibility_study}</div>
                        </div>

                        <div className={cls.pair}>
                            <div className={cls.des}>DOES YOUR STATE HAVE CON LAWS?</div>
                            <div className={cls.val}>{config.has_con_laws}</div>
                        </div>

                        {config.has_con_laws.toLowerCase() == "yes" && (
                            <div className={cls.pair}>
                                <div className={cls.des}>HAVE YOU SUBMITTED A CON APPLICATION?</div>
                                <div className={cls.val}>{config.submitted_con_application}</div>
                            </div>
                        )}

                        <div className={cls.pair}>
                            <div className={cls.des}>HAS CONSTRUCTION STARTED?</div>
                            <div className={cls.val}>{config.started}</div>
                        </div>

                        <div className={cls.pair}>
                            <div className={cls.des}>DO YOU HAVE A SLATED OPENING DATE?</div>
                            <div className={cls.val}>{config.has_slated_opening_date}</div>
                        </div>

                        {config.has_slated_opening_date.toLowerCase() == "yes" && (
                            <div className={cls.pair}>
                                <div className={cls.des}>SLATED DATE OF OPENING?</div>
                                <div className={cls.val}>{config.date_opend}</div>
                            </div>
                        )}

                        {/*  <div className={cls.pair}>
                            <div className={cls.des}>ARE YOU PARTNERING WITH A SOFTWARE PLATFORM TO MANAGE YOUR ASC OPERATIONS, SUCH AS SCHEDULING, BILLING, AND ELECTRONIC CHARTING?</div>
                            <div className={cls.val}>{config.has_software_platform}</div>
                        </div> */}


                        {!config.isManual && (
                            <div className={cls.label}>Facility ownership module</div>
                        )}
                        {!config.isManual &&
                            config.owner_ship.map((item, index) =>
                                item.value ? (
                                    <div
                                        className={classNames(cls.pair, cls.buttonpair)}
                                        key={index}
                                    >
                                        <div className={cls.labelpercent}>{`${item.value}%`}</div>
                                        <div className={cls.val}>
                                            {item.label == "Hospital/IDN"
                                                ? `${item.label} - ${config.owner_ship_hospital}`
                                                : item.label == "Management company"
                                                    ? `${item.label} - ${config.owner_ship_company}`
                                                    : item.label}
                                        </div>
                                    </div>
                                ) : null
                            )}

                        {!config.isManual &&
                            config.owner_ship_addions.map((item, index) =>
                                item.value ? (
                                    <div
                                        className={classNames(cls.pair, cls.buttonpair)}
                                        key={index}
                                    >
                                        <div className={cls.labelpercent}>{`${item.value}%`}</div>
                                        <div className={cls.val}>{item.label}</div>
                                    </div>
                                ) : null
                            )}
                        {!config.isManual && (config.asc === "De Novo / New Build ASC" || config.asc === "New Build") &&
                            config.facility_new.map((item, index) =>
                                item.value.length > 0 ? (
                                    <div key={index}>
                                        {index === 0 && (
                                            <div className={cls.label}>Operating rooms</div>
                                        )}
                                        {index === 1 && (
                                            <div className={cls.label}>Procedure rooms</div>
                                        )}
                                        {index === 2 && (
                                            <div className={cls.label}>Patient bays</div>
                                        )}
                                        {index === 4 && (
                                            <div className={cls.label}>Lobby / waiting rooms</div>
                                        )}
                                        {index === 5 && (
                                            <div className={cls.label}>Overnight stays (23hours)</div>
                                        )}
                                        <div className={cls.pair}>
                                            <div className={cls.des}>{item.label.toUpperCase()}</div>
                                            <div className={cls.val}>{item.value}</div>
                                        </div>
                                    </div>
                                ) : null
                            )}

                        {/* {config.facility_existing.map((item, index) =>
              item.value.length > 0 ? (
                <div key={index}>
                  {index === 0 && (
                    <div className={cls.label}>Operating rooms</div>
                  )}
                  {index === 3 && (
                    <div className={cls.label}>Procedure rooms</div>
                  )}
                  {index === 4 && <div className={cls.label}>Patient bays</div>}
                  <div className={cls.pair}>
                    <div className={cls.des}>{item.label}</div>
                    <div className={cls.val}>{item.value}</div>
                  </div>
                </div>
              ) : null
            )} */}
                        {!config.isManual && (config.asc === "Expansion / Construction of Existing ASC" || config.asc === "Existing") &&
                            config.facility_expanding.map((item, index) =>
                                item.value.length > 0 ? (
                                    <div key={index}>
                                        {index === 0 && (
                                            <div className={cls.label}>Operating rooms</div>
                                        )}
                                        {index === 3 && (
                                            <div className={cls.label}>Procedure rooms</div>
                                        )}
                                        {index === 5 && (
                                            <div className={cls.label}>Patient bays</div>
                                        )}
                                        {index === 8 && (
                                            <div className={cls.label}>Lobby / waiting rooms</div>
                                        )}
                                        {index === 10 && (
                                            <div className={cls.label}>Overnight stays (23hours)</div>
                                        )}
                                        <div className={cls.pair}>
                                            <div className={cls.des}>{item.label.toUpperCase()}</div>
                                            <div className={cls.val}>{item.value}</div>
                                        </div>
                                    </div>
                                ) : null
                            )}










                        {!config.isManual &&
                            config.facility_all_option.map((item, index) =>
                                item.value.length > 0 ? (
                                    <div key={index}>
                                        {index === 0 && (
                                            <div className={cls.label}>Sterilization</div>
                                        )}
                                        <div className={cls.pair}>
                                            <div className={cls.des}>{item.label.toUpperCase()}</div>
                                            <div className={cls.val}>{item.value}</div>
                                        </div>
                                    </div>
                                ) : null
                            )}
                        <div style={{ height: 20 }} />
                        {!config.isManual && (
                            <div className={cls.pair}>
                                <div className={cls.des}>
                                    ADDITIONAL PROJECT / CUSTOMER NOTES:
                                </div>
                                <div className={cls.val}>{config.facility_note}</div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {tabIndex == 2 && (
                <div>
                    <div className={cls.grayBar}>
                        {/* <PDFDownloadLink
              className={cls.btnUp}
              document={<SpecialtiesDoc />}
              fileName={fileSpecialties}
            >
              <Button square className={cls.btnUp}>
                <PublishIcon />
              </Button>
            </PDFDownloadLink> */}
                        <Button
                            square
                            className={cls.btnUp}
                            onClick={() => {
                                modalExportPDFOnlySpecialtiesControls.handleOpen();
                            }}
                        >
                            <PublishIcon />
                        </Button>
                        <Button
                            square
                            className={cls.btnEdit}
                            onClick={() => {
                                dispatch(appActions.setModalOpen());
                                history.push("/app/modal", {
                                    isEdit: true,
                                    initVal: customerProfiledata,
                                    page: 3,
                                });
                            }}
                        >
                            <EditOutlinedIcon
                                className={cls["edit-outlined-icon"]}
                                style={{ color: "white" }}
                            />
                        </Button>
                    </div>
                    <div className={cls.bottomWrapper}>
                        {config.specialtiesSummary ? (
                            <div className={cls.summaryWrapper}>
                                <ContainerHorizontal className={cls.summaryHeader}>
                                    <div>Notes </div>
                                    <Button
                                        className={cls.editSummaryBtn}
                                        square
                                        onClick={() => {
                                            modalAddspecialtiesSummaryControls.handleOpen();
                                        }}
                                    >
                                        <EditOutlinedIcon className={cls.editSummaryIcon} />
                                    </Button>
                                </ContainerHorizontal>
                                <div className={cls.grayLine}></div>
                                <div className={cls.detailText}>
                                    {config.specialtiesSummary}
                                </div>
                            </div>
                        ) : (
                            <Button
                                className={cls.btnAddSummary}
                                onClick={() => {
                                    modalAddspecialtiesSummaryControls.handleOpen();
                                }}
                            >
                                <AddOutlinedIcon className={cls["add-outlined-icon"]} />
                                Add Notes
                            </Button>
                        )}
                        {!config.isManual && (
                            <div className={cls.label}>ASC Specialties</div>
                        )}
                        {/* <div className={cls.surgeon}>Surgeons</div> */}
                        {config.specialties.map((item, index) => {
                            if (item.value > 0) {
                                return (
                                    <div key={index} className={cls.specialty}>
                                        <div className={classNames(cls.pair, cls.buttonpair)}>
                                            <div className={cls.subContainerRow}>
                                                <div className={cls.left}>
                                                    <img
                                                        src={`/assets/images/specialties/${item.image ? item.image : "generalSurgery.png"
                                                            }`}
                                                        className={cls.image}
                                                    />
                                                </div>
                                                <div className={cls.right}>
                                                    <div className={cls.label}>{item.label}</div>
                                                    <div
                                                        className={cls.value}
                                                    >{`${item.value} Surgeons`}</div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div style={{ height: 10, width: "100%" }} /> */}
                                        {index !== 0 && (
                                            <div className={cls.subBottom}>
                                                <div className={cls.leftborder}></div>
                                                <div>
                                                    <div className={cls.pair}>
                                                        <div className={cls.des}>
                                                            {`ESTIMATED ${item.label.toUpperCase()} CASES PER MONTH`}
                                                        </div>
                                                        <div className={cls.val}>
                                                            {item?.estimatedPerMonth || 0}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {index === 0 && (
                                            <div className={cls.subBottom}>
                                                <div className={cls.leftborder}></div>
                                                <div>
                                                    {parseInt(config.smsub.smdrop[0]) > 0 && (
                                                        <div className={cls.pair}>
                                                            <div className={cls.des}>
                                                                HOW MANY OF YOUR ORS WILL SPORTS MEDICINE CASES
                                                                BE PERFORMED IN?
                                                            </div>
                                                            <div className={cls.val}>
                                                                {config.smsub.smdrop[0]}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div style={{ height: 10, width: "100%" }} />
                                                    {parseInt(config.smsub.smdrop[1]) > 0 && (
                                                        <div className={cls.pair}>
                                                            <div className={cls.des}>
                                                                HOW MANY SPORTS CASES PER DAY?
                                                            </div>
                                                            <div className={cls.val}>
                                                                {config.smsub.smdrop[1]}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div style={{ height: 10, width: "100%" }} />
                                                    {parseInt(config.smsub.smdrop[2]) > 0 && (
                                                        <div className={cls.pair}>
                                                            <div className={cls.des}>
                                                                HOW MANY HIP ARTHROSCOPISTS WILL OPERATE
                                                                SIMULTANEOUSLY IN A SINGLE DAY?
                                                            </div>
                                                            <div className={cls.val}>
                                                                {config.smsub.smdrop[2]}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div style={{ height: 10, width: "100%" }} />
                                                    <div className={cls.pair}>
                                                        <div className={cls.des}>
                                                            SELECT ALL SUBSPECIALTIES THAT APPLY AND THEIR
                                                            CASE MIX PERCENTAGES. MUST EQUAL 100%
                                                        </div>
                                                        {config.smsub.smary.map((element, i) => {
                                                            if (element.value > 0) {
                                                                return (
                                                                    <div className={cls.subspec} key={i}>
                                                                        <div
                                                                            style={{ width: 60 }}
                                                                        >{`${element.value}%`}</div>
                                                                        <div>{element.label}</div>
                                                                    </div>
                                                                );
                                                            } else {
                                                                return null;
                                                            }
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {index === 1 && (
                                            <div className={cls.subBottom}>
                                                <div className={cls.leftborder}></div>
                                                <div>
                                                    <div className={cls.pair}>
                                                        <div className={cls.des}>
                                                            HOW MANY ORS WILL YOU BE DOING TOTAL JOINTS IN?
                                                        </div>
                                                        <div className={cls.val}>{config.jpsub1}</div>
                                                    </div>
                                                    {config.jpsub2 === "Yes" && (
                                                        <div className={cls.pair}>
                                                            <div className={cls.des}>
                                                                WHICH APPLICATIONS WOULD YOU LIKE TO SEE
                                                                PROPOSALS FOR THAT FACTOR IN THE POSSIBLITY OF
                                                                MAKO SMARTROBOTICS?
                                                            </div>
                                                            {/* <div className={cls.val}>{i}</div> */}
                                                            {config.jpsub.map((item, index) => {
                                                                return item.value ? (
                                                                    <div className={cls.val}>{item.label}</div>
                                                                ) : null;
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {index === 3 && (
                                            <div className={cls.subBottom}>
                                                <div className={cls.leftborder}></div>
                                                <div>
                                                    {config.sp1.length > 0 ? (
                                                        <div className={cls.pair}>
                                                            <div className={cls.des}>
                                                                WILL YOU BE DESIRING IMAGING WITH NAVIGATION OR
                                                                IMAGING ONLY?
                                                            </div>
                                                            <div className={cls.val}>{config.sp1}</div>
                                                        </div>
                                                    ) : null}
                                                    {config.sp2.length > 0 ? (
                                                        <div className={cls.pair} style={{ marginTop: 10 }}>
                                                            <div className={cls.des}>
                                                                WILL FLUOROSCOPY (2D) NAVIGATION OR 3D
                                                                NAVIGATION BE DESIRED?
                                                            </div>
                                                            <div className={cls.val}>{config.sp2}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )}
                                        {index === 8 && config.entNav.length > 0 && (
                                            <div className={cls.subBottom}>
                                                <div className={cls.leftborder} />
                                                <div className={cls.pair}>
                                                    <div className={cls.des}>
                                                        Would you like to see a proposal that factors in the
                                                        possibility of ENT navigation?
                                                    </div>
                                                    <div className={cls.val}>{config.entNav}</div>
                                                </div>
                                            </div>
                                        )}
                                        {index === 12 && (
                                            <div className={cls.subBottom}>
                                                <div className={cls.leftborder}></div>
                                                <div>
                                                    {config.eyeNewfacility.value.length > 0 &&
                                                        config.asc === "De Novo / New Build ASC" || config.asc === "New Build" ? (
                                                        <div className={cls.pair}>
                                                            <div className={cls.des}>
                                                                {config.eyeNewfacility.label}
                                                            </div>
                                                            <div className={cls.val}>
                                                                {config.eyeNewfacility.value}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                    {config.eyeExpandingfacility.value.length > 0 &&
                                                        config.asc ===
                                                        "Expansion / Construction of Existing ASC" ? (
                                                        <div className={cls.pair}>
                                                            <div className={cls.des}>
                                                                {config.eyeExpandingfacility.label.toUpperCase()}
                                                            </div>
                                                            <div className={cls.val}>
                                                                {config.eyeExpandingfacility.value}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )}
                                        <div style={{ height: 10, width: "100%" }} />
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                        {config.specialties_addtions.map((item, index) => {
                            if (item.value > 0) {
                                return (
                                    <div key={index}>
                                        <div className={classNames(cls.pair, cls.buttonpair)}>
                                            <div className={cls.labelpercent}>{item.value}</div>
                                            <div className={cls.val}>{item.label}</div>
                                        </div>
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                </div>
            )}
            {tabIndex == 1 && (
                <div>
                    {isEdit ? (
                        <div className={cls.grayBar}>
                            <Button
                                className={cls.savebtn}
                                onClick={() => {
                                    const tmpUpdate = {
                                        ...customerProfiledataTemp,
                                        config: { ...customerProfiledataTemp.config },
                                    };
                                    delete tmpUpdate["first_name"];
                                    delete tmpUpdate["last_name"];
                                    dispatch(
                                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                                            ...tmpUpdate,
                                        })
                                    );
                                    setisEdit(false);
                                    setCustomerProfiledataTemp({ ...customerProfiledataTemp });
                                }}
                            >
                                <CheckCircleOutlineOutlinedIcon className={cls.saveIcon} />
                                SAVE EDITS
                            </Button>
                            <div style={{ width: 10 }} />
                            <Button
                                className={cls.cancelbtn}
                                onClick={() => {
                                    setisEdit(false);
                                    setCustomerProfiledataTemp({ ...customerProfiledata });
                                }}
                            >
                                <CloseIcon
                                    className={cls.saveIcon}
                                    style={{ color: "white" }}
                                />
                                CANCEL
                            </Button>
                        </div>
                    ) : (
                        <div className={cls.grayBar}>
                            <Button
                                square
                                className={cls.btnlink}
                                onClick={() => {
                                    modalCopyLinkControls.handleOpen();
                                }}
                            >
                                <LinkOutlinedIcon className={cls["link-out-icon"]} />
                            </Button>
                            <Button
                                square
                                className={cls.btnUp}
                                onClick={() => {
                                    modalExportControls.handleOpen();
                                    /* tony */
                                }}
                            >
                                <PublishIcon />
                            </Button>

                            <Button
                                square
                                className={cls.btnEdit}
                                onClick={() => setisEdit(true)}
                            >
                                <EditOutlinedIcon
                                    className={cls["edit-outlined-icon"]}
                                    style={{ color: "white" }}
                                />
                            </Button>
                        </div>
                    )}
                    <div className={cls.bottomWrapper}>
                        {config.equipmentSummary ? (
                            <div className={cls.summaryWrapper}>
                                <ContainerHorizontal className={cls.summaryHeader}>
                                    <div>Notes </div>
                                    <Button
                                        className={cls.editSummaryBtn}
                                        square
                                        onClick={() => {
                                            modalAddEquipmentSummaryControls.handleOpen();
                                        }}
                                    >
                                        <EditOutlinedIcon className={cls.editSummaryIcon} />
                                    </Button>
                                </ContainerHorizontal>
                                <div className={cls.grayLine}></div>
                                <div className={cls.detailText}>{config.equipmentSummary}</div>
                            </div>
                        ) : (
                            <Button
                                className={cls.btnAddSummary}
                                onClick={() => {
                                    modalAddEquipmentSummaryControls.handleOpen();
                                }}
                            >
                                <AddOutlinedIcon className={cls["add-outlined-icon"]} />
                                Add Notes
                            </Button>
                        )}
                    </div>
                    <div className={cls.bottomWrapper}>
                        <div className={cls.summaryWrapper}>
                            <ContainerHorizontal className={cls.summaryHeader}>
                                <div>Equipment plan summary </div>
                                <button
                                    className={cls.btnSquare}
                                    onClick={() => {
                                        let tmp = [...isCollapsed];
                                        tmp[33] = !tmp[33];
                                        setIsCollapsed(tmp);
                                    }}
                                >
                                    {isCollapsed[33] ? <DownIcon /> : <UpIcon />}
                                </button>
                            </ContainerHorizontal>
                            <div className={cls.grayLine}></div>
                            <div
                                className={`${isCollapsed[33] ? cls.collapsed : ""} ${cls.planSummaryDetail
                                    }`}
                            >
                                <div className={cls.verticalGap}></div>

                                {checkNullArray([
                                    ...config.standardORs,
                                    ...config.isuitORs,
                                ]) && (
                                        <div className={cls.column}>
                                            <EquipmentSummaryItem
                                                title={
                                                    "Operating room infrastructure (Booms, Lights, Tables, etc.)"
                                                }
                                                products={filterSummaryValue([
                                                    ...config.standardORs,
                                                    ...config.isuitORs,
                                                ])}
                                            />
                                        </div>
                                    )}
                                {checkNullArray([...config.makoSmartRobotics]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"Robotics"}
                                            products={[...config.makoSmartRobotics]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([...config.wasteManagements]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"Waste Management"}
                                            products={[...config.wasteManagements]}
                                        />
                                    </div>
                                )}
                                {checkNullArray([...config.saftySpongeSystem]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"Safety Sponge System"}
                                            products={[...config.saftySpongeSystem]}
                                        />
                                    </div>
                                )}

                                {config.safeAir && checkNullArray([...config.safeAir]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"SafeAir"}
                                            products={[...config.safeAir]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([...config.generalStretchers]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"General Stretchers"}
                                            products={[...config.generalStretchers]}
                                        />
                                    </div>
                                )}
                                {checkNullArray([config.patienWarning]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"Patient Warming"}
                                            products={[config.patienWarning]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([config.transportChairs]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"Transport Chairs"}
                                            products={[config.transportChairs]}
                                        />
                                    </div>
                                )}
                                {checkNullArray([config.surgeonStools]) && (


                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"Surgeon Stools"}
                                            products={[config.surgeonStools]}
                                        />
                                    </div>


                                )}

                                {checkNullArray([...config.patientBayFurniture]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"Furniture"}
                                            products={[...config.patientBayFurniture]}
                                        />
                                    </div>
                                )}
                                {checkNullArray([...config.overnightBayRoomFurniture]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"Furniture"}
                                            products={[...config.overnightBayRoomFurniture]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([...config.lobbyRoomFurniture]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"Furniture"}
                                            products={[...config.lobbyRoomFurniture]}
                                        />
                                    </div>
                                )}
                                {checkNullArray([...config.spineNavigations]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"Spine Navigation, Software, and Imaging"}
                                            products={[...config.spineNavigations]}
                                        />
                                    </div>
                                )}
                                {checkNullArray([...config.spineInstrumentation]) &&
                                    config.specialties[3].value > 0 && (
                                        <div className={cls.column}>
                                            <EquipmentSummaryItem
                                                title={"Spine Instrumentation"}
                                                products={[...config.spineInstrumentation]}
                                            />
                                        </div>
                                    )}
                                {checkNullArray([...config.crashcartsDefibrillators]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"AEDs, Crash Carts, Defibrillators"}
                                            products={[...config.crashcartsDefibrillators]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([...config.emergencyPreparedness]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"Emergency Preparedness"}
                                            products={[...config.emergencyPreparedness]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([...config.vocera]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"Communication Technology"}
                                            products={[...config.vocera]}
                                        />
                                    </div>
                                )}


                                {checkVisiblity(
                                    true,
                                    config.powerTools
                                ) && (
                                        <div className={cls.column}>
                                            <EquipmentSummaryItem
                                                className={cls.column}
                                                title={"Power Tools"}
                                                products={[...config.powerTools]}
                                            />
                                        </div>
                                    )}



                                {checkNullArray([...config.tourniquet]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"Tourniquet System"}
                                            products={[...config.tourniquet]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([...config.surgicalHelmets]) &&
                                    checkVisiblity(
                                        parseInt(config.jpsub1) > 0 || config.isManual,
                                        config.surgicalHelmets
                                    ) && (
                                        <div className={cls.column}>
                                            <EquipmentSummaryItem
                                                title={"Surgical Helmets"}
                                                products={[...config.surgicalHelmets]}
                                            />
                                        </div>
                                    )}

                                {checkNullArray([
                                    ...config.sportMedicine,
                                    ...config.sportInstrumentation,
                                    ...config.sportAccessories,
                                    ...config.sportsKneeInstrumentation,
                                    ...config.sportsHipInstrumentation,
                                    ...config.sportMedicineHipArthroscopy,
                                    ...config.sportMedicineFootAnkle,
                                ]) &&
                                    checkVisiblity(
                                        config.specialties[0].value > 0 || config.isManual,
                                        [
                                            ...config.sportMedicine,
                                            ...config.sportInstrumentation,
                                            ...config.sportAccessories,
                                            ...config.sportsKneeInstrumentation,
                                            ...config.sportsHipInstrumentation,
                                            ...config.sportMedicineHipArthroscopy,
                                            ...config.sportMedicineFootAnkle,
                                        ]
                                    ) && (
                                        <div className={cls.column}>
                                            <EquipmentSummaryItem
                                                title={"Sports Medicine"}
                                                products={[
                                                    ...config.sportMedicine,
                                                    ...config.sportInstrumentation,
                                                    ...config.sportAccessories,
                                                    ...config.sportsKneeInstrumentation,
                                                    ...config.sportsHipInstrumentation,
                                                    ...config.sportMedicineHipArthroscopy,
                                                    ...config.sportMedicineFootAnkle,
                                                ]}
                                            />
                                        </div>
                                    )}
                                {checkNullArray([
                                    ...config.entNavigation,
                                    ...config.entDrills,
                                ]) &&
                                    checkVisiblity(config.entNav === "Yes" || config.isManual, [
                                        ...config.entNavigation,
                                        ...config.entDrills,
                                    ]) && (
                                        <div className={cls.column}>
                                            <EquipmentSummaryItem
                                                className={cls.column}
                                                title={"ENT"}
                                                products={[
                                                    ...config.entNavigation,
                                                    ...config.entDrills,
                                                ]}
                                            />
                                        </div>
                                    )}

                                {checkNullArray([...config.painManagement]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"Pain Management Equipment"}
                                            products={[...config.painManagement]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([...config.footAndAnkle]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"Foot & Ankle"}
                                            products={[...config.footAndAnkle]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([...config.entDrills]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            title={"ENT Drills, Irrigation Systems and Accessories"}
                                            products={[...config.entDrills]}
                                        />
                                    </div>
                                )}

                                {checkNullArray([
                                    ...config.videoEndoscopy
                                ]) &&
                                    checkVisiblity(
                                        ((config.specialties[0].value > 0 ||
                                            config.specialties[8].value > 0 ||
                                            config.specialties[10].value > 0 ||
                                            config.specialties[11].value > 0) &&
                                            (config.facility_all_option[1].value === "Low temp" ||
                                                config.facility_all_option[1].value === "Both" ||
                                                config.facility_all_option[1].value ===
                                                "I don't know yet.")) ||
                                        config.isManual,
                                        [...config.videoEndoscopy]
                                    ) && (
                                        <div className={cls.column}>
                                            <EquipmentSummaryItem
                                                className={cls.column}
                                                title={"Video Systems/Towers"}
                                                products={[
                                                    ...config.videoEndoscopy
                                                ]}
                                            />
                                        </div>
                                    )}

                                {checkNullArray([...config.videoEndcscopyautoclavable]) &&
                                    checkVisiblity(
                                        ((config.specialties[0].value > 0 ||
                                            config.specialties[8].value > 0 ||
                                            config.specialties[10].value > 0 ||
                                            config.specialties[11].value > 0) &&
                                            config.facility_all_option[1].value ===
                                            "High Temp/autoclave only") ||
                                        config.isManual,
                                        [...config.videoEndcscopyautoclavable]
                                    ) && (
                                        <div className={cls.column}>
                                            <EquipmentSummaryItem
                                                className={cls.column}
                                                title={
                                                    "Video Endoscopy System- 4K Autoclavable"
                                                }
                                                products={[...config.videoEndcscopyautoclavable]}
                                            />
                                        </div>
                                    )}

                                {checkNullArray([...config.scopesOption1]) &&
                                    checkVisiblity(
                                        ((config.specialties[0].value > 0 ||
                                            config.specialties[8].value > 0 ||
                                            config.specialties[10].value > 0 ||
                                            config.specialties[11].value > 0) &&
                                            (config.facility_all_option[1].value === "Low temp" ||
                                                config.facility_all_option[1].value ===
                                                "High Temp/autoclave only" ||
                                                config.facility_all_option[1].value === "Both" ||
                                                config.facility_all_option[1].value ===
                                                "I don't know yet.")) ||
                                        config.isManual,
                                        [...config.scopesOption1]
                                    ) && (
                                        <div className={cls.column}>
                                            <EquipmentSummaryItem
                                                className={cls.column}
                                                title={"Insufflation"}
                                                products={[...config.scopesOption1]}
                                            />
                                        </div>
                                    )}
                                {/* {checkNullArray([
                  ...config.scopesOption2,
                ]) && (
                    <div className={cls.column}>
                      <EquipmentSummaryItem
                        className={cls.column}
                        title={"Sinuscopes"}
                        products={[
                          ...config.scopesOption2,
                        ]}
                      />
                    </div>
                  )} */}
                                {checkNullArray([config.serviceContract]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"Service Contract"}
                                            products={[config.serviceContract]}
                                        />
                                    </div>
                                )}
                                {checkNullArray([config.onSiteServicesProgram]) && (
                                    <div className={cls.column}>
                                        <EquipmentSummaryItem
                                            className={cls.column}
                                            title={"OnSite Services Program"}
                                            products={[config.onSiteServicesProgram]}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {/*   Operating Rooms  */}
                    {(checkVisiblity(
                        config.communication1.value > 0 || config.isManual,
                        config.standardORs
                    ) ||
                        checkVisiblity(
                            config.communication3.value > 0 || config.isManual,
                            config.isuitORs
                        )) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    <div>
                                        Operating room infrastructure (Booms, Lights, Tables, etc.)
                                    </div>
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[0] = !tmp[0];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[0] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[0] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={[
                                                "standardORs",
                                                "standardORsAddons",
                                                "isuitORs",
                                                "isuitORsAddons",
                                            ]}
                                            editInfo={"Note: One of each item per number of ORs."}
                                        />
                                    )}

                                    {/*  Standart Operating Rooms  */}
                                    {checkVisiblity(
                                        config.communication1.value > 0 || config.isManual,
                                        config.standardORs
                                    ) && (
                                            <div>
                                                <div style={{ height: 10, width: "100%" }} />
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        <div className={cls.imagecontainer}>
                                                            <img
                                                                src={"/assets/images/communication1.png"}
                                                                className={cls.image}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.lighttext
                                                            )}
                                                        >
                                                            <div
                                                                className={classNames(
                                                                    cls.partNum,
                                                                    cls["equipment-list__section-title"]
                                                                )}
                                                            >
                                                                PART NUMBER
                                                            </div>
                                                            <div
                                                                className={classNames(
                                                                    cls.product,
                                                                    cls["equipment-list__section-title"]
                                                                )}
                                                            >
                                                                PRODUCT
                                                            </div>
                                                            <div
                                                                className={classNames(
                                                                    cls.category,
                                                                    cls["equipment-list__section-title"]
                                                                )}
                                                            >
                                                                CATEGORY
                                                            </div>
                                                            <div
                                                                className={classNames(
                                                                    cls.qty,
                                                                    cls["equipment-list__section-title"]
                                                                )}
                                                            >
                                                                QTY
                                                            </div>
                                                        </div>
                                                        {config.standardORs.map((item, index) => {
                                                            return item.qty > 0 || isEdit ? (
                                                                <div
                                                                    className={classNames(
                                                                        cls.subContainerRow,
                                                                        cls.blackText
                                                                    )}
                                                                    key={index}
                                                                >
                                                                    <div className={cls.partNum}>
                                                                        {item.partNumber}
                                                                    </div>
                                                                    <div className={cls.product}>{item.product}</div>
                                                                    <div className={cls.category}>
                                                                        {item.category != ""
                                                                            ? item.category
                                                                            : "Standart Operating Rooms"}
                                                                    </div>
                                                                    <div className={cls.qty}>
                                                                        {isEdit ? (
                                                                            <TextField
                                                                                className={cls.textfiledBottom}
                                                                                value={item.qty?.toString()}
                                                                                onChange={(e) =>
                                                                                    onChangeText(
                                                                                        e.target.value,
                                                                                        index,
                                                                                        "standardORs"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            item.qty
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ) : null;
                                                        })}

                                                    </div>
                                                </div>
                                            </div>
                                        )}


                                    {/*  iSuite Rooms  */}
                                    {checkVisiblity(
                                        config.communication3.value > 0 || config.isManual,
                                        config.isuitORs
                                    ) && (
                                            <div>
                                                <div style={{ height: 10, width: "100%" }} />
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        <div className={cls.imagecontainer}>
                                                            <img
                                                                src={"/assets/images/communication3.png"}
                                                                className={cls.image}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.lighttext
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>PART NUMBER</div>
                                                            <div className={cls.product}>PRODUCT</div>
                                                            <div className={cls.category}>CATEGORY</div>
                                                            <div className={cls.qty}>QTY</div>
                                                        </div>
                                                        {config.isuitORs.map((item, index) => {
                                                            return item.qty > 0 || isEdit ? (
                                                                <div
                                                                    className={classNames(
                                                                        cls.subContainerRow,
                                                                        cls.blackText
                                                                    )}
                                                                    key={index}
                                                                >
                                                                    <div className={cls.partNum}>
                                                                        {item.partNumber}
                                                                    </div>
                                                                    <div className={cls.product}>{item.product}</div>
                                                                    <div className={cls.category}>
                                                                        {item.category}
                                                                    </div>
                                                                    <div className={cls.qty}>
                                                                        {isEdit ? (
                                                                            <TextField
                                                                                className={cls.textfiledBottom}
                                                                                value={item.qty?.toString()}
                                                                                onChange={(e) =>
                                                                                    onChangeText(
                                                                                        e.target.value,
                                                                                        index,
                                                                                        "isuitORs"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            item.qty
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ) : null;
                                                        })}
                                                        {(isEdit ||
                                                            (!isEdit &&
                                                                checkNullArray(config.isuitORsAddons))) && (
                                                                <div>
                                                                    <div style={{ height: 5, width: "100%" }} />
                                                                    <div className={cls.addons}>
                                                                        <div className={cls.lightline} />
                                                                        <div className={cls.addonText}>ADD ONS</div>
                                                                        <div className={cls.lightline} />
                                                                    </div>
                                                                    {config.isuitORsAddons.map((item, index) => {
                                                                        return item.qty > 0 || isEdit ? (
                                                                            <div
                                                                                className={classNames(
                                                                                    cls.subContainerRow,
                                                                                    cls.blackText
                                                                                )}
                                                                                key={index}
                                                                            >
                                                                                <div className={cls.partNum}>
                                                                                    {item.partNumber}
                                                                                </div>
                                                                                <div className={cls.product}>
                                                                                    {item.product}
                                                                                </div>
                                                                                <div className={cls.category}>
                                                                                    {item.category}
                                                                                </div>
                                                                                <div className={cls.qty}>
                                                                                    {isEdit ? (
                                                                                        <TextField
                                                                                            className={cls.textfiledBottom}
                                                                                            value={item.qty?.toString()}
                                                                                            onChange={(e) =>
                                                                                                onChangeText(
                                                                                                    e.target.value,
                                                                                                    index,
                                                                                                    "isuitORsAddons"
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    ) : (
                                                                                        item.qty
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        ) : null;
                                                                    })}
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        )}

                    {/* Mako Smart Robotics  */}
                    {checkVisiblity(
                        config.jpsub2 === "Yes" || config.isManual,
                        config.makoSmartRobotics
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Mako Smart Robotics
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[1] = !tmp[1];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[1] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[1] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["makoSmartRobotics"]}
                                            editInfo={""}
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/mako.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }} />
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.makoSmartRobotics.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>
                                                            {item.category != ""
                                                                ? item.category
                                                                : "Mako Smart Robotics"}
                                                        </div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "makoSmartRobotics"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {/*  Waste Management  */}
                    {checkVisiblity(
                        totalORRooms > 0 || config.isManual,
                        config.wasteManagements
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    <div> Waste Management </div>
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[2] = !tmp[2];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[2] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[2] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["wasteManagements", "wasteManagementsSwap", "wasteManagementAddons"]}
                                            editInfo={
                                                "Rules: One Neptune rover per number of ORs. One Neptune docking station per 4 ORs. One PharmaLock per number of ORs."
                                            }
                                        />
                                    )}
                                    {checkVisiblity(
                                        totalORRooms > 0 || config.isManual,
                                        config.wasteManagements.slice(0, 2)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/waste_rover.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.wasteManagements
                                                        .slice(0, 2)
                                                        .map((item, index) => {
                                                            return item.qty > 0 || isEdit ? (
                                                                <div
                                                                    className={classNames(
                                                                        cls.subContainerRow,
                                                                        cls.blackText
                                                                    )}
                                                                    key={index}
                                                                >
                                                                    <div className={cls.partNum}>
                                                                        {item.partNumber}
                                                                    </div>
                                                                    <div className={cls.product}>{item.product}</div>
                                                                    <div className={cls.category}>
                                                                        {item.category}
                                                                    </div>
                                                                    <div className={cls.qty}>
                                                                        {isEdit ? (
                                                                            <TextField
                                                                                className={cls.textfiledBottom}
                                                                                value={item.qty?.toString()}
                                                                                onChange={(e) =>
                                                                                    onChangeText(
                                                                                        e.target.value,
                                                                                        index,
                                                                                        "wasteManagements"
                                                                                    )
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            item.qty
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ) : null;
                                                        })}
                                                    {((isEdit &&
                                                        checkEmptyArray(config.wasteManagementsSwap)) ||
                                                        (!isEdit &&
                                                            checkNullArray(config.wasteManagementsSwap))) && (
                                                            <div>
                                                                <div className={cls.addons}>
                                                                    <div className={cls.lightline} />
                                                                    {isEdit ? (
                                                                        // <Button
                                                                        //   className={cls.addonText}
                                                                        //   style={{ width: 800 }}
                                                                        //   onClick={() => {
                                                                        //     let tem =
                                                                        //       customerProfiledataTemp.config
                                                                        //         .wasteManagements[0].qty;
                                                                        //     customerProfiledataTemp.config.wasteManagements[0].qty =
                                                                        //       customerProfiledataTemp.config.wasteManagementsSwap[0].qty;
                                                                        //     customerProfiledataTemp.config.wasteManagementsSwap[0].qty =
                                                                        //       tem;
                                                                        //     setCustomerProfiledataTemp({
                                                                        //       ...customerProfiledataTemp,
                                                                        //     });
                                                                        //   }}
                                                                        // >
                                                                        //   Swap to pre-owned
                                                                        // </Button>
                                                                        <></>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                    <div className={cls.lightline} />
                                                                </div>
                                                                {config.wasteManagementsSwap.map((item, index) => {
                                                                    return !item.isRemoved &&
                                                                        (item.qty > 0 || isEdit) ? (
                                                                        <div
                                                                            className={classNames(
                                                                                cls.subContainerRow,
                                                                                cls.blackText
                                                                            )}
                                                                            key={index}
                                                                        >
                                                                            <div className={cls.partNum}>
                                                                                {item.partNumber}
                                                                            </div>
                                                                            <div className={cls.product}>
                                                                                {item.product}
                                                                            </div>
                                                                            <div className={cls.category}>
                                                                                {item.category}
                                                                            </div>
                                                                            <div className={cls.qty}>
                                                                                {isEdit ? (
                                                                                    <TextField
                                                                                        className={cls.textfiledBottom}
                                                                                        value={item.qty?.toString()}
                                                                                        onChange={(e) =>
                                                                                            onChangeText(
                                                                                                e.target.value,
                                                                                                index,
                                                                                                "wasteManagementsSwap"
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                ) : (
                                                                                    item.qty
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ) : null;
                                                                })}
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        )}
                                    {checkVisiblity(
                                        totalORRooms > 0 || config.isManual,
                                        config.wasteManagements.slice(2)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/waste_or.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.wasteManagements.slice(2).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 2,
                                                                                    "wasteManagements"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                    <div style={{ height: 5, width: "100%" }} />

                                    {config.wasteManagementAddons.map((item, index) =>
                                        item.qty > 0 || isEdit ? (
                                            <div key={index}>
                                                <div style={{ height: 20, width: "100%" }} />
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}></div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        {index === 0 && (
                                                            <div className={cls.addons}>
                                                                <div className={cls.lightline} />
                                                                <div className={cls.addonText}>ADD ONS</div>
                                                                <div className={cls.lightline} />
                                                            </div>
                                                        )}
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>{item.category}</div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={item.qty?.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "wasteManagementAddons"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    item.qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            </div>
                        )}

                    {/*  sponge  */}
                    {checkVisiblity(
                        totalORRooms > 0 || config.isManual,
                        config.saftySpongeSystem
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    <div> Safety Sponge System </div>
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[3] = !tmp[3];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[3] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[3] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["saftySpongeSystem", "saftySpongeSystemAddons"]}
                                            editInfo={"Rule: One system per OR."}
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/SC+ Stand Kit- Sponge Counting.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.saftySpongeSystem.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "saftySpongeSystem"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>

                                    {checkVisiblity(totalORRooms > 0 || config.isManual, config.saftySpongeSystemAddons) && (
                                        <>
                                            <div style={{ height: 5, width: "100%" }} />

                                            <div className={cls.addons}>
                                                <div className={cls.lightline} />
                                                <div className={cls.addonText}>ADD ONS</div>
                                                <div className={cls.lightline} />
                                            </div>
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/SurgiCount+ Safety-Sponge System (Generation 2) .jpeg"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(cls.subContainerRow, cls.lighttext)}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.saftySpongeSystemAddons.map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index,
                                                                                    "saftySpongeSystemAddons"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>


                                        </>)}






                                </div>
                            </div>
                        )}

                    {/*  sponge  */}
                    {config.safeAir && checkVisiblity(
                        totalORRooms > 0 || config.isManual,
                        config.safeAir
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    <div>SafeAir</div>
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[3] = !tmp[3];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[3] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[3] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["safeAir"]}
                                            editInfo={"Rule: One system per OR."}
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/safeAir.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.safeAir.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "safeAir"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}


                    {/* General Stretchers */}
                    {(
                        checkVisiblityOne(
                            config.acutecare2.value > 0 || config.isManual,
                            config.generalStretchers[0]
                        )) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    <div>General Stretchers</div>
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[4] = !tmp[4];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[4] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[4] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["generalStretchers", "generalStretchersAddons"]}
                                            editInfo={
                                                "Note: Number of stretchers = Total number of ORs and bays."
                                            }
                                        />
                                    )}
                                    {[0].map((i) =>
                                        checkVisiblityOne(
                                            config[`acutecare2`].value > 0 || config.isManual,
                                            config.generalStretchers[i]
                                        ) ? (
                                            <div>
                                                <div style={{ height: 20, width: "100%" }} />
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        <div className={cls.imagecontainer}>
                                                            <img
                                                                src={"/assets/images/stretcher.png"}
                                                                className={cls.image}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.lighttext
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>PART NUMBER</div>
                                                            <div className={cls.product}>PRODUCT</div>
                                                            <div className={cls.category}>CATEGORY</div>
                                                            <div className={cls.qty}>QTY</div>
                                                        </div>

                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>
                                                                {config.generalStretchers[i].partNumber}
                                                            </div>
                                                            <div className={cls.product}>
                                                                {config.generalStretchers[i].product}
                                                            </div>
                                                            <div className={cls.category}>
                                                                {config.generalStretchers[i].category}
                                                            </div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={config.generalStretchers[
                                                                            i
                                                                        ].qty.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                i,
                                                                                "generalStretchers"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    config.generalStretchers[i].qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                    <div style={{ height: 5, width: "100%" }} />

                                    {config.generalStretchersAddons.map((item, index) =>
                                        item.qty > 0 || isEdit ? (
                                            <div key={index}>
                                                <div style={{ height: 20, width: "100%" }} />
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}></div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        {index === 0 && (
                                                            <div className={cls.addons}>
                                                                <div className={cls.lightline} />
                                                                <div className={cls.addonText}>ADD ONS</div>
                                                                <div className={cls.lightline} />
                                                            </div>
                                                        )}
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>{item.category}</div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={item.qty?.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "generalStretchersAddons"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    item.qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            </div>
                        )}

                    {/*   Patient Warming   */}
                    {checkVisiblityOne(
                        totalPostOPRooms > 0 || config.isManual,
                        config.patienWarning
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    <div>Patient Warming</div>
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[5] = !tmp[5];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[5] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[5] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["patienWarning"]}
                                            editInfo={
                                                "Note: One per OR, one per every 2 patient bays (both pre and post) + 2 floaters."
                                            }
                                        />
                                    )}
                                    <div style={{ height: 20, width: "100%" }} />
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/prewarming2.jpeg"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.patienWarning.qty > 0 || isEdit ? (
                                                <div
                                                    className={classNames(
                                                        cls.subContainerRow,
                                                        cls.blackText
                                                    )}
                                                >
                                                    <div className={cls.partNum}>
                                                        {config.patienWarning.partNumber}
                                                    </div>
                                                    <div className={cls.product}>
                                                        {config.patienWarning.product}
                                                    </div>
                                                    <div className={cls.category}>
                                                        {config.patienWarning.category}
                                                    </div>
                                                    <div className={cls.qty}>
                                                        {isEdit ? (
                                                            <TextField
                                                                className={cls.textfiledBottom}
                                                                value={config.patienWarning.qty.toString()}
                                                                onChange={(e) => {
                                                                    if (parseInt(e.target.value) === 0) {
                                                                        customerProfiledataTemp.config.patienWarning.qty = 0;
                                                                    } else {
                                                                        customerProfiledataTemp.config.patienWarning.qty =
                                                                            parseInt(e.target.value)
                                                                                ? parseInt(e.target.value)
                                                                                : 0;
                                                                    }
                                                                    setCustomerProfiledataTemp({
                                                                        ...customerProfiledataTemp,
                                                                    });
                                                                }}
                                                            />
                                                        ) : (
                                                            config.patienWarning.qty
                                                        )}
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    {/*   Transport Chairs   */}
                    {checkVisiblityOne(
                        totalORRooms > 0 || config.isManual,
                        config.transportChairs
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    <div>Transport Chairs</div>
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[6] = !tmp[6];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[6] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[6] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["transportChairs"]}
                                            editInfo={"Note: One transport chair per number of ORs. "}
                                        />
                                    )}
                                    <div style={{ height: 20, width: "100%" }} />
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/transport_chair.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.transportChairs.qty > 0 || isEdit ? (
                                                <div
                                                    className={classNames(
                                                        cls.subContainerRow,
                                                        cls.blackText
                                                    )}
                                                >
                                                    <div className={cls.partNum}>
                                                        {config.transportChairs.partNumber}
                                                    </div>
                                                    <div className={cls.product}>
                                                        {config.transportChairs.product}
                                                    </div>
                                                    <div className={cls.category}>
                                                        {config.transportChairs.category != ""
                                                            ? config.transportChairs.category
                                                            : "Transport Chairs"}
                                                    </div>
                                                    <div className={cls.qty}>
                                                        {isEdit ? (
                                                            <TextField
                                                                className={cls.textfiledBottom}
                                                                value={config.transportChairs.qty.toString()}
                                                                onChange={(e) => {
                                                                    if (parseInt(e.target.value) === 0) {
                                                                        customerProfiledataTemp.config.transportChairs.qty = 0;
                                                                    } else {
                                                                        customerProfiledataTemp.config.transportChairs.qty =
                                                                            parseInt(e.target.value)
                                                                                ? parseInt(e.target.value)
                                                                                : 0;
                                                                    }
                                                                    setCustomerProfiledataTemp({
                                                                        ...customerProfiledataTemp,
                                                                    });
                                                                }}
                                                            />
                                                        ) : (
                                                            config.transportChairs.qty
                                                        )}
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {/*   Surgeon Stools   */}
                    {checkVisiblityOne(
                        totalORRooms > 0 || config.isManual,
                        config.surgeonStools
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    <div>Surgeon Stools</div>
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[7] = !tmp[7];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[7] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[7] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["surgeonStools"]}
                                            editInfo={"Note: One stool per number of ORs."}
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/surgeon_stools.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.surgeonStools.qty > 0 || isEdit ? (
                                                <div
                                                    className={classNames(
                                                        cls.subContainerRow,
                                                        cls.blackText
                                                    )}
                                                >
                                                    <div className={cls.partNum}>
                                                        {config.surgeonStools.partNumber}
                                                    </div>
                                                    <div className={cls.product}>
                                                        {config.surgeonStools.product}
                                                    </div>
                                                    <div className={cls.category}>
                                                        {config.surgeonStools.category != ""
                                                            ? config.surgeonStools.category
                                                            : "Surgeon Stools"}
                                                    </div>
                                                    <div className={cls.qty}>
                                                        {isEdit ? (
                                                            <TextField
                                                                className={cls.textfiledBottom}
                                                                value={config.surgeonStools.qty.toString()}
                                                                onChange={(e) => {
                                                                    if (parseInt(e.target.value) === 0) {
                                                                        customerProfiledataTemp.config.surgeonStools.qty = 0;
                                                                    } else {
                                                                        customerProfiledataTemp.config.surgeonStools.qty =
                                                                            parseInt(e.target.value)
                                                                                ? parseInt(e.target.value)
                                                                                : 0;
                                                                    }
                                                                    setCustomerProfiledataTemp({
                                                                        ...customerProfiledataTemp,
                                                                    });
                                                                }}
                                                            />
                                                        ) : (
                                                            config.surgeonStools.qty
                                                        )}
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    {/* Patient Bay Furniture */}
                    {checkVisiblity(
                        totalPostOPRooms > 0 || config.isManual,
                        config.patientBayFurniture
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Patient Bay Furniture
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[8] = !tmp[8];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[8] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[8] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["patientBayFurniture"]}
                                            editInfo={
                                                "Note:\n• One overbed table per pre-op room and one per post-op room.\n• One patient room seating chair per pre-op room and one per post-op room."
                                            }
                                        />
                                    )}
                                    {config.patientBayFurniture.map((item, index) =>
                                        config.patientBayFurniture[index].qty > 0 || isEdit ? (
                                            <div>
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        <div className={cls.imagecontainer}>
                                                            {index === 0 ? (
                                                                <img
                                                                    src={"/assets/images/patient_furniture.png"}
                                                                    className={cls.image}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={"/assets/images/patient_furniture1.png"}
                                                                    className={cls.image}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.lighttext
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>PART NUMBER</div>
                                                            <div className={cls.product}>PRODUCT</div>
                                                            <div className={cls.category}>CATEGORY</div>
                                                            <div className={cls.qty}>QTY</div>
                                                        </div>

                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>
                                                                {item.category != ""
                                                                    ? item.category
                                                                    : "Patient Bay Furniture"}
                                                            </div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={config.patientBayFurniture[
                                                                            index
                                                                        ].qty.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "patientBayFurniture"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    config.patientBayFurniture[index].qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            </div>
                        )}
                    {/* Overnight Bay/Room Furniture */}
                    {checkVisiblity(
                        totalOvernightRooms > 0 || config.isManual,
                        config.overnightBayRoomFurniture
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Overnight Bay/Room Furniture
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[9] = !tmp[9];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[9] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[9] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["overnightBayRoomFurniture"]}
                                            editInfo={
                                                "Note:\n• One recliner bed per overnight bay/room.\n• One treatment recliner per overnight bay/room."
                                            }
                                        />
                                    )}
                                    {config.overnightBayRoomFurniture.map((item, index) =>
                                        config.overnightBayRoomFurniture[index].qty > 0 || isEdit ? (
                                            <div>
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        <div className={cls.imagecontainer}>
                                                            {index === 0 ? (
                                                                <img
                                                                    src={"/assets/images/overnight1.png"}
                                                                    className={cls.image}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={"/assets/images/overnight2.png"}
                                                                    className={cls.image}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.lighttext
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>PART NUMBER</div>
                                                            <div className={cls.product}>PRODUCT</div>
                                                            <div className={cls.category}>CATEGORY</div>
                                                            <div className={cls.qty}>QTY</div>
                                                        </div>

                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>
                                                                {item.category != ""
                                                                    ? item.category
                                                                    : "Overnight Bay/Room Furniture"}
                                                            </div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={config.overnightBayRoomFurniture[
                                                                            index
                                                                        ].qty.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "overnightBayRoomFurniture"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    config.overnightBayRoomFurniture[index].qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            </div>
                        )}
                    {/* Lobby/Waiting Room Furniture */}
                    {checkVisiblity(
                        totalLobbyRooms > 0 || config.isManual,
                        config.lobbyRoomFurniture
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Lobby/Waiting Room Furniture
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[10] = !tmp[10];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[10] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[10] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["lobbyRoomFurniture"]}
                                            editInfo={`Note:
                    • Waiting room chairs should double the total amount of pre-op and post-op bays (ie. 4 pre-op & 4 post-op bays = 16 chairs).
                    • Two bariatric chairs per lobby/waiting area.`}
                                        />
                                    )}
                                    {config.lobbyRoomFurniture.map((item, index) =>
                                        config.lobbyRoomFurniture[index].qty > 0 || isEdit ? (
                                            <div>
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        <div className={cls.imagecontainer}>
                                                            {index === 0 ? (
                                                                <img
                                                                    src={"/assets/images/lobby1.png"}
                                                                    className={cls.image}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={"/assets/images/lobby2.png"}
                                                                    className={cls.image}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.lighttext
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>PART NUMBER</div>
                                                            <div className={cls.product}>PRODUCT</div>
                                                            <div className={cls.category}>CATEGORY</div>
                                                            <div className={cls.qty}>QTY</div>
                                                        </div>

                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>
                                                                {item.category != ""
                                                                    ? item.category
                                                                    : "Lobby/Waiting Room Furniture"}
                                                            </div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={config.lobbyRoomFurniture[
                                                                            index
                                                                        ].qty.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "lobbyRoomFurniture"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    config.lobbyRoomFurniture[index].qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            </div>
                        )}




                    {/* {((config.specialties[3].value > 0 &&
            (
              ((config.sp1 === "Imaging only" ||
                (config.sp1 === "Imaging with navigation" &&
                  config.sp2 === "3D navigation")) &&
                config.spineNavigations
                  .reduce((a, b) => a + b.qty, 0) > 0))
          ) ||
            (config.isManual && isEdit) ||
            checkVisiblity(config.isManual, config.spineNavigations)) && (
              <div className={cls.bottomWrapper}>
                <div className={cls.bottomTitle}>
                  Spine Navigation, Software, and Imaging
                  <button
                    className={cls.btnSquare}
                    onClick={() => {
                      let tmp = [...isCollapsed];
                      tmp[11] = !tmp[11];
                      setIsCollapsed(tmp);
                    }}
                  >
                    {isCollapsed[11] ? <DownIcon /> : <UpIcon />}
                  </button>
                </div>
                <div className={cls.grayLine} />
                <div
                  className={`${isCollapsed[11] ? cls.collapsed : ""} ${cls.equipmentBox
                    }`}
                >
                  {isEdit && (
                    <ProductEditBar
                      products={["spineNavigations"]}
                      editInfo={
                        "Select Navigation platform + either 2D or 3D software. If imaging desired as well, select a standard or expanded view C-Arm."
                      }
                    />
                  )}
                  <div style={{ height: 20, width: "100%" }} />


                  {checkVisiblity(
                    config.sp1 === "Imaging only" ||
                    (config.sp1 === "Imaging with navigation" &&
                      config.sp2 === "3D navigation") ||
                    config.isManual,
                    config.spineNavigations
                  ) && (
                      <div className={cls.subContainer}>
                        <div className={cls.subContainerLeft}>
                          <div className={cls.imagecontainer}>
                            <img
                              src={"/assets/images/spinenav12.png"}
                              className={cls.image}
                            />
                          </div>
                        </div>
                        <div style={{ width: 20, height: "100%" }}></div>
                        <div className={cls.subContainerRight}>
                          <div
                            className={classNames(
                              cls.subContainerRow,
                              cls.lighttext
                            )}
                          >
                            <div className={cls.partNum}>PART NUMBER</div>
                            <div className={cls.product}>PRODUCT</div>
                            <div className={cls.category}>CATEGORY</div>
                            <div className={cls.qty}>QTY</div>
                          </div>
                          {config.spineNavigations.map((item, index) => {
                            return item.qty > 0 || isEdit ? (
                              <div
                                className={classNames(
                                  cls.subContainerRow,
                                  cls.blackText
                                )}
                                key={index}
                              >
                                <div className={cls.partNum}>{item.partNumber}</div>
                                <div className={cls.product}>{item.product}</div>
                                <div className={cls.category}>{item.category}</div>
                                <div className={cls.qty}>
                                  {isEdit ? (
                                    <TextField
                                      className={cls.textfiledBottom}
                                      value={item.qty?.toString()}
                                      onChange={(e) =>
                                        onChangeText(
                                          e.target.value,
                                          index,
                                          "spineNavigations"
                                        )
                                      }
                                    />
                                  ) : (
                                    item.qty
                                  )}
                                </div>
                              </div>
                            ) : null;
                          })}
                        </div>
                      </div>
                    )}
                </div>
              </div>
            )} */}


                    {checkVisiblity(
                        config.sp1 === 'Imaging with navigation' || config.isManual,
                        config.spineNavigations
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Spine Navigation, Software, and Imaging
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[12] = !tmp[12];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[12] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[12] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["spineNavigations"]}
                                            editInfo={
                                                "Note: One spine instrumentation package per facilty with a spine surgeon."
                                            }
                                        />
                                    )}

                                    <div style={{ height: 20, width: "100%" }} />

                                    {checkVisiblity(
                                        config.sp1 === "Imaging with navigation" ||
                                        config.isManual,
                                        config.spineNavigations.slice(0, 2)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/spinenav12.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.spineNavigations.slice(0, 2).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index,
                                                                                    "spineNavigations"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                    {/* Q Guidance System */}
                                    {checkVisiblity(
                                        config.sp1 === "Imaging with navigation" ||
                                        config.isManual,
                                        config.spineNavigations.slice(2, 5)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/Q Guidance System.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.spineNavigations.slice(2, 5).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 2,
                                                                                    "spineNavigations"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                    {/* {'Airo System'} */}
                                    {checkVisiblity(
                                        config.sp1 === "Imaging with navigation" ||
                                        config.isManual,
                                        config.spineNavigations.slice(5, 8)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/Airo System.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.spineNavigations.slice(5, 8).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 5,
                                                                                    "spineNavigations"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                    {/* {'SpineMask Tracker'} */}
                                    {checkVisiblity(
                                        config.sp1 === "Imaging with navigation" ||
                                        config.isManual,
                                        config.spineNavigations.slice(8)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/SpineMask Tracker.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.spineNavigations.slice(8).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 8,
                                                                                    "spineNavigations"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        )}


















                    {/* Spine Instrumentation  */}
                    {checkVisiblity(
                        config.specialties[3].value > 0 || config.isManual,
                        config.spineInstrumentation
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Spine Instrumentation
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[12] = !tmp[12];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[12] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[12] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["spineInstrumentation"]}
                                            editInfo={
                                                "Note: One spine instrumentation package per facilty with a spine surgeon."
                                            }
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/spineinstrument.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.spineInstrumentation.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "spineInstrumentation"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {checkVisiblity(
                        true || config.isManual,
                        config.crashcartsDefibrillators
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    AEDs, Crash Carts, Defibrillators
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[13] = !tmp[13];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[13] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[13] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["crashcartsDefibrillators"]}
                                            editInfo={
                                                "Note: One spine instrumentation package per facilty with a spine surgeon."
                                            }
                                        />
                                    )}

                                    <div style={{ height: 20, width: "100%" }} />

                                    {checkVisiblity(
                                        true ||
                                        config.isManual,
                                        config.crashcartsDefibrillators.slice(0, 3)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/aed0.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.crashcartsDefibrillators.slice(0, 3).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index,
                                                                                    "crashcartsDefibrillators"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                    {/* Lifepak 35 */}
                                    {checkVisiblity(
                                        true ||
                                        config.isManual,
                                        config.crashcartsDefibrillators.slice(3)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/lifepak35.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.crashcartsDefibrillators.slice(3).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 3,
                                                                                    "crashcartsDefibrillators"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        )}









                    {/* Emergency Preparedness  */}
                    {checkVisiblity(true, config.emergencyPreparedness.length > 3 ? config.emergencyPreparedness.slice(0, 1) : config.emergencyPreparedness) && (
                        <div className={cls.bottomWrapper}>
                            <div className={cls.bottomTitle}>
                                Emergency Preparedness
                                <button
                                    className={cls.btnSquare}
                                    onClick={() => {
                                        let tmp = [...isCollapsed];
                                        tmp[14] = !tmp[14];
                                        setIsCollapsed(tmp);
                                    }}
                                >
                                    {isCollapsed[14] ? <DownIcon /> : <UpIcon />}
                                </button>
                            </div>
                            <div className={cls.grayLine} />
                            <div
                                className={`${isCollapsed[14] ? cls.collapsed : ""} ${cls.equipmentBox
                                    }`}
                            >
                                {isEdit && (
                                    <ProductEditBar
                                        products={["emergencyPreparedness"]}
                                        editInfo={"Note: "}
                                    />
                                )}
                                <div className={cls.subContainer}>
                                    <div className={cls.subContainerLeft}>
                                        <div className={cls.imagecontainer}>
                                            <img
                                                src={"/assets/images/emergency.png"}
                                                className={cls.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: 20, height: "100%" }}></div>
                                    <div className={cls.subContainerRight}>
                                        <div
                                            className={classNames(cls.subContainerRow, cls.lighttext)}
                                        >
                                            <div className={cls.partNum}>PART NUMBER</div>
                                            <div className={cls.product}>PRODUCT</div>
                                            <div className={cls.category}>CATEGORY</div>
                                            <div className={cls.qty}>QTY</div>
                                        </div>
                                        {config.emergencyPreparedness.map((item, index) => {
                                            return item.qty > 0 || isEdit ? (
                                                <div
                                                    className={classNames(
                                                        cls.subContainerRow,
                                                        cls.blackText
                                                    )}
                                                    key={index}
                                                >
                                                    <div className={cls.partNum}>{item.partNumber}</div>
                                                    <div className={cls.product}>{item.product}</div>
                                                    <div className={cls.category}>{item.category}</div>
                                                    <div className={cls.qty}>
                                                        {isEdit ? (
                                                            <TextField
                                                                className={cls.textfiledBottom}
                                                                value={item.qty?.toString()}
                                                                onChange={(e) =>
                                                                    onChangeText(
                                                                        e.target.value,
                                                                        index,
                                                                        "emergencyPreparedness"
                                                                    )
                                                                }
                                                            />
                                                        ) : (
                                                            item.qty
                                                        )}
                                                    </div>
                                                </div>
                                            ) : null;
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {config.emergencyPreparedness.length == 4 && checkVisiblity(true, [...config.emergencyPreparedness]) && (
                        <div className={cls.bottomWrapper}>
                            <div className={cls.bottomTitle}>
                                Emergency Preparedness
                                <button
                                    className={cls.btnSquare}
                                    onClick={() => {
                                        let tmp = [...isCollapsed];
                                        tmp[14] = !tmp[14];
                                        setIsCollapsed(tmp);
                                    }}
                                >
                                    {isCollapsed[14] ? <DownIcon /> : <UpIcon />}
                                </button>
                            </div>
                            <div className={cls.grayLine} />
                            <div
                                className={`${isCollapsed[14] ? cls.collapsed : ""} ${cls.equipmentBox
                                    }`}
                            >
                                {isEdit && (
                                    <ProductEditBar
                                        products={["emergencyPreparedness"]}
                                        editInfo={"Note: "}
                                    />
                                )}
                                <div className={cls.subContainer}>
                                    <div className={cls.subContainerLeft}>
                                        <div className={cls.imagecontainer}>
                                            <img
                                                src={"/assets/images/emergency1.png"}
                                                className={cls.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: 20, height: "100%" }}></div>
                                    <div className={cls.subContainerRight}>
                                        <div
                                            className={classNames(cls.subContainerRow, cls.lighttext)}
                                        >
                                            <div className={cls.partNum}>PART NUMBER</div>
                                            <div className={cls.product}>PRODUCT</div>
                                            <div className={cls.category}>CATEGORY</div>
                                            <div className={cls.qty}>QTY</div>
                                        </div>
                                        {config.emergencyPreparedness.map((item, index) => {
                                            return item.qty > 0 || isEdit ? (
                                                <div
                                                    className={classNames(
                                                        cls.subContainerRow,
                                                        cls.blackText
                                                    )}
                                                    key={index}
                                                >
                                                    <div className={cls.partNum}>{item.partNumber}</div>
                                                    <div className={cls.product}>{item.product}</div>
                                                    <div className={cls.category}>{item.category}</div>
                                                    <div className={cls.qty}>
                                                        {isEdit ? (
                                                            <TextField
                                                                className={cls.textfiledBottom}
                                                                value={item.qty?.toString()}
                                                                onChange={(e) =>
                                                                    onChangeText(
                                                                        e.target.value,
                                                                        index,
                                                                        "emergencyPreparedness"
                                                                    )
                                                                }
                                                            />
                                                        ) : (
                                                            item.qty
                                                        )}
                                                    </div>
                                                </div>
                                            ) : null;
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* vocera */}
                    {checkVisiblity(
                        true || config.isManual,
                        config.vocera
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Communication Technology
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[132] = !tmp[132];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[132] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[132] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["vocera"]}
                                            editInfo={''}
                                        />
                                    )}

                                    <div style={{ height: 20, width: "100%" }} />

                                    {checkVisiblity(
                                        true ||
                                        config.isManual,
                                        config.spineNavigations.slice(0, 1)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/vocera1.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.vocera.slice(0, 1).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index,
                                                                                    "vocera"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                    {/* Q Guidance System */}
                                    {checkVisiblity(
                                        true ||
                                        config.isManual,
                                        config.vocera.slice(1)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/vocera2.jpeg"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.vocera.slice(1).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 1,
                                                                                    "vocera"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        )}







                    {/* Power Tools  */}
                    {(checkVisiblity(
                        config.jpsub1 && parseInt(config.jpsub1) > 0
                        || config.isManual,
                        config.powerTools.slice(0, 12)
                    ) ||
                        checkVisiblity(
                            config.specialties[4].value > 0 ||
                            config.specialties[5].value > 0 ||
                            config.isManual,
                            config.powerTools.slice(12, 25)
                        ) ||
                        checkVisiblity(
                            config.specialties[0].value > 0 || config.isManual,
                            config.powerTools.slice(25, 37)
                        ) ||
                        checkVisiblity(
                            config.specialties[3].value > 0 || config.isManual,
                            config.powerTools.slice(37)
                        )) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Power Tools
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[15] = !tmp[15];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[15] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[15] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["powerTools"]}
                                            editInfo={`Note: 
                    • 1 - 4 ORs, 3 total sets.
                    • 5 - 8 ORs, 5 total sets. 
                    • 8+ ORs, 7 total sets. `}
                                        />
                                    )}

                                    {checkVisiblity(
                                        config.jpsub1 && parseInt(config.jpsub1) > 0
                                        || config.isManual,
                                        config.powerTools.slice(0, 12)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/powertool5.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.powerTools.slice(0, 12).map((item, index) => {

                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index,
                                                                                    "powerTools"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}






                                    {checkVisiblity(
                                        config.specialties[4].value > 0 ||
                                        config.specialties[5].value > 0 ||
                                        config.isManual,
                                        config.powerTools.slice(12, 25)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/powertool1.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.powerTools.slice(12, 25).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 12,
                                                                                    "powerTools"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                    {checkVisiblity(
                                        config.specialties[0].value > 0 || config.isManual,
                                        config.powerTools.slice(25, 37)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/powertool6.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.powerTools.slice(25, 37).map((item, index) => {

                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 25,
                                                                                    "powerTools"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    {checkVisiblity(
                                        config.specialties[3].value > 0 || config.isManual,
                                        config.powerTools.slice(37)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/powertool3.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.powerTools.slice(37).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 37,
                                                                                    "powerTools"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}






                                </div>
                            </div>
                        )}



                    {/*     Tourniquet System    */}
                    {checkVisiblity(
                        totalORRooms > 0 || config.isManual,
                        config.tourniquet
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Tourniquet System
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[17] = !tmp[17];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[17] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[17] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["tourniquet"]}
                                            editInfo={"Note: One of each item per number of ORs. "}
                                        />
                                    )}

                                    <div style={{ height: 20, width: "100%" }} />
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/tourniquet.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.tourniquet.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "tourniquet"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {/*     Surgical Helmets    */}
                    {checkVisiblity(
                        parseInt(config.jpsub1) > 0 || config.isManual,
                        config.surgicalHelmets
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Surgical Helmets
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[18] = !tmp[18];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[18] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[18] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["surgicalHelmets"]}
                                            editInfo={
                                                "Note: One lighted helmet and three non-lighted helmets per OR doing TJR. One charger and 8 batteries per OR doing TJR. One wall rack per OR doing TJR."
                                            }
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/surgical.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.surgicalHelmets.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "surgicalHelmets"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {/*   Sports Medicine - Arthroscopy Capital    */}
                    {checkVisiblity(
                        config.specialties[0].value > 0 || config.isManual,
                        config.sportMedicine
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Sports Medicine - Arthroscopy Capital
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[19] = !tmp[19];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[19] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[19] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["sportMedicine"]}
                                            editInfo={
                                                "Note: One CrossFlow, CrossFire and CrossFire foot pedal per Sports Medicine OR. Two Crossfire handpieces per Sports Medicine OR."
                                            }
                                        />
                                    )}
                                    {config.sportMedicine.map((item, index) => {
                                        return item.qty > 0 || isEdit ? (
                                            <div>
                                                <div style={{ height: 20, width: "100%" }} />
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        {index == 0 && (
                                                            <div className={cls.imagecontainer}>
                                                                <img
                                                                    src={`/assets/images/sportsMedicine0.png`}
                                                                    className={cls.image}
                                                                />
                                                            </div>
                                                        )}
                                                        {index == 1 && (
                                                            <div className={cls.imagecontainer}>
                                                                <img
                                                                    src={`/assets/images/sportsMedicine1.png`}
                                                                    className={cls.image}
                                                                />
                                                            </div>
                                                        )}
                                                        {index == 2 && (
                                                            <div className={cls.imagecontainer}>
                                                                <img
                                                                    src={`/assets/images/crossfirefootpedal.png`}
                                                                    className={cls.image}
                                                                />
                                                            </div>
                                                        )}

                                                        {index == 3 && (
                                                            <div className={cls.imagecontainer}>
                                                                <img
                                                                    src={`/assets/images/crossfirehandpiece.png`}
                                                                    className={cls.image}
                                                                />
                                                            </div>
                                                        )}

                                                        {index == 4 && (
                                                            <div className={cls.imagecontainer}>
                                                                <img
                                                                    src={`/assets/images/cuttercannulaset.png`}
                                                                    className={cls.image}
                                                                />
                                                            </div>
                                                        )}
                                                        {index == 5 && (
                                                            <div className={cls.imagecontainer}>
                                                                <img
                                                                    src={`/assets/images/inspaceballoon.png`}
                                                                    className={cls.image}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(cls.subContainerRow, cls.lighttext)}
                                                        >
                                                            <div className={cls.partNum}>PART NUMBER</div>
                                                            <div className={cls.product}>PRODUCT</div>
                                                            <div className={cls.category}>CATEGORY</div>
                                                            <div className={cls.qty}>QTY</div>
                                                        </div>

                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                            key={index}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>{item.category}</div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={item.qty?.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "sportMedicine"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    item.qty
                                                                )}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        ) : null;
                                    })}
                                </div>
                            </div>
                        )}

                    {/*  Sports Medicine - shoulder Trays / Instrumentation   */}
                    {checkVisiblity(
                        (config.specialties[0].value > 0 &&
                            config.smsub.smary[2].value > 0) ||
                        config.isManual,
                        config.sportInstrumentation
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Sports Medicine - Shoulder Trays / Instrumentation
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[20] = !tmp[20];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[20] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[20] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["sportInstrumentation"]}
                                            editInfo={"Note: One tray per shoulder case per day."}
                                        />
                                    )}


                                    {config.sportInstrumentation.map((item, index) => {
                                        return item.qty > 0 || isEdit ? (

                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>

                                                    {index == 0 && (<div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/Championshoulderinstrumentationset.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>)}
                                                    {index == 1 && (<div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/AntegradeSuturePasser.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>)}
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(cls.subContainerRow, cls.lighttext)}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>

                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "sportInstrumentation"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>





                                                </div>
                                            </div>

                                        ) : null;
                                    })}

                                </div>
                            </div>
                        )}

                    {/*  Sports Medicine - shoulder OR Table Accessories   */}
                    {checkVisiblity(
                        (config.specialties[0].value > 0 &&
                            config.smsub.smary[2].value > 0) ||
                        config.isManual,
                        config.sportAccessories
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Sports Medicine - Shoulder OR Table Accessories
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[21] = !tmp[21];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[21] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[21] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["sportAccessories"]}
                                            editInfo={
                                                "Note: 1 per OR that will be doing concurrent shoulder procedures."
                                            }
                                        />
                                    )}
                                    {config.sportAccessories.map((item, index) => {
                                        return item.qty > 0 || isEdit ? (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    {index == 0 && (<div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/sportaccessories1.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>)}
                                                    {index == 1 && (<div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/sportAccessories2.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>)}
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(cls.subContainerRow, cls.lighttext)}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>

                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "sportAccessories"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>



                                        ) : null;
                                    })}

                                </div>
                            </div>
                        )}

                    {/*  Sports Medicine - Knee Trays / Instrumentation   */}
                    {checkVisiblity(
                        (config.specialties[0].value > 0 &&
                            config.smsub.smary[1].value > 0) ||
                        config.isManual,
                        config.sportsKneeInstrumentation
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Sports Medicine - Knee Trays / Instrumentation
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[22] = !tmp[22];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[22] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[22] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["sportsKneeInstrumentation"]}
                                            editInfo={"Note: One tray per knee case per day."}
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/spineinstrument.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.sportsKneeInstrumentation.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "sportsKneeInstrumentation"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {/*  Sports Medicine - Hip Trays / Instrumentation   */}
                    {checkVisiblity(
                        (config.specialties[0].value > 0 &&
                            config.smsub.smary[0].value > 0) ||
                        config.isManual,
                        config.sportsHipInstrumentation
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Sports Medicine - Hip Trays / Instrumentation
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[23] = !tmp[23];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[23] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[23] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["sportsHipInstrumentation"]}
                                            editInfo={"Note: One tray per hip case per day."}
                                        />
                                    )}
                                    {true && <div style={{ height: 20, width: "100%" }} />}
                                    {true && (
                                        <div className={cls.subContainer}>
                                            <div className={cls.subContainerLeft}>
                                                <div className={cls.imagecontainer}>
                                                    <img
                                                        src={"/assets/images/sportsHipInstrumentation.png"}
                                                        className={cls.image}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ width: 20, height: "100%" }}></div>
                                            <div className={cls.subContainerRight}>
                                                <div
                                                    className={classNames(
                                                        cls.subContainerRow,
                                                        cls.lighttext
                                                    )}
                                                >
                                                    <div className={cls.partNum}>PART NUMBER</div>
                                                    <div className={cls.product}>PRODUCT</div>
                                                    <div className={cls.category}>CATEGORY</div>
                                                    <div className={cls.qty}>QTY</div>
                                                </div>
                                                {config.sportsHipInstrumentation.map((item, index) => {
                                                    return item.qty > 0 || isEdit ? (
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                            key={index}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>{item.category}</div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={item.qty?.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "sportsHipInstrumentation"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    item.qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) : null;
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                    {/*    Sports Medicine - Hip Arthroscopy: Capital     */}
                    {checkVisiblity(
                        (config.specialties[0].value > 0 &&
                            config.smsub.smary[0].value > 0) ||
                        config.isManual,
                        config.sportMedicineHipArthroscopy
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Sports Medicine - Hip Arthroscopy: Capital
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[24] = !tmp[24];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[24] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[24] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["sportMedicineHipArthroscopy"]}
                                            editInfo={
                                                "Note: One of each item per OR that is doing hip arthroscopy."
                                            }
                                        />
                                    )}

                                    {config.sportMedicineHipArthroscopy.map((item, index) =>
                                        item.qty > 0 || isEdit ? (
                                            <div>
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        <div className={cls.imagecontainer}>
                                                            {index === 0 ? (
                                                                <img
                                                                    src={"/assets/images/sportarth0.png"}
                                                                    className={cls.image}
                                                                />
                                                            ) : index === 1 ? (
                                                                <img
                                                                    src={"/assets/images/sportarth1.png"}
                                                                    className={cls.image}
                                                                />
                                                            ) : (

                                                                <img
                                                                    src={"/assets/images/sportarth2.png"}
                                                                    className={cls.image}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.lighttext
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>PART NUMBER</div>
                                                            <div className={cls.product}>PRODUCT</div>
                                                            <div className={cls.category}>CATEGORY</div>
                                                            <div className={cls.qty}>QTY</div>
                                                        </div>

                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>{item.category}</div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={item.qty?.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "sportMedicineHipArthroscopy"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    item.qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            </div>
                        )}

                    {/*   Sports Medicine - Foot & Ankle Trays / Instrumentation    */}
                    {checkVisiblity(
                        (config.specialties[0].value > 0 &&
                            config.smsub.smary[3].value > 0) ||
                        config.isManual,
                        config.sportMedicineFootAnkle
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Sports Medicine - Foot & Ankle Trays / Instrumentation
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[25] = !tmp[25];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[25] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[25] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["sportMedicineFootAnkle"]}
                                            editInfo={"Note: One tray per foot & ankle case per day."}
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/sportMedicineFootAnkle.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.sportMedicineFootAnkle.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "sportMedicineFootAnkle"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {/*   ENT Navigation System    */}
                    {checkVisiblity(
                        config.entNav === "Yes" || config.isManual,
                        config.entNavigation
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    ENT Navigation System
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[26] = !tmp[26];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[26] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[26] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["entNavigation"]}
                                            editInfo={"Note: One per facility."}
                                        />
                                    )}

                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/entnavigation.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.entNavigation.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "entNavigation"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {/*   ENT Drills, Irrigation Systems and Accessories    */}
                    {/*
          {checkVisiblity(
            config.entNav === "Yes" ||
            config.specialties[8].value > 0 ||
            config.isManual,
            config.entDrills
          ) && (
              <div className={cls.bottomWrapper}>
                <div className={cls.bottomTitle}>
                  ENT Drills, Irrigation Systems and Accessories
                  <button
                    className={cls.btnSquare}
                    onClick={() => {
                      let tmp = [...isCollapsed];
                      tmp[27] = !tmp[27];
                      setIsCollapsed(tmp);
                    }}
                  >
                    {isCollapsed[27] ? <DownIcon /> : <UpIcon />}
                  </button>
                </div>
                <div className={cls.grayLine} />
                <div
                  className={`${isCollapsed[27] ? cls.collapsed : ""} ${cls.equipmentBox
                    }`}
                >
                  {isEdit && (
                    <ProductEditBar
                      products={["entDrills"]}
                      editInfo={"Note: One of each item per ENT facility."}
                    />
                  )}
                  <div className={cls.subContainer}>
                    <div className={cls.subContainerLeft}>
                      <div className={cls.imagecontainer}>
                        <img
                          src={"/assets/images/entdrill.png"}
                          className={cls.image}
                        />
                      </div>
                    </div>

                    <div style={{ width: 20, height: "100%" }}></div>
                    <div className={cls.subContainerRight}>
                      <div
                        className={classNames(cls.subContainerRow, cls.lighttext)}
                      >
                        <div className={cls.partNum}>PART NUMBER</div>
                        <div className={cls.product}>PRODUCT</div>
                        <div className={cls.category}>CATEGORY</div>
                        <div className={cls.qty}>QTY</div>
                      </div>
                      {config.entDrills.slice(0, 1).map((item, index) => {
                        return item.qty > 0 || isEdit ? (
                          <div
                            className={classNames(
                              cls.subContainerRow,
                              cls.blackText
                            )}
                            key={index}
                          >
                            <div className={cls.partNum}>{item.partNumber}</div>
                            <div className={cls.product}>{item.product}</div>
                            <div className={cls.category}>{item.category}</div>
                            <div className={cls.qty}>
                              {isEdit ? (
                                <TextField
                                  className={cls.textfiledBottom}
                                  value={item.qty?.toString()}
                                  onChange={(e) =>
                                    onChangeText(
                                      e.target.value,
                                      index,
                                      "entDrills"
                                    )
                                  }
                                />
                              ) : (
                                item.qty
                              )}
                            </div>
                          </div>
                        ) : null;
                      })}

                      {(isEdit ||
                        (!isEdit &&
                          checkNullArray(config.entDrills.slice(1)))) && (
                          <div>
                            <div style={{ height: 5, width: "100%" }} />
                            <div className={cls.addons}>
                              <div className={cls.lightline} />
                              <div className={cls.addonText}>ADD ONS</div>
                              <div className={cls.lightline} />
                            </div>
                            {config.entDrills.slice(1).map((item, index) => {
                              return item.qty > 0 || isEdit ? (
                                <div
                                  className={classNames(
                                    cls.subContainerRow,
                                    cls.blackText
                                  )}
                                  key={index}
                                >
                                  <div className={cls.partNum}>
                                    {item.partNumber}
                                  </div>
                                  <div className={cls.product}>
                                    {item.product}
                                  </div>
                                  <div className={cls.category}>
                                    {item.category}
                                  </div>
                                  <div className={cls.qty}>
                                    {isEdit ? (
                                      <TextField
                                        className={cls.textfiledBottom}
                                        value={item.qty?.toString()}
                                        onChange={(e) =>
                                          onChangeText(
                                            e.target.value,
                                            index,
                                            "entDrills" + 1
                                          )
                                        }
                                      />
                                    ) : (
                                      item.qty
                                    )}
                                  </div>
                                </div>
                              ) : null;
                            })}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )} */}




                    {/*  sponge  */}
                    {checkVisiblity(
                        config.entNav === "Yes" ||
                        config.specialties[8].value > 0 ||
                        config.isManual,
                        config.entDrills
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    <div>ENT Drills, Irrigation Systems and Accessories</div>
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[27] = !tmp[27];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[27] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[27] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["entDrills"]}
                                            editInfo={""}
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/entdrill.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.entDrills.slice(0, 1).map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "entDrills"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                    <div style={{ height: 5, width: "100%" }} />

                                    <div className={cls.addons}>
                                        <div className={cls.lightline} />
                                        <div className={cls.addonText}>ADD ONS</div>
                                        <div className={cls.lightline} />
                                    </div>
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/Cliq Suction Pump .png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.entDrills.slice(1).map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "entDrills" + 1
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}


                    {/*   Pain Management Equipment   */}
                    {checkVisiblity(
                        config.specialties[6].value > 0 || config.isManual,
                        config.painManagement
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Pain Management Equipment
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[29] = !tmp[29];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[29] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[29] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["painManagement"]}
                                            editInfo={
                                                "Note: One per facilty with 1 - 3 surgeons. Two per facilty with 4+ surgeons."
                                            }
                                        />
                                    )}
                                    <div className={cls.subContainer}>
                                        <div className={cls.subContainerLeft}>
                                            <div className={cls.imagecontainer}>
                                                <img
                                                    src={"/assets/images/painmanagement.png"}
                                                    className={cls.image}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ width: 20, height: "100%" }}></div>
                                        <div className={cls.subContainerRight}>
                                            <div
                                                className={classNames(cls.subContainerRow, cls.lighttext)}
                                            >
                                                <div className={cls.partNum}>PART NUMBER</div>
                                                <div className={cls.product}>PRODUCT</div>
                                                <div className={cls.category}>CATEGORY</div>
                                                <div className={cls.qty}>QTY</div>
                                            </div>
                                            {config.painManagement.map((item, index) => {
                                                return item.qty > 0 || isEdit ? (
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.blackText
                                                        )}
                                                        key={index}
                                                    >
                                                        <div className={cls.partNum}>{item.partNumber}</div>
                                                        <div className={cls.product}>{item.product}</div>
                                                        <div className={cls.category}>{item.category}</div>
                                                        <div className={cls.qty}>
                                                            {isEdit ? (
                                                                <TextField
                                                                    className={cls.textfiledBottom}
                                                                    value={item.qty?.toString()}
                                                                    onChange={(e) =>
                                                                        onChangeText(
                                                                            e.target.value,
                                                                            index,
                                                                            "painManagement"
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                item.qty
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}



                    {/* here */}


                    {/* FOOT & ANKLE */}
                    {checkVisiblity(
                        true || config.isManual,
                        config.footAndAnkle
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Foot and Ankle
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[133] = !tmp[133];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[133] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[133] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["footAndAnkle"]}
                                            editInfo={''}
                                        />
                                    )}

                                    <div style={{ height: 20, width: "100%" }} />

                                    {checkVisiblity(
                                        true ||
                                        config.isManual,
                                        config.footAndAnkle.slice(0, 1)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/footAndAnkle1.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.footAndAnkle.slice(0, 1).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index,
                                                                                    "footAndAnkle"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                    {/* Q Guidance System */}
                                    {checkVisiblity(
                                        true ||
                                        config.isManual,
                                        config.footAndAnkle.slice(1)
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/footAndAnkle2.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.footAndAnkle.slice(1).map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index + 1,
                                                                                    "footAndAnkle"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        )}

                    {/*   Video Endoscopy Tower Systems   */}
                    {checkVisiblity(
                        ((config.specialties[0].value > 0 ||
                            config.specialties[8].value > 0 ||
                            config.specialties[10].value > 0 ||
                            config.specialties[11].value > 0) &&
                            (config.facility_all_option[1].value === "Low temp" ||
                                config.facility_all_option[1].value === "Both" ||
                                config.facility_all_option[1].value === "I don't know yet.")) ||
                        config.isManual,
                        [
                            ...config.videoEndoscopy,
                            ...config.scopesOption1,
                            ...config.scopesOption2,
                        ]
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Video Systems/Towers
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[30] = !tmp[30];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[30] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[30] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["videoEndoscopy"]}
                                            editInfo={"Note: One tower per OR."}
                                        />
                                    )}
                                    {checkVisiblity(true, config.videoEndoscopy) && (
                                        <div className={cls.subContainer}>
                                            <div className={cls.subContainerLeft}>
                                                <div className={cls.imagecontainer}>
                                                    <img
                                                        src={"/assets/images/videoendoscopy.png"}
                                                        className={cls.image}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ width: 20, height: "100%" }}></div>
                                            <div className={cls.subContainerRight}>
                                                <div
                                                    className={classNames(
                                                        cls.subContainerRow,
                                                        cls.lighttext
                                                    )}
                                                >
                                                    <div className={cls.partNum}>PART NUMBER</div>
                                                    <div className={cls.product}>PRODUCT</div>
                                                    <div className={cls.category}>CATEGORY</div>
                                                    <div className={cls.qty}>QTY</div>
                                                </div>
                                                {config.videoEndoscopy.map((item, index) => {
                                                    return item.qty > 0 || isEdit ? (
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                            key={index}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>{item.category}</div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={item.qty?.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "videoEndoscopy"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    item.qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) : null;
                                                })}
                                            </div>
                                        </div>
                                    )}

                                    {/* checkVisiblity(
                  config.specialties[10].value > 0 || config.isManual,
                  config.scopesOption1
                ) && (
                  <div className={cls.subContainer}>
                    <div className={cls.subContainerLeft}>
                      <div className={cls.imagecontainer}>
                        <img
                          src={"/assets/images/scopeoption.png"}
                          className={cls.image}
                        />
                      </div>
                    </div>
                    <div style={{ width: 20, height: "100%" }}></div>
                    <div className={cls.subContainerRight}>
                      <div
                        className={classNames(
                          cls.subContainerRow,
                          cls.lighttext
                        )}
                      >
                        <div className={cls.partNum}>PART NUMBER</div>
                        <div className={cls.product}>PRODUCT</div>
                        <div className={cls.category}>CATEGORY</div>
                        <div className={cls.qty}>QTY</div>
                      </div>
                      {config.scopesOption1.map((item, index) => {
                        return item.qty > 0 || isEdit ? (
                          <div
                            className={classNames(
                              cls.subContainerRow,
                              cls.blackText
                            )}
                            key={index}
                          >
                            <div className={cls.partNum}>{item.partNumber}</div>
                            <div className={cls.product}>{item.product}</div>
                            <div className={cls.category}>{item.category}</div>
                            <div className={cls.qty}>
                              {isEdit ? (
                                <TextField
                                  className={cls.textfiledBottom}
                                  value={item.qty?.toString()}
                                  onChange={(e) =>
                                    onChangeText(
                                      e.target.value,
                                      index,
                                      "scopesOption1"
                                    )
                                  }
                                />
                              ) : (
                                item.qty
                              )}
                            </div>
                          </div>
                        ) : null;
                      })}
                    </div>
                  </div>
                ) */}
                                    {/* checkVisiblity(
                  config.specialties[8].value > 0 || config.isManual,
                  config.scopesOption2
                ) && (
                  <div className={cls.subContainer}>
                    <div className={cls.subContainerLeft}></div>
                    <div className={cls.subContainerRight}>
                      <div
                        className={classNames(
                          cls.subContainerRow,
                          cls.lighttext
                        )}
                      >
                        <div className={cls.partNum}>PART NUMBER</div>
                        <div className={cls.product}>PRODUCT</div>
                        <div className={cls.category}>CATEGORY</div>
                        <div className={cls.qty}>QTY</div>
                      </div>
                      {config.scopesOption2.map((item, index) => {
                        return item.qty > 0 || isEdit ? (
                          <div
                            className={classNames(
                              cls.subContainerRow,
                              cls.blackText
                            )}
                            key={index}
                          >
                            <div className={cls.partNum}>{item.partNumber}</div>
                            <div className={cls.product}>{item.product}</div>
                            <div className={cls.category}>{item.category}</div>
                            <div className={cls.qty}>
                              {isEdit ? (
                                <TextField
                                  className={cls.textfiledBottom}
                                  value={item.qty?.toString()}
                                  onChange={(e) =>
                                    onChangeText(
                                      e.target.value,
                                      index,
                                      "scopesOption2"
                                    )
                                  }
                                />
                              ) : (
                                item.qty
                              )}
                            </div>
                          </div>
                        ) : null;
                      })}
                    </div>
                  </div>
                ) */}
                                </div>
                            </div>
                        )}

                    {/*    Video Endoscopy System- Precision/Autoclavable   */}
                    {checkVisiblity(
                        ((config.specialties[0].value > 0 ||
                            config.specialties[8].value > 0 ||
                            config.specialties[10].value > 0 ||
                            config.specialties[11].value > 0) &&
                            config.facility_all_option[1].value ===
                            "High Temp/autoclave only") ||
                        config.isManual,
                        [...config.videoEndcscopyautoclavable]
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Video Systems/Towers - Precision/Autoclavable
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[31] = !tmp[31];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[31] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[31] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["videoEndcscopyautoclavable"]}
                                            editInfo={"Note: One camera system per OR."}
                                        />
                                    )}
                                    {checkVisiblity(
                                        config.facility_all_option[1].value ===
                                        "High Temp/autoclave only" || config.isManual,
                                        config.videoEndcscopyautoclavable
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/videoauto.jpeg"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.videoEndcscopyautoclavable.map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index,
                                                                                    "videoEndcscopyautoclavable"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        )}

                    {/* Insufflatoin */}
                    {checkVisiblity(
                        ((config.specialties[0].value > 0 ||
                            config.specialties[8].value > 0 ||
                            config.specialties[10].value > 0 ||
                            config.specialties[11].value > 0) &&
                            (config.facility_all_option[1].value === "Low temp" ||
                                config.facility_all_option[1].value ===
                                "High Temp/autoclave only" ||
                                config.facility_all_option[1].value === "Both" ||
                                config.facility_all_option[1].value === "I don't know yet.")) ||
                        config.isManual,
                        [...config.scopesOption1]
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Insufflation
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[34] = !tmp[34];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[34] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[34] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["scopesOption1"]}
                                            editInfo={
                                                "Note: One Insufflator per OR and 4 laparoscopes per surgeon."
                                            }
                                        />
                                    )}

                                    {checkVisiblity(
                                        config.specialties[10].value > 0 || config.isManual,
                                        config.scopesOption1
                                    ) && (
                                            <div className={cls.subContainer}>
                                                <div className={cls.subContainerLeft}>
                                                    <div className={cls.imagecontainer}>
                                                        <img
                                                            src={"/assets/images/scopeoption.png"}
                                                            className={cls.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ width: 20, height: "100%" }}></div>
                                                <div className={cls.subContainerRight}>
                                                    <div
                                                        className={classNames(
                                                            cls.subContainerRow,
                                                            cls.lighttext
                                                        )}
                                                    >
                                                        <div className={cls.partNum}>PART NUMBER</div>
                                                        <div className={cls.product}>PRODUCT</div>
                                                        <div className={cls.category}>CATEGORY</div>
                                                        <div className={cls.qty}>QTY</div>
                                                    </div>
                                                    {config.scopesOption1.map((item, index) => {
                                                        return item.qty > 0 || isEdit ? (
                                                            <div
                                                                className={classNames(
                                                                    cls.subContainerRow,
                                                                    cls.blackText
                                                                )}
                                                                key={index}
                                                            >
                                                                <div className={cls.partNum}>{item.partNumber}</div>
                                                                <div className={cls.product}>{item.product}</div>
                                                                <div className={cls.category}>{item.category}</div>
                                                                <div className={cls.qty}>
                                                                    {isEdit ? (
                                                                        <TextField
                                                                            className={cls.textfiledBottom}
                                                                            value={item.qty?.toString()}
                                                                            onChange={(e) =>
                                                                                onChangeText(
                                                                                    e.target.value,
                                                                                    index,
                                                                                    "scopesOption1"
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        item.qty
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        )}
                    {/* Sinuscopes */}
                    {checkVisiblity(
                        ((config.specialties[0].value > 0 ||
                            config.specialties[8].value > 0 ||
                            config.specialties[10].value > 0 ||
                            config.specialties[11].value > 0) &&
                            (config.facility_all_option[1].value === "Low temp" ||
                                config.facility_all_option[1].value ===
                                "High Temp/autoclave only" ||
                                config.facility_all_option[1].value === "Both" ||
                                config.facility_all_option[1].value === "I don't know yet.")) ||
                        config.isManual,
                        [...config.scopesOption2]
                    ) && (
                            <div className={cls.bottomWrapper}>
                                <div className={cls.bottomTitle}>
                                    Sinuscopes
                                    <button
                                        className={cls.btnSquare}
                                        onClick={() => {
                                            let tmp = [...isCollapsed];
                                            tmp[35] = !tmp[35];
                                            setIsCollapsed(tmp);
                                        }}
                                    >
                                        {isCollapsed[35] ? <DownIcon /> : <UpIcon />}
                                    </button>
                                </div>
                                <div className={cls.grayLine} />
                                <div
                                    className={`${isCollapsed[35] ? cls.collapsed : ""} ${cls.equipmentBox
                                        }`}
                                >
                                    {isEdit && (
                                        <ProductEditBar
                                            products={["scopesOption2"]}
                                            editInfo={"Note: Four sinuscopes per surgeon."}
                                        />
                                    )}


                                    {config.scopesOption2.map((item, index) =>
                                        item.qty > 0 || isEdit ? (
                                            <div>
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        <div className={cls.imagecontainer}>
                                                            {index === 0 ? (
                                                                <img
                                                                    src={"/assets/images/scopesOption21.png"}
                                                                    className={cls.image}
                                                                />
                                                            ) : index === 1 ? (
                                                                <img
                                                                    src={"/assets/images/scopesOption22.png"}
                                                                    className={cls.image}
                                                                />
                                                            ) : (

                                                                <></>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.lighttext
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>PART NUMBER</div>
                                                            <div className={cls.product}>PRODUCT</div>
                                                            <div className={cls.category}>CATEGORY</div>
                                                            <div className={cls.qty}>QTY</div>
                                                        </div>

                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.blackText
                                                            )}
                                                        >
                                                            <div className={cls.partNum}>{item.partNumber}</div>
                                                            <div className={cls.product}>{item.product}</div>
                                                            <div className={cls.category}>{item.category}</div>
                                                            <div className={cls.qty}>
                                                                {isEdit ? (
                                                                    <TextField
                                                                        className={cls.textfiledBottom}
                                                                        value={item.qty?.toString()}
                                                                        onChange={(e) =>
                                                                            onChangeText(
                                                                                e.target.value,
                                                                                index,
                                                                                "scopesOption2"
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    item.qty
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}






































                                    {/* {checkVisiblity(
                    config.specialties[8].value > 0 || config.isManual,
                    config.scopesOption2
                  ) && (
                      <div className={cls.subContainer}>
                        <div className={cls.subContainerLeft}>
                          <div className={cls.imagecontainer}>
                            <img
                              src={"/assets/images/scopeoption.png"}
                              className={cls.image}
                            />

                            <img
                              src={"/assets/images/scopeoption.png"}
                              className={cls.image}
                            />
                          </div>




                        </div>
                        <div className={cls.subContainerRight}>
                          <div
                            className={classNames(
                              cls.subContainerRow,
                              cls.lighttext
                            )}
                          >
                            <div className={cls.partNum}>PART NUMBER</div>
                            <div className={cls.product}>PRODUCT</div>
                            <div className={cls.category}>CATEGORY</div>
                            <div className={cls.qty}>QTY</div>
                          </div>
                          {config.scopesOption2.map((item, index) => {
                            return item.qty > 0 || isEdit ? (
                              <div
                                className={classNames(
                                  cls.subContainerRow,
                                  cls.blackText
                                )}
                                key={index}
                              >
                                <div className={cls.partNum}>{item.partNumber}</div>
                                <div className={cls.product}>{item.product}</div>
                                <div className={cls.category}>{item.category}</div>
                                <div className={cls.qty}>
                                  {isEdit ? (
                                    <TextField
                                      className={cls.textfiledBottom}
                                      value={item.qty?.toString()}
                                      onChange={(e) =>
                                        onChangeText(
                                          e.target.value,
                                          index,
                                          "scopesOption2"
                                        )
                                      }
                                    />
                                  ) : (
                                    item.qty
                                  )}
                                </div>
                              </div>
                            ) : null;
                          })}
                        </div>
                      </div>
                    )} */}
                                </div>
                            </div>
                        )}
                    {/*   Service Contract   */}
                    {checkVisiblityOne(true, config.serviceContract) && config.serviceContract && (
                        <div className={cls.bottomWrapper}>
                            <div className={cls.bottomTitle}>
                                ProCare Services
                                <button
                                    className={cls.btnSquare}
                                    onClick={() => {
                                        let tmp = [...isCollapsed];
                                        tmp[32] = !tmp[32];
                                        setIsCollapsed(tmp);
                                    }}
                                >
                                    {isCollapsed[32] ? <DownIcon /> : <UpIcon />}
                                </button>
                            </div>
                            <div className={cls.grayLine} />
                            <div
                                className={`${isCollapsed[32] ? cls.collapsed : ""} ${cls.equipmentBox
                                    }`}
                            >
                                {isEdit && (
                                    <ProductEditBar
                                        products={["serviceContract"]}
                                        editInfo={
                                            "Note: We recommend 1 to 2 OnSite specialists per facility."
                                        }
                                    />
                                )}
                                <div className={cls.subContainer}>
                                    <div className={cls.subContainerLeft}>
                                        <div className={cls.imagecontainer}>
                                            <img
                                                src={"/assets/images/serviceContract.png"}
                                                className={cls.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: 20, height: "100%" }}></div>
                                    <div className={cls.subContainerRight}>
                                        <div
                                            className={classNames(cls.subContainerRow, cls.lighttext)}
                                        >
                                            <div className={cls.partNum}>PART NUMBER</div>
                                            <div className={cls.product}>PRODUCT</div>
                                            <div className={cls.category}>CATEGORY</div>
                                            <div className={cls.qty}>QTY</div>
                                        </div>
                                        <div>
                                            <div
                                                className={classNames(
                                                    cls.subContainerRow,
                                                    cls.blackText
                                                )}
                                            >
                                                <div className={cls.partNum}>
                                                    {config.serviceContract.partNumber}
                                                </div>
                                                <div className={cls.product}>
                                                    {config.serviceContract.product}
                                                </div>
                                                <div className={cls.category}>
                                                    {config.serviceContract.category}
                                                </div>
                                                <div className={cls.qty}>
                                                    {isEdit ? (
                                                        <TextField
                                                            className={cls.textfiledBottom}
                                                            value={config.serviceContract.qty.toString()}
                                                            onChange={(e) => {
                                                                if (parseInt(e.target.value) === 0) {
                                                                    customerProfiledataTemp.config.serviceContract.qty = 0;
                                                                } else {
                                                                    customerProfiledataTemp.config.serviceContract.qty =
                                                                        parseInt(e.target.value)
                                                                            ? parseInt(e.target.value)
                                                                            : 0;
                                                                }
                                                                setCustomerProfiledataTemp({
                                                                    ...customerProfiledataTemp,
                                                                });
                                                            }}
                                                        />
                                                    ) : (
                                                        config.serviceContract.qty
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/*   OnSite Services Program   */}
                    {checkVisiblityOne(true, config.onSiteServicesProgram) && (
                        <div className={cls.bottomWrapper}>
                            <div className={cls.bottomTitle}>
                                OnSite Services Program
                                <button
                                    className={cls.btnSquare}
                                    onClick={() => {
                                        let tmp = [...isCollapsed];
                                        tmp[32] = !tmp[32];
                                        setIsCollapsed(tmp);
                                    }}
                                >
                                    {isCollapsed[32] ? <DownIcon /> : <UpIcon />}
                                </button>
                            </div>
                            <div className={cls.grayLine} />
                            <div
                                className={`${isCollapsed[32] ? cls.collapsed : ""} ${cls.equipmentBox
                                    }`}
                            >
                                {isEdit && (
                                    <ProductEditBar
                                        products={["onSiteServicesProgram"]}
                                        editInfo={
                                            "Note: We recommend 1 to 2 OnSite specialists per facility."
                                        }
                                    />
                                )}
                                <div className={cls.subContainer}>
                                    <div className={cls.subContainerLeft}>
                                        <div className={cls.imagecontainer}>
                                            <img
                                                src={"/assets/images/onsiteservicesprogram2.png"}
                                                className={cls.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: 20, height: "100%" }}></div>
                                    <div className={cls.subContainerRight}>
                                        <div
                                            className={classNames(cls.subContainerRow, cls.lighttext)}
                                        >
                                            <div className={cls.partNum}>PART NUMBER</div>
                                            <div className={cls.product}>PRODUCT</div>
                                            <div className={cls.category}>CATEGORY</div>
                                            <div className={cls.qty}>QTY</div>
                                        </div>
                                        <div>
                                            <div
                                                className={classNames(
                                                    cls.subContainerRow,
                                                    cls.blackText
                                                )}
                                            >
                                                <div className={cls.partNum}>
                                                    {config.onSiteServicesProgram.partNumber}
                                                </div>
                                                <div className={cls.product}>
                                                    {config.onSiteServicesProgram.product}
                                                </div>
                                                <div className={cls.category}>
                                                    {config.onSiteServicesProgram.category}
                                                </div>
                                                <div className={cls.qty}>
                                                    {isEdit ? (
                                                        <TextField
                                                            className={cls.textfiledBottom}
                                                            value={config.onSiteServicesProgram.qty.toString()}
                                                            onChange={(e) => {
                                                                if (parseInt(e.target.value) === 0) {
                                                                    customerProfiledataTemp.config.onSiteServicesProgram.qty = 0;
                                                                } else {
                                                                    customerProfiledataTemp.config.onSiteServicesProgram.qty =
                                                                        parseInt(e.target.value)
                                                                            ? parseInt(e.target.value)
                                                                            : 0;
                                                                }
                                                                setCustomerProfiledataTemp({
                                                                    ...customerProfiledataTemp,
                                                                });
                                                            }}
                                                        />
                                                    ) : (
                                                        config.onSiteServicesProgram.qty
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
            {tabIndex == 3 && (
                <div>
                    {isEdit ? (
                        <div className={cls.grayBar}>
                            <Button
                                className={cls.savebtn}
                                onClick={() => {
                                    dispatch(
                                        updateCustomerProfileAction(customerProfiledataTemp.id, {
                                            ...customerProfiledataTemp,
                                            config: { ...customerProfiledataTemp.config },
                                        })
                                    );
                                    setisEdit(false);
                                    setCustomerProfiledataTemp({ ...customerProfiledataTemp });
                                }}
                            >
                                <CheckCircleOutlineOutlinedIcon className={cls.saveIcon} />
                                SAVE EDITS
                            </Button>
                            <div style={{ width: 10 }} />
                            <Button
                                className={cls.cancelbtn}
                                onClick={() => {
                                    setisEdit(false);
                                    setCustomerProfiledataTemp({ ...customerProfiledata });
                                }}
                            >
                                <CloseIcon
                                    className={cls.saveIcon}
                                    style={{ color: "white" }}
                                />
                                CANCEL
                            </Button>
                        </div>
                    ) : (
                        <div className={cls.grayBar}>
                            {/* <Button
                square
                className={cls.btnlink}
                onClick={() => {
                  modalCopyLinkControls.handleOpen();
                }}
              >
                <LinkOutlinedIcon className={cls["link-out-icon"]} />
              </Button> */}
                            <Button
                                square
                                className={cls.btnUp}
                                onClick={() => {
                                    modalExportImplantControls.handleOpen();
                                }}
                            >
                                <PublishIcon />
                            </Button>

                            {/* <Button
                square
                className={cls.btnEdit}
                onClick={() => setisEdit(true)}
              >
                <EditOutlinedIcon
                  className={cls["edit-outlined-icon"]}
                  style={{ color: "white" }}
                />
              </Button> */}
                        </div>
                    )}

                    <div className={cls.bottomWrapper}>
                        {config.implantSummary ? (
                            <div className={cls.summaryWrapper}>
                                <ContainerHorizontal className={cls.summaryHeader}>
                                    <div>Notes </div>
                                    <Button
                                        className={cls.editSummaryBtn}
                                        square
                                        onClick={() => {
                                            modalAddImplantSummaryControls.handleOpen();
                                        }}
                                    >
                                        <EditOutlinedIcon className={cls.editSummaryIcon} />
                                    </Button>
                                </ContainerHorizontal>
                                <div className={cls.grayLine}></div>
                                <div className={cls.detailText}>{config.implantSummary}</div>
                            </div>
                        ) : (
                            <Button
                                className={cls.btnAddSummary}
                                onClick={() => {
                                    modalAddImplantSummaryControls.handleOpen();
                                }}
                            >
                                <AddOutlinedIcon className={cls["add-outlined-icon"]} />
                                Add Notes
                            </Button>
                        )}
                    </div>

                    {/*   Implants and disposables */}
                    {config.implants &&
                        config.implants.map((implantGroup, groupIndex) => (
                            <>
                                <div className={classNames(cls.bottomWrapper, cls.implants)}>
                                    <div
                                        className={`${cls.bottomTitle} ${groupIndex == 0
                                            ? cls.first
                                            : groupIndex == 1
                                                ? cls.second
                                                : cls.third
                                            }`}
                                    >
                                        <div>{implantGroup.title}</div>
                                        <button
                                            className={cls.btnSquare}
                                            onClick={() => {
                                                let tmp = [...isCollapsed];
                                                tmp[groupIndex] = !tmp[groupIndex];
                                                setIsCollapsed(tmp);
                                            }}
                                        >
                                            {isCollapsed[groupIndex] ? <DownIcon /> : <UpIcon />}
                                        </button>
                                    </div>
                                    <div className={cls.grayLine} />
                                    <div
                                        className={`${isCollapsed[groupIndex] ? cls.collapsed : ""
                                            } ${cls.equipmentBox}`}
                                    >
                                        {implantGroup.implants.map((implant, implantIndex) => (
                                            <div key={implantIndex}>
                                                <div style={{ height: 10, width: "100%" }} />
                                                <div className={cls.subContainer}>
                                                    <div className={cls.subContainerLeft}>
                                                        <div style={{ fontSize: "12px" }}>
                                                            {implant.subtitle}
                                                        </div>
                                                        <div className={cls.imagecontainer}>
                                                            <img
                                                                src={`/assets/images/ImplantImagery/${implant.imageUrl}`}
                                                                className={cls.image}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ width: 20, height: "100%" }}></div>
                                                    <div className={cls.subContainerRight}>
                                                        <div
                                                            className={classNames(
                                                                cls.subContainerRow,
                                                                cls.lighttext
                                                            )}
                                                        >
                                                            <div
                                                                className={classNames(
                                                                    cls.product,
                                                                    cls["equipment-list__section-title"]
                                                                )}
                                                            >
                                                                PRODUCTS
                                                            </div>

                                                            <div
                                                                className={classNames(
                                                                    cls.qty,
                                                                    cls["equipment-list__section-title"]
                                                                )}
                                                            >
                                                                INCLUDE IN QUOTE
                                                            </div>
                                                        </div>
                                                        {implant.implantProducts.map(
                                                            (item, productIndex) => {
                                                                return (
                                                                    <div
                                                                        className={classNames(
                                                                            cls.subContainerRow,
                                                                            cls.blackText
                                                                        )}
                                                                        key={productIndex}
                                                                    >
                                                                        <div className={cls.product}>
                                                                            {item.productName}
                                                                        </div>
                                                                        <div className={cls.qty}>
                                                                            <Toggle
                                                                                className={cls.toggle}
                                                                                defaultChecked={item.isInQuote}
                                                                                onChange={(e) => {
                                                                                    customerProfiledataTemp.config.implants[
                                                                                        groupIndex
                                                                                    ].implants[
                                                                                        implantIndex
                                                                                    ].implantProducts[
                                                                                        productIndex
                                                                                    ].isInQuote = e.target.checked;
                                                                                    const updateData = {
                                                                                        ...customerProfiledataTemp,
                                                                                        config: {
                                                                                            ...customerProfiledataTemp.config,
                                                                                        },
                                                                                    };
                                                                                    delete updateData["first_name"];
                                                                                    delete updateData["last_name"];
                                                                                    dispatch(
                                                                                        updateCustomerProfileAction(
                                                                                            customerProfiledataTemp.id,
                                                                                            { ...updateData }
                                                                                        )
                                                                                    );
                                                                                    setCustomerProfiledataTemp({
                                                                                        ...customerProfiledataTemp,
                                                                                        config: {
                                                                                            ...customerProfiledataTemp.config,
                                                                                        },
                                                                                    });
                                                                                    console.log(
                                                                                        "Toggle event: ",
                                                                                        e.target.checked
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        ))}
                </div>
            )}
        </ContainerVertical>
    );
};
export default CustomerDetail;
